<template>
  <div style="z-index: 9999;">

    <div class="needGZ_TanWrap tan_needGz_portraitWrap" style="z-index: 9999;" v-if="true && tan_needGZ_single && allData">
      
      <!-- <div class="needGZ_Tan bgF3F4F7 needGZ_One_Tan" style="width: 924px;overflow: hidden;"> -->
      <!-- <div class="needGZ_Tan bgF3F4F7 needGZ_One_Tan" style="width: 924px;overflow: hidden;max-height: none;" v-show="isDomOver"> -->
      <div class="needGZ_Tan bgF3F4F7 needGZ_One_Tan" style="width: 924px;overflow: hidden;max-height: none;" v-show="true">
        <div class="needGZ_Top">
          <div class="time">{{allData.buAndFlName}}</div>
          <div class="chazi" @click="clickClose">X</div>
        </div>


        <!-- <div class="needGZ_Cont portrait_Cont" style="max-height: 730px;overflow: auto;"> -->
        <div class="needGZ_Cont portrait_Cont" :style="{maxHeight: innerHeight + 'px',overflow: 'auto'}">
          <img class="szhxNoBg" src="../../../assets/szhxNo.png" v-if="!allData.isStart"/>
          <img class="szhxNoBg" src="../../../assets/szhxNo1.png" v-if="allData.isStart && allData.breathInfoV2.unSecretsDays && allData.breathInfoV2.unSecretsDays.remainDays == 1"/>
          <img class="szhxNoBg" src="../../../assets/szhxNo2.png" v-if="allData.isStart && allData.breathInfoV2.unSecretsDays && allData.breathInfoV2.unSecretsDays.remainDays == 2"/>
          <div v-if="allData.isStart && allData.breathInfoV2.clickFlag == 3">
            <div class="portrait_topWrap" v-if="!allData.breathInfoV2.unSecretsDays">
              <img class="szhxNo3_1" src="../../../assets/icon_dean_home_alert_icon_8.png"/>
              <img class="szhxNo3_2" src="../../../assets/icon_dean_home_alert_icon_9.png"/>
              <div>&nbsp;</div>
              <div class="hx_overview1" v-html="$options.filters.reMate(allData.summarize)"></div>
              <!-- <div class="hx_overview">
                芬达发大水发发生
                <div class="bot_adv_tag">
                  <img class="tanhaoIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png"/>
                  <span>哈哈</span>
                </div>
                <div class="bot_adv_tag">
                  <img class="tanhaoIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png"/>
                  <span>哈发建档立卡减肥的哈</span>
                </div>
                <div class="bot_adv_tag">
                  <img class="tanhaoIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png"/>
                  <span>哈发建档立卡减肥的哈</span>
                </div>
                芬达发大水发发生芬达发大水发发生芬达发大水发发生
                <div class="bot_adv_tag">
                  <img class="tanhaoIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png"/>
                  <span>哈发建档立卡减肥的哈</span>
                </div>
              </div> -->
              <img class="szhxNo3_3" src="../../../assets/icon_dean_home_alert_icon_10.png"/>
            </div>
            <!-- 发现几项值得关注的变化 -->
            <div class="gzVaryWrap" v-if="allData.changeNum">
              <img class="gBellImg" src="../../../assets/ai_icon_news_d@2x.png" alt="">
              <div class="name">发现</div>
              <div class="name colorFF7186" style="font-weight: bold;">{{  allData.changeNum }}</div>
              <div class="name">项值得关注的变化</div>
            </div>
            <div class="needGZ_OneListWrap">
              <!-- 呼吸情况 -->
              <div class="needGZ_OneList" v-if="true">
                <!-- 未揭秘的进度条 -->
                <div class="needGZ_OneListNoJm" v-if="allData.breathInfoV2.unSecretsDays">
                  <div class="noJm_speed" :style="{width: allData.breathInfoV2.unSecretsDays.accDays/allData.breathInfoV2.unSecretsDays.totalDays + '%'}"></div>
                </div>
                <!-- 上方内容 -->
                <div class="portrait_OneList_topWrap" @click="hxqk_isExpand = !hxqk_isExpand">
                  <div class="portrait_OneList_top">
                    <div class="szhx_IconWrap">
                      <img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_11.png" alt="">
                    </div>
                    <div class="szhx_nameNum" v-if="allData.breathInfoV2.changeNum">
                      <div class="num">{{ allData.breathInfoV2.changeNum }}</div>
                    </div>
                    <div class="flex_Cen_Cen" v-if="allData.breathInfoV2.hasOccurPrfList">
                      <div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.breathInfoV2.hasOccurPrfList">
                        <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
                        <div class="fList fListRed" v-if="item.isNew && item.isWarn">
						  <img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
                          {{ item.realValue }}
                        </div>
                      </div>
                    </div>
                    
                    <div class="flex mlAuto" v-if="allData.breathInfoV2.unSecretsDays">
                      <div>再有</div>
                      <div class="color1890ff">{{ allData.breathInfoV2.unSecretsDays.remainDays }}</div>
                      <div>晚揭秘</div>
                    </div>
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!allData.breathInfoV2.unSecretsDays && !hxqk_isExpand">
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="!allData.breathInfoV2.unSecretsDays && hxqk_isExpand">
                  </div>
                </div>
                <!-- 弹窗展开内容 -->
                <div class="oneExpandCont" v-show="!allData.breathInfoV2.unSecretsDays && hxqk_isExpand">
                  <!-- 昨晚是否有值得关注的变化 -->
                  <tan_needGz_portrait_isHaveChange v-if="allData.breathInfoV2.deviateTheDay" :haveChangeData="allData.breathInfoV2.deviateTheDay"></tan_needGz_portrait_isHaveChange>
                  <!-- 呼吸率分布如下图 -->
                  <div class="txjyWrap border_no mt10">
                    <!-- <div class="txjyTit txjyTit_after_blue" style="">呼吸率分布</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为呼吸率(次/分)</div>
                      </div>
                    </div>
                    <div id="ech_breathOne" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.breathInfoV2.secretsBreath">{{ allData.breathInfoV2.secretsBreath.descLabel }}</div> -->
                  
					<div style="display: flex; justify-content: space-between;">
						<div class="txjyTit txjyTit_after_blue" style="">每晚呼吸率</div>
						<div style="display: flex; margin-top: 5px; align-items: center; cursor: pointer;" @click="clickSetAlarm">
                            <img style="width: 73px; height: 12px; margin-right: 5px;" src="../../../assets/icon_home_new_icon_chang_tiao_fang_ge.png" alt="" />
                            <div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #4A7CE8; line-height: 20px;">呼吸过速报警阈值设置</div>
                            <img style="width: 16px; height: 16px; " src="../../../assets/icon_home_new_icon_jian_tou_lan.png" alt="" />
                        </div>
					</div>

					<div v-if="allData.breathInfoV2.secretsBreath.brPdfFlag == 1 && !isHaveHxl" style="height: 177px; display: flex; align-items: center; flex-direction: column;">
						<img src="../../../assets/icon_home_new_icon_empty_10.png" alt="" style="width: 107px; height: 107px; margin-top: 15px;">
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #A4ABB6; line-height: 20px; margin-top: 15px;">最近30天暂无数据</div>
					</div>

                    <!-- <div id="ech_breathOne" style="height: 150px;"></div> -->
					<div id="ech_breathOne" v-if="allData.breathInfoV2.secretsBreath.brPdfFlag == 1 && isHaveHxl" style="height: 150px;"></div>
					
                    <div class="refer_comTit mt15" v-if="allData.breathInfoV2.secretsBreath && allData.breathInfoV2.secretsBreath.brPdfFlag == 1 && isHaveHxl">{{ allData.breathInfoV2.secretsBreath.descLabel }}</div>

					<ContentCardBasePortraitE v-if="allData.breathInfoV2.secretsBreath.brPdfFlag == 0"  :echartId="'ContentCardBasePortraitE'" :data="allData.breathInfoV2.secretsBreath" :type="0" :isFold="true"></ContentCardBasePortraitE>

					<!-- 是否发生偏离 -->
                    <!-- <tan_needGz_portrait_botZheCont v-if="allData.breathInfoV2.secretsBreathDeviate" :haveChangeData="allData.breathInfoV2.secretsBreathDeviate"></tan_needGz_portrait_botZheCont> -->

				  </div>
                  <!-- <div style="height:200px;background: red;;"></div> -->
                  <!-- 吸呼比分布 -->
                  <div class="txjyWrap border_no mt10">
                    <div class="txjyTit txjyTit_after_blue mt15" style="">吸呼比分布</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为吸呼比</div>
                      </div>
                    </div>
                    <div id="ech_breathTwo" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if="allData.breathInfoV2.secretsInExRatio">{{ allData.breathInfoV2.secretsInExRatio.descLabel }}</div>

                    <!-- 是否发生偏离 -->
                    <tan_needGz_portrait_botZheCont v-if="allData.breathInfoV2.secretsInExRatioDeviate" :haveChangeData="allData.breathInfoV2.secretsInExRatioDeviate"></tan_needGz_portrait_botZheCont>

                  </div>
                  
                  <!-- 最下面的提醒建议 -->
                  <tan_needGz_portrait_botAdvise :haveChangeData="allData.breathInfoV2.conclusionRecommend"></tan_needGz_portrait_botAdvise>
                

                  
                </div>
              </div>

              <!-- 体动情况 -->
              <div class="needGZ_OneList" v-if="true">
                <!-- 未揭秘的进度条 -->
                <div class="needGZ_OneListNoJm" v-if="allData.bodyMoveInfo.unSecretsDays">
                  <div class="noJm_speed" :style="{width: allData.bodyMoveInfo.unSecretsDays.accDays/allData.bodyMoveInfo.unSecretsDays.totalDays + '%'}"></div>
                </div>
                <!-- 上方内容 -->
                <div class="portrait_OneList_topWrap" @click="tdqk_isExpand = !tdqk_isExpand">
                  <div class="portrait_OneList_top">
                    <div class="szhx_IconWrap">
                      <img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_12.png" alt="">
                    </div>
                    <div class="szhx_nameNum" v-if="allData.bodyMoveInfo.changeNum">
                      <div class="num">{{ allData.bodyMoveInfo.changeNum }}</div>
                    </div>
                    <div class="flex_Cen_Cen" v-if="allData.bodyMoveInfo.hasOccurPrfList">
                      <div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.bodyMoveInfo.hasOccurPrfList">
                        <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
                        <div class="fList fListRed" v-if="item.isNew && item.isWarn">
                          <img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
                          {{ item.realValue }}
                        </div>
                      </div>
                    </div>

                    <div class="flex mlAuto" v-if="allData.bodyMoveInfo.unSecretsDays">
                      <div>再有</div>
                      <div class="color1890ff">{{ allData.bodyMoveInfo.unSecretsDays.remainDays }}</div>
                      <div>晚揭秘</div>
                    </div>
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!allData.bodyMoveInfo.unSecretsDays && !tdqk_isExpand">
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="!allData.bodyMoveInfo.unSecretsDays && tdqk_isExpand">
                  </div>
                </div>
                <!-- 弹窗展开内容 -->
                <div class="oneExpandCont" v-show="!allData.bodyMoveInfo.unSecretsDays && tdqk_isExpand">
                  <!-- 昨晚是否有值得关注的变化 -->
                  <tan_needGz_portrait_isHaveChange v-if="allData.bodyMoveInfo.deviateTheDay" :haveChangeData="allData.bodyMoveInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
                  
                  <!-- 体动指数分布 -->
                  <div class="txjyWrap border_no mt10">
                    <div class="txjyTit txjyTit_after_blue" style="">体动指数分布</div>
                    <div class="referVal">
                      <div class="referValLeft">
                        <div class="gangKuai2_border"></div>
                        <div class="gantTip">参考范围</div>
                      </div>
                      <div class="referValRight">
                        <div class="gantTip">横轴为体动指数</div>
                      </div>
                    </div>
                    <div id="ech_tdOne" style="height: 150px;"></div>
                    <div class="refer_comTit mt15" v-if=allData.bodyMoveInfo.secretsBodyMoveIndex>{{ allData.bodyMoveInfo.secretsBodyMoveIndex.descLabel }}</div>

                  </div>
                  <!-- 体动指数分布统计_折线 -->
                  <div class="txjyWrap border_no mt10">
                    <div>
                      <div class="txjyTit txjyTit_after_blue" style="">每晚体动指数</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">日常表现</div>
                        </div>
                      </div>
                      <div id="ech_td_line" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.bodyMoveInfo.secretsBodyMoveIndexDay">{{ allData.bodyMoveInfo.secretsBodyMoveIndexDay.descLabel }}</div>

                      <!-- 是否发生偏离 -->
                      <tan_needGz_portrait_botZheCont v-if="allData.bodyMoveInfo.secretsBodyMoveIndexDayDeviate" :haveChangeData="allData.bodyMoveInfo.secretsBodyMoveIndexDayDeviate"></tan_needGz_portrait_botZheCont>
                    </div>
                  </div>
                  
                  <!-- 最下面的提醒建议 -->
                  <tan_needGz_portrait_botAdvise :haveChangeData="allData.bodyMoveInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>
                  

                  
                </div>
              </div>

              <!-- 心跳情况 -->
              <div class="needGZ_OneList" v-if="false">
                <!-- 未揭秘的进度条 -->
                <div class="needGZ_OneListNoJm" v-if="allData.heartInfo.unSecretsDays">
                  <div class="noJm_speed" :style="{width: allData.heartInfo.unSecretsDays.accDays/allData.heartInfo.unSecretsDays.totalDays + '%'}"></div>
                </div>
                <!-- 上方内容 -->
                <div class="portrait_OneList_topWrap" @click="xtqk_isExpand = !xtqk_isExpand">
                  <div class="portrait_OneList_top">
                    <div class="szhx_IconWrap">
                      <img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_13.png" alt="">
                    </div>
                    <div class="szhx_nameNum" v-if="allData.heartInfo.changeNum">
                      <div class="num">{{ allData.heartInfo.changeNum }}</div>
                    </div>
                    <div class="flex_Cen_Cen" v-if="allData.heartInfo.hasOccurPrfList">
                      <div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.heartInfo.hasOccurPrfList">
                        <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
                        <div class="fList fListRed" v-if="item.isNew && item.isWarn">
                          <img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
                          {{ item.realValue }}
                        </div>
                      </div>
                    </div>
                    <div class="flex mlAuto" v-if="allData.heartInfo.unSecretsDays">
                      <div>再有</div>
                      <div class="color1890ff">{{ allData.heartInfo.unSecretsDays.remainDays }}</div>
                      <div>晚揭秘</div>
                    </div>
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!xtqk_isExpand && !allData.heartInfo.unSecretsDays">
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="xtqk_isExpand && !allData.heartInfo.unSecretsDays">
                  </div>
                </div>
                <!-- 弹窗展开内容 -->
                <div class="oneExpandCont" v-show="!allData.heartInfo.unSecretsDays && xtqk_isExpand">
                  <!-- 昨晚是否有值得关注的变化 -->
                  <tan_needGz_portrait_isHaveChange v-if="allData.heartInfo.deviateTheDay" :haveChangeData="allData.heartInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
                  <!-- 心率分布 -->
                  <div class="txjyWrap border_no mt10">
                    <div>
                      <div class="txjyTit txjyTit_after_blue" style="">心率分布</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">参考范围</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">横轴为心率(次/分)</div>
                        </div>
                      </div>
                      <div id="ech_heartOne" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.heartInfo.secretsHeart">{{ allData.heartInfo.secretsHeart.descLabel }}</div>

                      <!-- 是否发生偏离 -->
                      <tan_needGz_portrait_botZheCont v-if="allData.heartInfo.secretsHeartDeviate" :haveChangeData="allData.heartInfo.secretsHeartDeviate"></tan_needGz_portrait_botZheCont>
                    </div>
                  </div>

                  <!-- 最下面的提醒建议 -->
                  <tan_needGz_portrait_botAdvise :haveChangeData="allData.heartInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>

                  
                </div>
              </div>

              <!-- 作息规律 -->
              <div class="needGZ_OneList" v-if="true">
                <!-- 未揭秘的进度条 -->
                <div class="needGZ_OneListNoJm" v-if="allData.dailyRoutineInfo.unSecretsDays">
                  <div class="noJm_speed" :style="{width: allData.dailyRoutineInfo.unSecretsDays.accDays/allData.dailyRoutineInfo.unSecretsDays.totalDays + '%'}"></div>
                </div>
                <!-- 上方内容 -->
                <div class="portrait_OneList_topWrap" @click="zxgl_isExpand = !zxgl_isExpand">
                  <div class="portrait_OneList_top">
                    <div class="szhx_IconWrap">
                      <img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_14.png" alt="">
                    </div>
                    <div class="szhx_nameNum" v-if="allData.dailyRoutineInfo.changeNum">
                      <div class="num">{{ allData.dailyRoutineInfo.changeNum }}</div>
                    </div>
                    <div class="flex_Cen_Cen" v-if="allData.dailyRoutineInfo.hasOccurPrfList">
                      <div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.dailyRoutineInfo.hasOccurPrfList">
                        <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
                        <div class="fList fListRed" v-if="item.isNew && item.isWarn">
                          <img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
                          {{ item.realValue }}
                        </div>
                      </div>
                    </div>
                    <div class="flex mlAuto" v-if="allData.dailyRoutineInfo.unSecretsDays">
                      <div>再有</div>
                      <div class="color1890ff">{{ allData.dailyRoutineInfo.unSecretsDays.remainDays }}</div>
                      <div>晚揭秘</div>
                    </div>
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!zxgl_isExpand && !allData.dailyRoutineInfo.unSecretsDays">
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="zxgl_isExpand && !allData.dailyRoutineInfo.unSecretsDays">
                  </div>
                </div>
                <!-- 弹窗展开内容 -->
                <div class="oneExpandCont" v-show="!allData.dailyRoutineInfo.unSecretsDays && zxgl_isExpand">
                  <!-- 昨晚是否有值得关注的变化 -->
                  <tan_needGz_portrait_isHaveChange v-if="allData.dailyRoutineInfo.deviateTheDay" :haveChangeData="allData.dailyRoutineInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
                  <!-- 上床入睡醒来起床 -->
                  <div class="txjyWrap border_no mt10">
                    <div>
                      <div class="txjyTit txjyTit_after_blue" style="">上床、入睡、醒来、起床时间点分布</div>
                      <!-- <div class="lcscSinWrap">
                        <div class="name">离床时长（分钟）</div>
                        <img class="boxBg mt5" src="../../../assets/report_pic_color_d@2x.png" alt="">
                        <div class="boxBgData">
                          <div class="bNum" :key="index" v-for="(item,index) in 11">{{index}}</div>
                        </div>
                      </div> -->
                      <div class="referVal referValTimeSingle">
                        <div class="referValLeft">
                          <div class="gantTip">19:30</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">08:30</div>
                        </div>
                      </div>
                      <div id="id_echSanDian_wrap" style="height: 300px;overflow: auto;" v-if="allData && allData.dailyRoutineInfo && allData.dailyRoutineInfo.secretsDailyRoutine">
                        <div id="echSanDian" :style="{height:allData.dailyRoutineInfo.secretsDailyRoutine.data.length*42 + 'px'}"></div>
                      </div>

                      <!-- 作息规律显示这个 -->
                      <div v-if="allData.dailyRoutineInfo.secretsDailyRoutine">
                        <div class="zxSanWrap mt10">
                          <div class="zxSanList">上床</div>
                          <div class="zxSanList">入睡</div>
                          <div class="zxSanList">醒来</div>
                          <div class="zxSanList">起床</div>
                        </div>
                        <div class="zxSanBotCont mt20">
                          <div class="zxSanBotListWrap mb10" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.isShow_highFreTime2">
                            <div class="zxSanBotList">
                              <div class="flex_Cen_Cen pt15">
                                <div class="zxBoxBlock"></div>
                                <div class="zxBoxName ml5">上床时间高频范围</div>
                              </div>
                              <div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedEd }}</div>
                              <div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedSt">暂无</div>
                            </div>
                            <div class="zxSanBotList">
                              <div class="flex_Cen_Cen pt15">
                                <div class="zxBoxBlock bgFFEAD4"></div>
                                <div class="zxBoxName ml5">入睡时间高频范围</div>
                              </div>
                              <div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStEd }}</div>
                              <div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStSt">暂无</div>
                            </div>
                            <div class="zxSanBotList">
                              <div class="flex_Cen_Cen pt15">
                                <div class="zxBoxBlock bgC6F3E9"></div>
                                <div class="zxBoxName ml5">醒来时间高频范围</div>
                              </div>
                              <div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdEd }}</div>
                              <div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdSt">暂无</div>
                            </div>
                            <div class="zxSanBotList">
                              <div class="flex_Cen_Cen pt15">
                                <div class="zxBoxBlock bgB9DDFF"></div>
                                <div class="zxBoxName ml5">起床时间高频范围</div>
                              </div>
                              <div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedEd }}</div>
                              <div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedSt">暂无</div>
                            </div>
                          </div>
                          <div class='' v-if="allData.dailyRoutineInfo.secretsDailyRoutine">{{ allData.dailyRoutineInfo.secretsDailyRoutine.descLabel }}</div>
                        </div>
                      </div>

                      <!-- 夜间离床显示这个 -->
                      <!-- <div>
                        <div class="lcTimeTip mt10">
                          <div class="lcTimeKuang"></div>
                          <div class="lcTimeFont ml5">离床时间高频范围</div>
                        </div>
                        <div class="refer_comTit mt15" style="height: 66px;line-height: 22px;">
                          <div>·通常会在01:12～02:13，05:18～05:58离床；·</div>
                          <div class="flex">
                            <div>·</div>
                            <div class="colorFF7186">01:12～02:13</div>
                            <div>这个时间段发生的离床是值得注意的。·</div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <!-- 入睡时长分布、统计如下图 -->
                  <div class="txjyWrap border_no mt10">
                    <!-- 入睡时长分布 -->
                    <div>
                      <div class="txjyTit txjyTit_after_blue" style="">入睡时长分布</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">参考范围</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">横轴为入睡时长(分钟)</div>
                        </div>
                      </div>
                      <div id="ech_sleepOne" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsSleep">{{ allData.dailyRoutineInfo.secretsSleep.descLabel }}</div>
                    </div>
                    <!-- 入睡时长统计 -->
                    <div>
                      <div class="txjyTit txjyTit_after_blue mt15" style="">每晚入睡时长</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">日常表现</div>
                        </div>
                      </div>
                      <div id="ech_sleepTwo" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsSleepDay">{{ allData.dailyRoutineInfo.secretsSleepDay.descLabel }}</div>

                      <!-- 是否发生偏离 -->
                      <tan_needGz_portrait_botZheCont v-if="allData.dailyRoutineInfo.secretsSleepDayDeviate" :haveChangeData="allData.dailyRoutineInfo.secretsSleepDayDeviate"></tan_needGz_portrait_botZheCont>
                    </div>
                  </div>
                  <!-- 起床时长分布、统计如下图 -->
                  <div class="txjyWrap border_no mt10">
                    <!-- 起床时长分布 -->
                    <div>
                      <div class="txjyTit txjyTit_after_blue" style="">起床时长分布</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">参考范围</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">横轴为起床时长(分钟)</div>
                        </div>
                      </div>
                      <div id="ech_getUpOne" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsBed">{{ allData.dailyRoutineInfo.secretsBed.descLabel }}</div>
                    </div>
                    <!-- 起床时长统计 -->
                    <div>
                      <div class="txjyTit txjyTit_after_blue mt15" style="">每晚起床时长</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">日常表现</div>
                        </div>
                      </div>
                      <div id="ech_getUpTwo" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsBed">{{ allData.dailyRoutineInfo.secretsBedDay.descLabel }}</div>

                      <!-- 是否发生偏离 -->
                      <tan_needGz_portrait_botZheCont v-if="allData.dailyRoutineInfo.secretsBedDayDeviate" :haveChangeData="allData.dailyRoutineInfo.secretsBedDayDeviate"></tan_needGz_portrait_botZheCont>
                    </div>
                  </div>
                  
                  <!-- 最下面的提醒建议 -->
                  <tan_needGz_portrait_botAdvise :haveChangeData="allData.dailyRoutineInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>

                  
                </div>
              </div>

              <!-- 夜间离床 -->
              <div class="needGZ_OneList" v-if="true">
                <!-- 未揭秘的进度条 -->
                <div class="needGZ_OneListNoJm" v-if="allData.leaveBedInfoV2.unSecretsDays">
                  <div class="noJm_speed" :style="{width: allData.leaveBedInfoV2.unSecretsDays.accDays/allData.leaveBedInfoV2.unSecretsDays.totalDays + '%'}"></div>
                </div>
                <!-- 上方内容 -->
                <div class="portrait_OneList_topWrap" @click="yjlcUnfold">
                  <div class="portrait_OneList_top">
                    <div class="szhx_IconWrap">
                      <img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_15.png" alt="">
                    </div>
                    <div class="szhx_nameNum" v-if="allData.leaveBedInfoV2.changeNum">
                      <div class="num">{{ allData.leaveBedInfoV2.changeNum }}</div>
                    </div>
                    <div class="flex_Cen_Cen" v-if="allData.leaveBedInfoV2.hasOccurPrfList">
                      <div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.leaveBedInfoV2.hasOccurPrfList">
                        <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
                        <div class="fList fListRed" v-if="item.isNew && item.isWarn">
                          <img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
                          {{ item.realValue }}
                        </div>
                      </div>
                    </div>
                    <div class="flex mlAuto" v-if="allData.leaveBedInfoV2.unSecretsDays">
                      <div>再有</div>
                      <div class="color1890ff">{{ allData.leaveBedInfoV2.unSecretsDays.remainDays }}</div>
                      <div>晚揭秘</div>
                    </div>
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!yjlc_isExpand && !allData.leaveBedInfoV2.unSecretsDays">
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="yjlc_isExpand && !allData.leaveBedInfoV2.unSecretsDays">
                  </div>
                </div>
                <!-- 弹窗展开内容 -->
                <div class="oneExpandCont" v-show="!allData.leaveBedInfoV2.unSecretsDays && yjlc_isExpand">
                  <!-- 昨晚是否有值得关注的变化 -->
                  <tan_needGz_portrait_isHaveChange v-if="allData.leaveBedInfoV2.deviateTheDay" :haveChangeData="allData.leaveBedInfoV2.deviateTheDay"></tan_needGz_portrait_isHaveChange>
                  <!-- 离床次数分布、统计如下图 -->
                  <div class="txjyWrap border_no mt10">
					<!-- 每晚睡眠间离床情况 -->
                    <div style="margin-bottom: 0px;">
                      <div class="txjyTit txjyTit_after_blue" style="">每晚睡眠间离床情况</div>
					  <div style="display: flex; margin-top: 10px;">
							<div style="display: flex; flex-direction: column; flex: 1;">
								<div style="height: 70px; background: #F3F4F7; border-radius: 4px; display: flex;">
									<div  v-if="leaveLeftData && leaveLeftData.data && leaveLeftData.data[leaveSelectIndex] && leaveLeftData.data[leaveSelectIndex].extendData" style="width: 6px; height: 6px; background: rgba(255, 113, 134, 1); border-radius: 5px; margin-top: 22px; margin-left: 15px;" :style="{ background: leaveLeftData.data[leaveSelectIndex].extendData.deviateFlag == 1 ? 'rgba(255, 113, 134, 1)' : (leaveLeftData.data[leaveSelectIndex].extendData.deviateFlag == 2 ? 'rgba(74, 124, 232, 1)' : 'rgba(165, 169, 188, 1)') }"></div>
									<div style="margin-left: 5px; margin-right: 15px; margin-top: 15px; flex: 1;">
										<div v-if="leaveLeftData && leaveLeftData.data && leaveLeftData.data[leaveSelectIndex] && leaveLeftData.data[leaveSelectIndex].extendData" v-html="$options.filters.reMate((leaveLeftData.data[leaveSelectIndex].extendData.date + '：' + leaveLeftData.data[leaveSelectIndex].extendData.deviateDescLabel) || '')"></div>
									</div>
								</div>
								<div style="height: 457px; display: flex; flex-direction: column; position: relative;">
									<div style="position: absolute; left: 0px; right: 0px; top: 10px; height: 102px; border-radius: 4px; border: 1px solid #E4E5EA;  pointer-events: none; z-index: 1;"></div>
									<div style="position: absolute; left: 0px; right: 0px; top: 144px; height: 313px; border-radius: 4px; border: 1px solid #E4E5EA;  pointer-events: none; z-index: 1;"></div>
									<div style="position: absolute; background: rgba(243, 244, 247, 1); width: 17px; top: 11px; bottom: 1px; left: 150px; z-index: 0;  pointer-events: none;" :style="{ left: leaveSingleWidth * leaveSelectIndex + 'px', width: leaveSingleWidth + 'px' }"></div>
									<div v-if="leaveHoverindex != undefined" style="border-left: 1px dashed rgba(164, 189, 243, 1); text-align: center; position: absolute; top: 11px; height: 101px; width: 1px; z-index: 10;  pointer-events: none;" :style="{ left: leaveSingleWidth * leaveHoverindex + (leaveSingleWidth / 2.0) + 'px' }"></div>
									<div v-if="leaveHoverindex != undefined" style="border-left: 1px dashed rgba(164, 189, 243, 1); text-align: center; position: absolute; top: 144px; bottom: 2px; width: 1px; z-index: 10;  pointer-events: none;" :style="{ left: leaveSingleWidth * leaveHoverindex + (leaveSingleWidth / 2.0) + 'px' }"></div>
									<div style="height: 10px; position: relative;  pointer-events: none;">
										<div style="width: 19px; height: 10px; position: absolute; left: 100px; top: 0px; display: flex;" :style="{ left: leaveSingleWidth * leaveSelectIndex + ((leaveSingleWidth - 19) / 2.0) + 'px' }">
											<img style="width: 19px; height: 10px;" src="../../../assets/icon_portrait_arrow_2.png" alt="" />
										</div>
									</div>
									<div style="position: absolute; top: 150px; bottom: 0px; z-index: 1; pointer-events: none;" :style="{ width: leaveSingleWidth + 'px', left: leaveSingleWidth * leaveSelectIndex + 'px'} ">
										<div  v-for="(item, index) in leaveWranningTips || []" style="position: absolute;" :style="{ left: leaveSelectIndex <= 15 ?  leaveSingleWidth + 'px' : 'unset', right: leaveSelectIndex > 15 ? leaveSingleWidth + 'px' : 'unset', top: item.top }">
											<div style="display: flex; align-items: center;">
												<img v-if="leaveSelectIndex <= 15"  style="width: 6px; height: 10px; margin-right: -1px; z-index: 1;" src="../../../assets/icon_portrait_tip_alert_arrow_left.png" alt="">
												<div style="background: rgba(254,228,228,0.5); border: 1px solid rgba(255,113,134,0.3); display: flex; align-items: center;  padding: 10px; border-radius: 5px; z-index: 0;">
													<div style="width: 6px; height: 6px; background: rgba(255, 113, 134, 1); border-radius: 3px; margin-right: 5px;"></div>
													<!-- <div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #5E6779; line-height: 20px; white-space: nowrap">{{ item.floatingWinTips }}</div> -->
													<div style="white-space: nowrap" v-html="$options.filters.reMate(item.floatingWinTips || '')"></div>
												</div>
												<img v-if="leaveSelectIndex > 15" style="width: 6px; height: 10px; margin-left: -1px; z-index: 1;" src="../../../assets/icon_portrait_tip_alert_arrow_right.png" alt="">
											</div>
										</div>
									</div>
									<div style="height: 102px; border-radius: 4px; display: flex;">
										<div style="height: 102px; width: 100%;">
											<div id="echartsLeaveBedTop1" style="height: 102px;"></div>
										</div>
									</div>
									<div style="height: 32px; display: flex; z-index: 1">
										<div v-for="(item, index) in leaveLeftData && leaveLeftData.xaxis ? leaveLeftData.xaxis : []" style="flex: 1; display: flex; justify-content: center; align-items: center; font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 10px; color: #A5A9BC; line-height: 14px; cursor: pointer;" @click="leaveChangeDateClick(index)">
											<div style="width: 16px; height: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 10px; color: #A5A9BC; line-height: 14px; display: flex; justify-content: center; align-items: center; border-radius: 8px;" :style="{ color: leaveSelectIndex == index ? '#FFFFFF' : leaveHoverindex == index ? 'rgba(94, 103, 121, 1)' : 'rgba(165, 169, 188, 1)', fontSize: (leaveSelectIndex == index || leaveHoverindex == index) ? '600' : '400', background: leaveSelectIndex == index ? '#5E6779' : '#FFFFFF00' }">{{ item }}</div>
										</div>
									</div>
									<div style="height: 313px; border-radius: 4px;">
										<div style="height: 313px;">
											<div id="echartsLeaveBedBottom1" style="height: 313px;"></div>
										</div>
									</div>
									
								</div>
							</div>
							<div v-if="leaveIsShowRightCharts"  style="width: 230px; margin-left: 10px; display: flex; flex-direction: column;">
								<div v-if="leaveRightData && !leaveRightData.normalCntWarn" style="background: #F6F9FF; border-radius: 4px; border: 1px solid #E4ECFD; position: relative; height: 86px;">
									<div style="display: flex; margin-left: 15px; margin-top: 6px;">
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(131, 148, 185, 0.7); line-height: 17px; margin-top: 9px;">日常每晚离床：</div>
										<div style="font-family: DINAlternate-Bold,DINAlternate; font-weight: 400; font-size: 24px; color: #8394B9; line-height: 28px;">{{ leaveRightData.normalCnt }}</div>
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(131, 148, 185, 0.7); line-height: 17px; margin-top: 9px;">次左右</div>
									</div>
									<div style="display: flex; background: rgba(131, 148, 185, 0.1); align-items: center; margin-left: 15px; margin-top: 3px; margin-bottom: 15px; margin-right: 15px;">
										<div style="width: 4px; height: 34px; background: rgba(131, 148, 185, 0.5); margin-right: 6px;"></div>
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #8394B9; line-height: 20px;">{{ leaveRightData.normalCntCon }}</div>
									</div>
									<div style="position: absolute; left: 3px; bottom: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
									<div style="position: absolute; right: 3px; bottom: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
								</div>
								<div v-if="leaveRightData && leaveRightData.normalCntWarn" style="background: #FFF8FB; border-radius: 4px; border: 1px solid #FED3D9; position: relative; height: 86px;">
									<div style="display: flex; margin-left: 15px; margin-top: 6px;">
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(255, 113, 134, 0.7); line-height: 17px; margin-top: 9px;">日常每晚离床：</div>
										<div style="font-family: DINAlternate-Bold,DINAlternate; font-weight: 400; font-size: 24px; color: rgba(255, 113, 134, 1); line-height: 28px;">{{ leaveRightData.normalCnt }}</div>
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(255, 113, 134, 0.7); line-height: 17px; margin-top: 9px;">次左右</div>
									</div>
									<div style="display: flex; background: rgba(255, 209, 215, 0.3); align-items: center; margin-left: 15px; margin-top: 3px; margin-bottom: 15px; border: 1px solid rgba(255, 184, 195, 0.3); margin-right: 15px;">
										<div style="width: 4px; height: 34px; background: rgba(255, 113, 134, 0.5); margin-right: 6px;"></div>
										<img style="width: 14px; height: 14px; margin-right: 5px;" src="../../../assets/icon_portrait_wranning_1.png" alt="">
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(94, 103, 121, 1); line-height: 20px;">{{ leaveRightData.normalCntCon }}</div>
									</div>
									<div style="position: absolute; left: 3px; bottom: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
									<div style="position: absolute; right: 3px; bottom: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
								</div>
								<div style="display: flex; justify-content: space-between; padding-top: 1px; padding-bottom: 1px; padding-left: 6px; padding-right: 6px;">
									<div style="width: 2px; height: 8px; background: rgba(131, 148, 185, 0.3)"></div>
									<div style="width: 2px; height: 8px; background: rgba(131, 148, 185, 0.3)"></div>
								</div>
								<div v-if="leaveRightData && !leaveRightData.normalDurationWarn" style="background: #F6F9FF; border-radius: 4px; border: 1px solid #E4ECFD; position: relative; height: 86px;">
									<div style="display: flex; margin-left: 15px; margin-top: 6px;">
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(131, 148, 185, 0.7); line-height: 17px; margin-top: 9px;">日常每次离床：</div>
										<div style="font-family: DINAlternate-Bold,DINAlternate; font-weight: 400; font-size: 24px; color: #8394B9; line-height: 28px;">{{ leaveRightData.normalDuration }}</div>
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(131, 148, 185, 0.7); line-height: 17px; margin-top: 9px;">分钟左右</div>
									</div>
									<div style="display: flex; background: rgba(131, 148, 185, 0.1); align-items: center; margin-left: 15px; margin-top: 3px; margin-bottom: 15px; margin-right: 15px;">
										<div style="width: 4px; height: 34px; background: rgba(131, 148, 185, 0.5); margin-right: 6px;"></div>
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #8394B9; line-height: 20px;">{{ leaveRightData.normalDurationCon }}</div>
									</div>
									<div style="position: absolute; left: 3px; top: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
									<div style="position: absolute; right: 3px; top: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
								</div>
								<div v-if="leaveRightData && leaveRightData.normalDurationWarn" style="background: #FFF8FB; border-radius: 4px; border: 1px solid #FED3D9; position: relative; height: 86px;">
									<div style="display: flex; margin-left: 15px; margin-top: 6px;">
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(255, 113, 134, 0.7); line-height: 17px; margin-top: 9px;">日常每次离床：</div>
										<div style="font-family: DINAlternate-Bold,DINAlternate; font-weight: 400; font-size: 24px; color: rgba(255, 113, 134, 1); line-height: 28px;">{{ leaveRightData.normalDuration }}</div>
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(255, 113, 134, 0.7); line-height: 17px; margin-top: 9px;">分钟左右</div>
									</div>
									<div style="display: flex; background: rgba(255, 209, 215, 0.3); align-items: center; margin-left: 15px; margin-top: 3px; margin-bottom: 15px; border: 1px solid rgba(255, 184, 195, 0.3); margin-right: 15px;">
										<div style="width: 4px; height: 34px; background: rgba(255, 113, 134, 0.5); margin-right: 6px;"></div>
										<img style="width: 14px; height: 14px; margin-right: 5px;" src="../../../assets/icon_portrait_wranning_1.png" alt="">
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(94, 103, 121, 1); line-height: 20px;">{{ leaveRightData.normalDurationCon }}</div>
									</div>
									<div style="position: absolute; left: 3px; top: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
									<div style="position: absolute; right: 3px; top: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
								</div>
								<div style="display: flex; align-items: center; margin-top: 10px; margin-bottom: 5px;">
									<img style="width: 10px; height: 8px; margin-left: 38px; margin-right: 6px;" src="../../../assets/icon_portrait_arrow_1.png" alt="">
									<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: #5E6779; line-height: 17px;">最近30天每小时离床情况</div>
								</div>
								<div style="height: 313px; position: relative; display: flex;">
									<div style="position: absolute; left: 34px; right: 0px; top: 0px; bottom: 0px; border: 1px solid #FFFFFF; z-index: 1;"></div>
									<div style="position: absolute; left: 34px; right: 0px; top: 0px; bottom: 0px; border: 1px solid #E4E5EA; border-radius: 4px; z-index: 2;"></div>
									<div style="width: 30px; height: 100%; display: flex; flex-direction: column; justify-content: space-between; padding: 18px 0px;">
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 10px; color: #A5A9BC; line-height: 14px;" v-for="(mItem, mIndex) in thirtyDayArr">{{mItem}}</div>
									</div>
									<div style="flex: 1;">
										<div id="echart_last_thirty_day_leave_bed" style="width: 200px; height: 313px; z-index: 3;"></div>
									</div>
								</div>
							</div>
					  </div>


                      <!-- <div id="ech_outBedNumOne" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedTimes">{{ allData.leaveBedInfo.secretsLeaveBedTimes.descLabel }}</div> -->
                    </div>
                    <!-- 离床次数分布 -->
                    <!-- <div>
                      <div class="txjyTit txjyTit_after_blue" style="">离床次数分布</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">参考范围</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">横轴为离床次数(次)</div>
                        </div>
                      </div>
                      <div id="ech_outBedNumOne" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedTimes">{{ allData.leaveBedInfo.secretsLeaveBedTimes.descLabel }}</div>
                    </div> -->
                    <!-- 离床次数统计 -->
                    <!-- <div>
                      <div class="txjyTit txjyTit_after_blue mt15" style="">每晚离床次数</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">日常表现</div>
                        </div>
                      </div>
                      <div id="ech_outBedNumTwo" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedTimesDay">{{ allData.leaveBedInfo.secretsLeaveBedTimesDay.descLabel }}</div> -->

                      <!-- 是否发生偏离 -->
                      <!-- <tan_needGz_portrait_botZheCont v-if="allData.leaveBedInfo.secretsLeaveBedTimesDayDeviate" :haveChangeData="allData.leaveBedInfo.secretsLeaveBedTimesDayDeviate"></tan_needGz_portrait_botZheCont>
                    </div> -->
                  </div>
                  <!-- 离床时长分布、统计如下图 -->
                  <!-- <div class="txjyWrap border_no mt10" v-if="allData.leaveBedInfo.secretsLeaveBedDuration"> -->
                    <!-- 离床时长分布 -->
                    <!-- <div>
                      <div class="txjyTit txjyTit_after_blue" style="">离床时长分布</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">参考范围</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">横轴为离床时长(分钟)</div>
                        </div>
                      </div>
                      <div id="ech_outBedTimeOne" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedDuration">{{ allData.leaveBedInfo.secretsLeaveBedDuration.descLabel }}</div> -->

                      <!-- 是否发生偏离 -->
                      <!-- <tan_needGz_portrait_botZheCont v-if="allData.leaveBedInfo.secretsLeaveBedDurationDeviate" :datatype="'lcscfb'" :haveChangeData="allData.leaveBedInfo.secretsLeaveBedDurationDeviate"></tan_needGz_portrait_botZheCont>
                    </div>
                  </div> -->
                  <!-- 上床入睡醒来起床 -->
                  <!-- <div class="txjyWrap border_no mt10" v-if="allData.leaveBedInfo.secretsLeaveBedTimeDuration">
                    <div>
                      <div class="txjyTit txjyTit_after_blue" style="">离床发生的时间点和时长分布</div>
                      <div class="lcscSinWrap mt10">
                        <div class="name" style="width:100%;text-align:center;">离床时长（分钟）</div>
                        <img class="boxBg mt5" src="../../../assets/report_pic_color_d@2x.png" alt="">
                        <div class="boxBgData" v-if="allData.leaveBedInfo.secretsLeaveBedTimeDuration">
                          <div class="bNum" :key="index" v-for="(item,index) in allData.leaveBedInfo.secretsLeaveBedTimeDuration.referenceList">
                            <div v-if="item < 90">{{item}}</div>
                            <div v-if="item >= 90">≥{{item}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="referVal referValTimeSingle">
                        <div class="referValLeft">
                          <div class="gantTip">19:30</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">08:30</div>
                        </div>
                      </div>
                      
                      <div id="id_echSanDian_nightOutBed" style="height: 300px;overflow: auto;" v-if="allData && allData.leaveBedInfo && allData.leaveBedInfo.secretsLeaveBedTimeDuration">
                        <div id="echSanDian_nightOutBed" :style="{height:allData.leaveBedInfo.secretsLeaveBedTimeDuration.data.length*42 + 'px'}"></div>
                      </div> -->
                      

                      <!-- 夜间离床显示这个 -->
                      <!-- <div>
                        <div class="lcTimeTip mt10">
                          <div class="lcTimeKuang"></div>
                          <div class="lcTimeFont ml5">离床时间高频范围</div>
                        </div>
                        <div class="refer_comTit mt15" style="line-height: 22px;">
                          <div v-if="allData.leaveBedInfo.secretsLeaveBedTimeDuration" v-html="$options.filters.reMate(allData.leaveBedInfo.secretsLeaveBedTimeDuration.descLabel)"></div> -->
                          <!-- <div>·通常会在01:12～02:13，05:18～05:58离床；·</div>
                          <div class="flex">
                            <div>·</div>
                            <div class="colorFF7186">01:12～02:13</div>
                            <div>这个时间段发生的离床是值得注意的。·</div>
                          </div> -->
                        <!-- </div>
                      </div> -->

                      <!-- 是否发生偏离 -->
                      <!-- <tan_needGz_portrait_botZheCont v-if="allData.leaveBedInfo.secretsLeaveBedTimeDurationDeviate" :datatype="'lcSdt'" :haveChangeData="allData.leaveBedInfo.secretsLeaveBedTimeDurationDeviate"></tan_needGz_portrait_botZheCont>
                    </div>
                  </div> -->

                  <!-- 最下面的提醒建议 -->
                  <tan_needGz_portrait_botAdvise :haveChangeData="allData.leaveBedInfoV2.conclusionRecommend"></tan_needGz_portrait_botAdvise>

                  
                </div>
              </div>
              
              <!-- 睡眠情况 -->
              <div class="needGZ_OneList" v-if="true">
                <!-- 未揭秘的进度条 -->
                <div class="needGZ_OneListNoJm" v-if="allData.sleepInfo.unSecretsDays">
                  <div class="noJm_speed" :style="{width: allData.sleepInfo.unSecretsDays.accDays/allData.sleepInfo.unSecretsDays.totalDays + '%'}"></div>
                </div>
                <!-- 上方内容 -->
                <div class="portrait_OneList_topWrap" @click="smqk_isExpand = !smqk_isExpand">
                  <div class="portrait_OneList_top">
                    <div class="szhx_IconWrap">
                      <img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_16.png" alt="">
                    </div>
                    <div class="szhx_nameNum" v-if="allData.sleepInfo.changeNum">
                      <div class="num">{{ allData.sleepInfo.changeNum }}</div>
                    </div>
                    <div class="flex_Cen_Cen" v-if="allData.sleepInfo.hasOccurPrfList">
                      <div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.sleepInfo.hasOccurPrfList">
                        <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
                        <div class="fList fListRed" v-if="item.isNew && item.isWarn">
                          <img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
                          {{ item.realValue }}
                        </div>
                      </div>
                    </div>
                    <div class="flex mlAuto" v-if="allData.sleepInfo.unSecretsDays">
                      <div>再有</div>
                      <div class="color1890ff">{{ allData.sleepInfo.unSecretsDays.remainDays }}</div>
                      <div>晚揭秘</div>
                    </div>
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!smqk_isExpand && !allData.sleepInfo.unSecretsDays">
                    <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="smqk_isExpand && !allData.sleepInfo.unSecretsDays">
                  </div>
                </div>
                <!-- 弹窗展开内容 -->
                <div class="oneExpandCont" v-show="!allData.sleepInfo.unSecretsDays && smqk_isExpand">
                  <!-- 昨晚是否有值得关注的变化 -->
                  <tan_needGz_portrait_isHaveChange v-if="allData.sleepInfo.deviateTheDay" :haveChangeData="allData.sleepInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
                  
                  <!-- 睡眠时长分布、统计 -->
                  <div class="txjyWrap border_no mt10">
                    <!-- 睡眠时长分布 -->
                    <div>
                      <div class="txjyTit txjyTit_after_blue" style="">睡眠时长分布</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">参考范围</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">横轴为睡眠时长(小时)</div>
                        </div>
                      </div>
                      <div id="ech_sleepTimeOne" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepDuration">{{ allData.sleepInfo.secretsSleepDuration.descLabel }}</div>
                    </div>
                    <!-- 睡眠时长统计 -->
                    <div>
                      <div class="refer_comLine_heng"></div>
                      <div class="txjyTit txjyTit_after_blue mt15" style="">每晚睡眠时长</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">日常表现</div>
                        </div>
                      </div>
                      <div id="ech_sleepTimeTwo" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepDurationDay">{{ allData.sleepInfo.secretsSleepDurationDay.descLabel }}</div>

                      <!-- 是否发生偏离 -->
                      <tan_needGz_portrait_botZheCont v-if="allData.sleepInfo.secretsSleepDurationDayDeviate" :haveChangeData="allData.sleepInfo.secretsSleepDurationDayDeviate"></tan_needGz_portrait_botZheCont>
                    </div>
                  </div>

                  <!-- 睡眠效率分布、统计 -->
                  <div class="txjyWrap border_no mt10">
                    <!-- 睡眠效率分布 -->
                    <div>
                      <div class="txjyTit txjyTit_after_blue" style="">睡眠效率分布</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">参考范围</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">横轴为睡眠效率(%)</div>
                        </div>
                      </div>
                      <div id="ech_sleepEffOne" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepEfficiency">{{ allData.sleepInfo.secretsSleepEfficiency.descLabel }}</div>
                    </div>
                    <!-- 睡眠效率统计 -->
                    <div>
                      <div class="refer_comLine_heng"></div>
                      <div class="txjyTit txjyTit_after_blue mt15" style="">每晚睡眠效率</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">日常表现</div>
                        </div>
                      </div>
                      <div id="ech_sleepEffTwo" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepEfficiencyDay">{{ allData.sleepInfo.secretsSleepEfficiencyDay.descLabel }}</div>

                      <!-- 是否发生偏离 -->
                      <tan_needGz_portrait_botZheCont v-if="allData.sleepInfo.secretsSleepEfficiencyDayDeviate" :haveChangeData="allData.sleepInfo.secretsSleepEfficiencyDayDeviate"></tan_needGz_portrait_botZheCont>
                    </div>
                  </div>


                  <!-- 睡眠破碎统计_折线 -->
                  <div class="txjyWrap border_no mt10">
                    <!--  -->
                    <!-- 睡眠破碎分布 -->
                    <div>
                      <div class="txjyTit txjyTit_after_blue" style="">睡眠破碎指数分布</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">参考范围</div>
                        </div>
                        <div class="referValRight">
                          <div class="gantTip">横轴为睡眠破碎指数</div>
                        </div>
                      </div>
                      <div id="ech_sleepRrush" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepCrush">{{ allData.sleepInfo.secretsSleepCrush.descLabel }}</div>
                    </div>

                    <!-- 睡眠破碎统计_折线 -->
                    <div class="">
                      <div class="refer_comLine_heng"></div>
                      <div class="txjyTit txjyTit_after_blue mt15" style="">每晚睡眠破碎指数</div>
                      <div class="referVal">
                        <div class="referValLeft">
                          <div class="gangKuai2_border"></div>
                          <div class="gantTip">日常表现</div>
                        </div>
                      </div>
                      <div id="ech_sleepRrush_line" style="height: 150px;"></div>
                      <div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepCrushDay">{{  allData.sleepInfo.secretsSleepCrushDay.descLabel }}</div>

                      <!-- 是否发生偏离 -->
                      <tan_needGz_portrait_botZheCont v-if="allData.sleepInfo.secretsSleepCrushDayDeviate" :haveChangeData="allData.sleepInfo.secretsSleepCrushDayDeviate"></tan_needGz_portrait_botZheCont>
                    </div>
                  </div>
                  
                  <!-- 最下面的提醒建议 -->
                  <tan_needGz_portrait_botAdvise :haveChangeData="allData.sleepInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>

                  
                </div>
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
	<a-modal title="温馨提示" :width="400" :visible="isShowAlarmSetAlert" :maskClosable="false" :footer="null"
		@cancel="alarmSetAlertClickCancel" :zIndex="10000">
		<div style="font-family: PingFangSC, PingFang SC; font-weight: 500; font-size: 16px; color: #262626; line-height: 20px; margin-top: 0px; height: 56px; display: flex; align-items: center; padding-left: 24px;">设置</div>
		<div style="height: 1px; background: rgba(232, 232, 232, 1);"></div>
		<div style="display: flex; padding-left: 24px;">
			<div style="display: flex; align-items: center; margin-top: 24px; margin-bottom: 40px;">
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px;">呼吸过速报警阈值</div>
				<a-select
					v-if="isShowAlarmSetAlert"
					placeholder="请选择"
					:default-value="alarmModel.breathFast"
					option-filter-prop="children"
					style="width: 99px; margin-left: 10px; margin-right: 10px;"
					:filter-option="filterOption"
					@focus="handleFocus"
					@blur="handleBlur"
					@change="handleChange"
				>
					<a-select-option :value="item" :key="index" v-for="(item, index) in [27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40]">
					{{ item }}
					</a-select-option>
				</a-select>
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px;">bpm</div>
			</div>
		</div>
		<div class="addBtn toitet-btn" style="margin-left: 245px; margin-bottom: 20px;">
			<a-button style="margin-right: 10px" @click="alarmSetAlertClickCancel">取消</a-button>
			<a-button type="primary" @click="alarmSetAlertClickSure">确定</a-button>
		</div>
	</a-modal>
  </div>
</template>

<script>
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';
import tan_needGz_portrait_isHaveChange from './tan_needGz_portrait_isHaveChange.vue';     //昨晚是否有值得关注的变化
import tan_needGz_portrait_botZheCont from './tan_needGz_portrait_botZheCont.vue';         //是否发生偏离
import tan_needGz_portrait_botAdvise from './tan_needGz_portrait_botAdvise.vue';           //最下面的提醒建议

import ContentCardBasePortraitE from '../component/contentCardBasePortraitE.vue'
import getEchartsOptionFloatA2 from '../component/options/echartsOptionFloatA2.js'

import dataJson from './bbb.json'
export default {
  components: { tan_needGz_portrait_isHaveChange,tan_needGz_portrait_botZheCont,tan_needGz_portrait_botAdvise, ContentCardBasePortraitE },
  filters: {
	reMate(val){
      return CustomRichText.reMate(portFn.function_reg_str_to_arr(val))
    },
  },
  props: {
    
  },
  watch: {
    
  },
  data() {
    return {
      innerHeight: null,
      bedId: '',
      new_rankList: [],
      tan_needGZ_single: false,
      hxqk_isExpand: true,     // 呼吸情况是否展开
      tdqk_isExpand: true,     // 体动情况是否展开
      xtqk_isExpand: true,     // 心跳情况是否展开
      zxgl_isExpand: true,     // 作息规律是否展开
      yjlc_isExpand: true,     // 夜间离床是否展开
      smqk_isExpand: true,     // 睡眠情况是否展开


      allData: null,           //数字画像接口数据
      isDomOver: null,
      
	  isHaveHxl: true,

	  isShowAlarmSetAlert: false,


	  clickId: null,

	  alarmModel: null,

		// 复杂图表相关
		leaveSelectIndex: undefined,
		leaveWidth: 540,
		leaveSingleWidth: 18,
		leaveHoverindex: undefined,
		leaveIsShowRightCharts: true,
		leaveLeftData: null,
		leaveRightData: null,
		leaveWranningTips: [],
		thirtyDayArr: ["20:30", "21:30", "22:30", "23:30", "00:30", "01:30", "02:30", "03:30", "04:30", "05:30", "06:30", "07:30"]




    };
  },
  created() {
	window.addEventListener('resize', () => {
		if (this.echartsLeaveBedTop1) {
			this.echartsLeaveBedTop1.resize();
		}
		if (this.echartsLeaveBedTop1) {
			this.echartsLeaveBedTop1.resize();
		}
		if (this.lastThirtyDayLeaveBedChar) {
			this.lastThirtyDayLeaveBedCharts.resize();
		}
      });
  },
  mounted() {
    
    
  },
  methods: {
	yjlcUnfold() {
		this.yjlc_isExpand = !this.yjlc_isExpand;
		// 最近30天每小时离床情况 - 图表
		if (this.leaveIsShowRightCharts == true) {
			this.setEchartLastThirtyDayLeaveBed();
		}
		// 每晚睡眠间离床情况 - 图表
		this.setEchartLeaveBed();
	},
	// 分 转 时分字符串
	mintuesToHoursMintues(data) {
		return (Math.floor(data / 60) < 10 ? '0' + Math.floor(data / 60) : Math.floor(data / 60)) + ':' + ( Math.floor(data % 60) < 10 ? '0' +  Math.floor(data % 60) :  Math.floor(data % 60))
	},
	// 时分字符串 转 分
	hoursMintuesToMintues(data) {
		return (parseInt((parseInt(data.split(":")[0]) * 60) + (parseInt(data.split(":")[1]))))
	},
	// 时分字符串 转 特定时分字符串 （比如：02:00 会变成 26:00）
	hoursMintuesToCustomHoursMintues(data) {
		let mintues = this.hoursMintuesToMintues(data);
		if (mintues < 1170) { // 1170 代表 19:30
			mintues = mintues + 1440;
		}
		return this.mintuesToHoursMintues(mintues);
	},
	leaveChangeDateClick(index) {
		this.leaveSelectIndex = index;
		this.setEchartLeaveBed();
	},
	initLeaveCharts() {
		let that = this;

		this.echartsLeaveBedTop1 = this.$echarts.init(document.getElementById('echartsLeaveBedTop1'), null, { renderer: 'svg' });
		// 柱子点击事件
		this.echartsLeaveBedTop1.on('click', function (params) {
			that.leaveSelectIndex = params.dataIndex;
			that.setEchartLeaveBed();
			// console.log('========', '点击了某根柱子', params)
		});
		// 柱子hover事件
		this.echartsLeaveBedTop1.on('mouseover', function (params) {
			if (params.componentType === 'series') {
				var dataIndex = params.dataIndex;
				// 你可以在这里编写你的逻辑，例如：
				// console.log('Hovering over data index: ' + dataIndex);
				that.leaveHoverindex = dataIndex;
			}
		});
		this.echartsLeaveBedTop1.on('mouseout', function (params) {
			if (params.componentType === 'series') {
				var dataIndex = params.dataIndex;
				// 你可以在这里编写你的逻辑，例如：
				// console.log('Mouse out of data index: ' + dataIndex);
				// that.leaveHoverindex = undefined;
			}
		});


		this.echartsLeaveBedBottom1 = this.$echarts.init(document.getElementById('echartsLeaveBedBottom1'), null, { renderer: 'svg' });
		// 柱子点击事件
		this.echartsLeaveBedBottom1.on('click', function (params) {
			that.leaveSelectIndex = params.dataIndex;
			that.setEchartLeaveBed();
			// console.log('========', '点击了某根柱子', params)
		});
		// 柱子hover事件
		this.echartsLeaveBedBottom1.on('mouseover', function (params) {
			if (params.componentType === 'series') {
				var dataIndex = params.dataIndex;
				// 你可以在这里编写你的逻辑，例如：
				// console.log('Hovering over data index: ' + dataIndex);
				that.leaveHoverindex = dataIndex;
			}
		});
		this.echartsLeaveBedBottom1.on('mouseout', function (params) {
			if (params.componentType === 'series') {
				var dataIndex = params.dataIndex;
				// 你可以在这里编写你的逻辑，例如：
				// console.log('Mouse out of data index: ' + dataIndex);
				// that.leaveHoverindex = undefined;
			}
		});

		// if (this.leaveIsShowRightCharts == true) {
		this.lastThirtyDayLeaveBedCharts = this.$echarts.init(document.getElementById('echart_last_thirty_day_leave_bed'), null, { renderer: 'svg' });
		// }
	},
	setEchartLeaveBed() {

		/**
		 * 一、数据处理
		 */
		let xaxisArr = this.leaveLeftData && this.leaveLeftData.xaxis ? this.leaveLeftData.xaxis : [];
		let dataArr = [];
		for (let i = 0; i < this.leaveLeftData.data.length; i++) {
			let item = this.leaveLeftData.data[i];
			dataArr.push(item.extendData.leaveBedCnt);
		}

		// 设置默认选中index
		if (this.leaveSelectIndex === undefined) {
			this.leaveSelectIndex = dataArr.length - 1;
		}

		let xAxis_data = xaxisArr;
		let normal_series_data = []; // 未被选中的柱子数组
		let select_series_data = []; // 被选中的柱子数组
		let tool_series_data = []; // 工具视图（用于处理柱子点击事件和）
		let maxY = 1;
		
		for (let i = 0; i < dataArr.length; i++) {
			// 两个图表 series_data
			if (this.leaveSelectIndex == i) {
				select_series_data.push({
					value: dataArr[i],
					itemStyle: {
						normal: {
							color: this.leaveLeftData.data[i].extendData.leaveBedCntDeviate ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 1)'
						},
						emphasis: {
							color: this.leaveLeftData.data[i].extendData.leaveBedCntDeviate ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 1)'
						}
					}
				});
				normal_series_data.push(null);
			} else {
				select_series_data.push(null);
				normal_series_data.push({
					value: dataArr[i],
					itemStyle: {
						normal: {
							color: this.leaveLeftData.data[i].extendData.leaveBedCntDeviate ? 'rgba(255, 113, 134, 0.1)' : 'rgba(74, 124, 232, 0.1)'
						},
						emphasis: {
							color: this.leaveLeftData.data[i].extendData.leaveBedCntDeviate ? 'rgba(255, 113, 134, 0.4)' : 'rgba(74, 124, 232, 0.4)'
						}
					}
				});
			}
			// Y轴最小值
			if (dataArr[i] > maxY) {
				maxY = dataArr[i];
			}
		}
		for (let i = 0; i < xAxis_data.length; i++) {
			tool_series_data.push(maxY);
		}

		let that = this;

		/**
		 * 设置 Option
		 */
		let option = {
			grid: [
				{ 
					left: 0,
					top: 0,
					right: 0,
					bottom: 2
				},
				{ 
					left: 0,
					top: 0,
					right: 0,
					bottom: 2
				},
				{ 
					left: 0,
					top: 0,
					right: 0,
					bottom: 2
				}
			],
			tooltip: {
				backgroundColor: 'rgba(255, 255, 255, 0.95)',
				borderColor: "rgba(216, 226, 248, 1)",
				borderWidth: 1,
				borderRadius: 4,
				textStyle: {
					color: "#8394B9",
				},
				confine: true,
				formatter: function (value) {

					let barSerieVal = value;

					let titleDiv;
					let contentDiv;
					let dotColor;
					let textColor = 'rgba(165, 169, 188, 1)'

					titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${that.leaveLeftData.data[barSerieVal.dataIndex].extendData.date}</div>`;

					if (that.leaveLeftData.data[barSerieVal.dataIndex].extendData.leaveBedCntDeviate == true) {
						dotColor = "rgba(255, 113, 134, 1)";
					} else {
						dotColor = "rgba(74, 124, 232, 1)";
					}

					let text = '离床' + that.leaveLeftData.data[barSerieVal.dataIndex].extendData.leaveBedCnt + '次';
					if (that.leaveLeftData.data[barSerieVal.dataIndex].extendData.leaveBedCnt == 0) {
						dotColor = 'rgba(165, 169, 188, 1)'
						text = "未离床"
					} else if (!that.leaveLeftData.data[barSerieVal.dataIndex].extendData.leaveBedCnt) {
						dotColor = 'rgba(165, 169, 188, 1)'
						text = "未使用"
					}
					contentDiv = `
					<div style="display: flex; align-items: center; margin-top: 5px;">
						<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
						<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${text}</div>
					</div>
					`

					return titleDiv + contentDiv

				},
			},
			xAxis: [
				{ 
					gridIndex: 0,
					type: 'category',
					axisTick: {
						show: false,
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: "rgba(94, 103, 121, 0.1)",
							type: "dotted",
						},
						alignWithLabel: true
					},
					axisLabel: {
						show: false,
						interval: 0
					},
					data: xAxis_data,
				},
				{ 
					gridIndex: 1,
					type: 'category',
					show: false,
					data: xAxis_data 
				},
				{ 
					gridIndex: 2,
					type: 'category',
					show: false,
					data: xAxis_data 
				}
			],
			yAxis: [
				{ 
					gridIndex: 0,
					minInterval: 1,
					max: maxY,
					axisTick: {
						show: false,
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: "rgba(94, 103, 121, 0.1)",
							type: "dotted",
						},
					},
					axisLabel: {
						show: false
					},
				},
				{ 
					gridIndex: 1,
					minInterval: 1,
					max: maxY,
					show: false,
				},
				{ 
					gridIndex: 2,
					minInterval: 1,
					max: maxY,
					show: false,
				}
			],
			series: [
				{
					zlevel: 1,
					type: 'bar',
					xAxisIndex: 0,
					yAxisIndex: 0,
					itemStyle: {
						normal: {
						color: 'rgba(74, 124, 232, 0.1)',
						borderRadius: [2, 2, 2, 2],
						},
						emphasis: {
						color: 'rgba(74, 124, 232, 0.4)'
						}
					},
					data: normal_series_data,
				},
				{
					zlevel: 2,
					type: 'bar',
					xAxisIndex: 1,
					yAxisIndex: 1,
					itemStyle: {
						normal: {
						color: 'rgba(74, 124, 232, 0.1)',
						borderRadius: [2, 2, 2, 2],
						},
						emphasis: {
						color: 'rgba(74, 124, 232, 0.4)'
						}
					},
					data: select_series_data,
				},
				{
					zlevel: 0,
					type: 'bar',
					xAxisIndex: 2,
					yAxisIndex: 2,
					itemStyle: {
						normal: {
							color: '#FFFFFF00',
							borderRadius: [2, 2, 2, 2],
						}
					},
					data: tool_series_data,
					barWidth: '100%'
				}
			]
			};

		this.echartsLeaveBedTop1.setOption(option, true);
		this.echartsLeaveBedTop1.resize();
		setTimeout(() => {
			this.echartsLeaveBedTop1.resize();
		}, 1000);

		this.setEchartLeaveBedBottom();
	},
	setEchartLeaveBedBottom() {

		/**
		 * 一、数据处理
		 */

		// 0.数据、X轴
		let leaveLeftData = this.leaveLeftData && this.leaveLeftData.data ? JSON.parse(JSON.stringify(this.leaveLeftData.data)) : null;
		let xaxisArr = this.leaveLeftData && this.leaveLeftData.xaxis ? this.leaveLeftData.xaxis : [];
		// 去掉 timeSt 和 timeEd 的年月日
		for (let i = 0; i < leaveLeftData.length; i++) {
			let item = leaveLeftData[i];
			if (item.extendData && item.extendData.leaveBedList) {
				for (let j = 0; j < item.extendData.leaveBedList.length; j++) {
					let jItem = item.extendData.leaveBedList[j];
					if (jItem.timeSt && jItem.timeSt.indexOf(" ") >= 0) {
						jItem.timeSt = jItem.timeSt.split(" ")[1]
					}
					if (jItem.timeEd && jItem.timeEd.indexOf(" ") >= 0) {
						jItem.timeEd = jItem.timeEd.split(" ")[1]
					}
				}
			}
		}

		let tipWranningList = leaveLeftData[this.leaveSelectIndex];
		if (tipWranningList.extendData.leaveBedList && tipWranningList.extendData.leaveBedList.length > 0) {
			let needArr = [];
			for (let i = 0; i < tipWranningList.extendData.leaveBedList.length; i++) {
				let item = tipWranningList.extendData.leaveBedList[i];
				if (item.floatingWinTips && item.timeSt) {
					let needTop = '0px';
					let tempTimeSt = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(item.timeSt))
					// 1170
					// 1950
					// 780
					// 313 / 780 = 0.4
					console.log('=======', (tempTimeSt - 1170) * 0.4, tempTimeSt)
					let needArrItem = {
						"floatingWinTips": item.floatingWinTips,
						"top": ((tempTimeSt - 1170) *  0.386 - 20) + 'px'
					}
					needArr.push(needArrItem);
				}
			}
			this.leaveWranningTips = needArr;
		} else { 
			this.leaveWranningTips = []
		}

		// 1.获取Y轴时间点数据（单位：分）
		let yAxis_data = [];
		let start_time_1 = "19:30";
		let end_time_1 = "23:59";
		let start_time_2 = "00:00";
		let end_time_2 = "08:30";
		
		let start_time_1_int = parseInt((parseInt(start_time_1.split(":")[0]) * 60) + (parseInt(start_time_1.split(":")[1])));
		let end_time_1_int = parseInt((parseInt(end_time_1.split(":")[0]) * 60) + (parseInt(end_time_1.split(":")[1])));
		let start_time_2_int = parseInt((parseInt(start_time_2.split(":")[0]) * 60) + (parseInt(start_time_2.split(":")[1])));
		let end_time_2_int = parseInt((parseInt(end_time_2.split(":")[0]) * 60) + (parseInt(end_time_2.split(":")[1])));

		let minutes = [];
		for (let i = start_time_1_int; i <= end_time_1_int; i++) {
			minutes.push(i);
		}
		for (let i = start_time_2_int; i <= end_time_2_int; i++) {
			minutes.push(i);
		}

		// 2.Y轴分段最大值、最小值
		let minY1 = 1170;
		let maxY1 = 1439;
		let minY2 = 0;
		let maxY2 = 510

		// 3.获取最大的堆叠数（堆叠柱状图）
		let maxStackedNum = 0;
		for (let i = 0; i < leaveLeftData.length; i++) {
			let tempItem = leaveLeftData[i];
			if (tempItem && tempItem.extendData.leaveBedList && tempItem.extendData.leaveBedList.length > 0) {
				if (maxStackedNum < tempItem.extendData.leaveBedList.length) {
					maxStackedNum = tempItem.extendData.leaveBedList.length;
				}
			}
		}
		maxStackedNum = maxStackedNum * 2 + 1; // 最大堆叠数计算方式，具体如下
		/**
		 	0 - 2dict
			1 - 3dict
			2 - 5dict
			3 - 7dict
			4 - 9dict
			5 - 11dict
		 */
		console.log('hahaha', maxStackedNum)

		// 拷贝一份新的数据数组，补充满堆叠数
		let copyTargetData = JSON.parse(JSON.stringify(leaveLeftData));
		for (let i = 0; i < copyTargetData.length; i++) {
			let tempItem = copyTargetData[i];
			if (!tempItem.extendData.leaveBedList || tempItem.extendData.leaveBedList.length == 0) {
				tempItem.extendData.leaveBedList = []
				for (let j = 0; j < maxStackedNum; j++) {
					tempItem.extendData.leaveBedList.push(null);
				}
			} else {
				let tempItemTimeDuration = JSON.parse(JSON.stringify(tempItem.extendData.leaveBedList));
				tempItem.extendData.leaveBedList = []
				for (let j = 0; j < maxStackedNum; j++) {
					if (j % 2 == 1) { // 1 3 5 - 0 1 2
						let needIndex = Math.round(j / 2) - 1;
						if (tempItemTimeDuration.length - 1 >= needIndex) {
							tempItem.extendData.leaveBedList.push(tempItemTimeDuration[Math.round(j / 2) - 1]);
						} else {
							tempItem.extendData.leaveBedList.push(null);
						}
					} else {
						tempItem.extendData.leaveBedList.push(null);
					}
				}
			}
		}

		// 再次处理 copyTargetData
		for (let i = 0; i < copyTargetData.length; i++) {
			let tempItem_timeDuration = copyTargetData[i].extendData.leaveBedList;
			for (let j = 0; j < tempItem_timeDuration.length; j++) {
				if (tempItem_timeDuration[j] == null) {
					let needTimeSt;
					let needTimeEd;
					let needDuration;
					let needCustomDuration;
					if (j == 0) {
						needTimeSt = '19:30';
						if (!tempItem_timeDuration[j + 1]) {
							needTimeEd = '19:30'
							needDuration = 0;
							needCustomDuration = 0;
						} else {
							needTimeEd = this.mintuesToHoursMintues((this.hoursMintuesToMintues(tempItem_timeDuration[j + 1].timeSt) - 1));
							needDuration = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeSt));
							needCustomDuration = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeSt));
						}
						tempItem_timeDuration[j] = {
							'timeSt': needTimeSt,
							'timeEd': needTimeEd,
							'duration': needDuration,
							'needCustomDuration': needCustomDuration,
							'isAdd': true
						}
					} else {
						if (j == tempItem_timeDuration.length - 1) {
							tempItem_timeDuration[j] = {
								'timeSt': tempItem_timeDuration[j - 1].timeEd,
								'timeEd': "08:30",
								'duration': this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues("08:30")) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(tempItem_timeDuration[j - 1].timeEd)),
								'needCustomDuration': this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues("08:30")) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(tempItem_timeDuration[j - 1].timeEd)),
								'isAdd': true
							}
						} else {
							if (tempItem_timeDuration[j + 1] == null) {
								tempItem_timeDuration[j] = {
									'timeSt': tempItem_timeDuration[j - 1].timeEd,
									'timeEd': tempItem_timeDuration[j - 1].timeEd,
									'duration': 0,
									'needCustomDuration': 0,
									'isAdd': true
								}
							} else {
								let tempLastItem = tempItem_timeDuration[j - 1];
								let tempNextItem = tempItem_timeDuration[j + 1];
								needTimeSt = this.mintuesToHoursMintues(this.hoursMintuesToMintues(tempLastItem.timeEd) + 1);
								needTimeEd = this.mintuesToHoursMintues(this.hoursMintuesToMintues(tempNextItem.timeSt) - 1);
								needDuration = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeSt));
								needCustomDuration = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeSt));
								tempItem_timeDuration[j] = {
									'timeSt': needTimeSt,
									'timeEd': needTimeEd,
									'duration': needDuration,
									'needCustomDuration': needCustomDuration,
									'isAdd': true
								}
							}
						}
					}
				} else {
					tempItem_timeDuration[j].needCustomDuration =  this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(tempItem_timeDuration[j].timeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(tempItem_timeDuration[j].timeSt));
					tempItem_timeDuration[j].isAdd = false;
				}
			}
		}

		// console.log('======看看处理好没啊啊=====', copyTargetData)

		// .构造 series 数据
		let series_data = [];
		for (let i = 0; i < maxStackedNum; i++) {
			let serie = {
				xAxisIndex: 0,
				yAxisIndex: 0,
				type: 'bar',
				stack: 'leadve_a',
				barWidth: 5,
				zlevel: 1
			}
			let select_serie = {
				xAxisIndex: 1,
				yAxisIndex: 1,
				type: 'bar',
				stack: 'leave_b',
				barWidth: 13,
				zlevel: 0
			}
			let tempNeedArr = [];
			let select_tempNeedArr = [];
			for (let j = 0; j < copyTargetData.length; j++) {
				let temp_copyTargetData_item = copyTargetData[j];
				let needArrItem = {
					value: i == 0 ? temp_copyTargetData_item.extendData.leaveBedList[i].needCustomDuration + 1170 : temp_copyTargetData_item.extendData.leaveBedList[i].needCustomDuration,
                	itemStyle: {
						normal: {
							color: temp_copyTargetData_item.extendData.leaveBedList[i].isAdd ? '#FFFFFF00' : (temp_copyTargetData_item.extendData.leaveBedList[i].deviate ? 'rgba(255, 113, 134, 0.2)' : 'rgba(74, 124, 232, 0.2)'),
							borderRadius: [3, 3, 3, 3]
						},
						emphasis: {
							color: temp_copyTargetData_item.extendData.leaveBedList[i].isAdd ? '#FFFFFF00' : (temp_copyTargetData_item.extendData.leaveBedList[i].deviate ? 'rgba(255, 113, 134, 0.5)' : 'rgba(74, 124, 232, 0.5)'),
							borderRadius: [3, 3, 3, 3]
						},
					},
					customData: temp_copyTargetData_item.extendData.leaveBedList[i]
				}
				tempNeedArr.push(needArrItem)
				
				let select_needArrItem = {
					value: i == 0 ? temp_copyTargetData_item.extendData.leaveBedList[i].needCustomDuration + 1170 : temp_copyTargetData_item.extendData.leaveBedList[i].needCustomDuration,
                	itemStyle: {
						normal: {
							color: this.leaveSelectIndex == j ? temp_copyTargetData_item.extendData.leaveBedList[i].isAdd ? '#FFFFFF00' : (temp_copyTargetData_item.extendData.leaveBedList[i].deviate ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 1)') : '#FFFFFF00',
							borderRadius: [3, 3, 3, 3]
						},
						emphasis: {
							color: this.leaveSelectIndex == j ? temp_copyTargetData_item.extendData.leaveBedList[i].isAdd ? '#FFFFFF00' : (temp_copyTargetData_item.extendData.leaveBedList[i].deviate ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 1)') : '#FFFFFF00',
							borderRadius: [3, 3, 3, 3]
						}
					},
					customData: temp_copyTargetData_item.extendData.leaveBedList[i]
				}
				select_tempNeedArr.push(select_needArrItem)
			}
			serie.data = tempNeedArr;
			series_data.push(serie);

			select_serie.data = select_tempNeedArr;
			series_data.push(select_serie);
		}

		let option2 = {
			tooltip: {
				backgroundColor: 'rgba(255, 255, 255, 0.95)',
				borderColor: "rgba(216, 226, 248, 1)",
				borderWidth: 1,
				borderRadius: 4,
				textStyle: {
					color: "#8394B9",
				},
				confine: true,
				formatter: function (value) {
					// console.log('==========', value.data.customData)
					// console.log('~~~~~~~~~~', copyTargetData)
					// console.log('++++++++++', copyTargetData[value.dataIndex].extendData.leaveBedList)
					// return
					let barSerieVal = value;


					if (!value.data.customData.isAdd) {
						let titleDiv;
						let contentDiv;
						let dotColor;
						let textColor = 'rgba(165, 169, 188, 1)'

						if (value.data.customData.deviate == true) {
							textColor = 'rgba(255, 113, 134, 1)';
							dotColor = "rgba(255, 113, 134, 1)";
						} else {
							textColor = 'rgba(165, 169, 188, 1)';
							dotColor = "rgba(74, 124, 232, 1)";
						}

						titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${value.data.customData.timeStCn}</div>`;

						contentDiv = `
						<div style="display: flex; align-items: center; margin-top: 5px;">
							<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
							<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'离床' + value.data.customData.duration + '分钟'}</div>
						</div>
						`

						return titleDiv + contentDiv
					} else {
						return undefined
						return `<div></div>`
						let titleDiv;
						let textColor = 'rgba(165, 169, 188, 1)'
						titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'></div>`;
						return titleDiv
					}

				},
			},
			grid: [
				{ 
					left: 0,
					top: 0,
					right: 0,
					bottom: 2,
				},
				{ 
					left: 0,
					top: 0,
					right: 0,
					bottom: 2
				},
			],
			xAxis: [
				{
					gridIndex: 0,
					type: 'category',
					axisTick: {
						show: false,
					},
					axisLine: {
						show: false
					},
					axisLabel: {
						show: false,
						interval: 0
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: "rgba(94, 103, 121, 0.1)",
							type: "dotted",
						},
						alignWithLabel: true
					},
					data: xaxisArr
				},
				{
					gridIndex: 1,
					type: 'category',
					show: false,
					data: xaxisArr
				}
			],
			yAxis: [
				{
					gridIndex: 0,
					type: 'value',
					axisTick: {
						show: false,
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: "rgba(94, 103, 121, 0.1)",
							type: "dotted",
						},
					},
					min: 1170,
					max: 1950,
					inverse: true,
					interval: 60,
				},
				{
					gridIndex: 1,
					type: 'value',
					show: false,
					min: 1170,
					max: 1950,
					inverse: true
				}
			],
			series: series_data
		};
		this.echartsLeaveBedBottom1.setOption(option2, true);
		this.echartsLeaveBedBottom1.resize();

		setTimeout(() => {
			this.echartsLeaveBedBottom1.resize();
		}, 1000);
	},
	// 最近30天每小时离床情况 Echarts 图表
	setEchartLastThirtyDayLeaveBed() {
		
		let interfaceData = JSON.parse(JSON.stringify(this.allData.leaveBedInfoV2.secretsLeaveBedInfo.secretsLeaveBedBaseline))

		let originalDataArr = interfaceData.last30EveryHourList;
		let barArr = [];
		let lineArr = [];
		for (let i = 0; i < originalDataArr.length; i++) {
			let item = originalDataArr[i];
			barArr.push(item.cnt);
			lineArr.push(item.duration);
		}

		// pieces
		let pieces = [];
		for (let i = 0; i < originalDataArr.length; i++) {
			let item = originalDataArr[i];
			if (item.duration == 0) {
				pieces.push(
					{
						gt: i - 1,
						lte: i,
						symbolSize: 6,
						color: 'rgba(165, 169, 188, 1)'
					}
				)
			} else {
				pieces.push(
					{
						gt: i - 1,
						lte: i,
						symbolSize: 6,
						color: 'rgba(110, 197, 245, 1)'
					}
				)
			}
		}

		// let yAxis_data = ["19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "00:00", "00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30"]
		let yAxis_data = ['19:30~20:30', '20:30~21:30', '21:30~22:30', '22:30~23:30', '23:30~00:30', '00:30~01:30', '01:30~02:30', '02:30~03:30', '03:30~04:30', '04:30~05:30', '05:30~06:30', '06:30~07:30', '07:30~08:30']
		let option = {
			grid: [
				{
					x: -3,
					y: 0,
					x2: 0,
					y2: 0,
					containLabel: true
				},
				{
					x: -3,
					y: 0,
					x2: 0,
					y2: 0,
					containLabel: true
				}
			],
			tooltip: {
				trigger: "axis",
				backgroundColor: 'rgba(255, 255, 255, 0.95)',
				borderColor: "rgba(216, 226, 248, 1)",
				borderWidth: 1,
				borderRadius: 4,
				textStyle: {
					color: "#8394B9",
				},
				confine: true,
				formatter: function (value) {

					let barSerieVal = value[0];
					let lineSerieVal = value[1];

					let titleDiv;
					let contentDiv1;
					let contentDiv2;
					let contentDiv3;
					let dotColor1;
					let dotColor2;
					let dotColor3;
					let textColor = 'rgba(165, 169, 188, 1)'

					titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'最近30天'} ${originalDataArr[barSerieVal.dataIndex].timeSt + '～' + originalDataArr[barSerieVal.dataIndex].timeEd}</div>`;
					if (!barSerieVal.data || barSerieVal.data == 0) {
						dotColor3 = 'rgba(165, 169, 188, 1)';
						contentDiv3 = `
						<div style="display: flex; align-items: center; margin-top: 5px;">
							<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor3}'></span>
							<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'未离床'}</div>
						</div>
						`
						return titleDiv + contentDiv3;
					} else {
						dotColor1 = 'rgba(74, 124, 232, 1)';
						dotColor2 = 'rgba(110, 197, 245, 1)';
						contentDiv1 = `
						<div style="display: flex; align-items: center; margin-top: 5px;">
							<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor1}'></span>
							<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'离床' + barSerieVal.data + '次'}</div>
						</div>
						`
						contentDiv2 = `
						<div style="display: flex; align-items: center; margin-top: 5px;">
							<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor2}'></span>
							<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'平均离床' + lineSerieVal.data + '分钟/次'}</div>
						</div>
						`
						return titleDiv + contentDiv1 + contentDiv2;
					}

					// let barValue = value

					// let dotColor = 'rgba(74, 124, 232, 1)';
					// let textColor = 'rgba(131, 148, 185, 1)';

					// // 弹窗样式
					// let titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'2'} ${'1'}</div>`
					// let contentDiv1 = `
					// <div style="display: flex; align-items: center; margin-top: 5px;">
					// 	<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
					// 	<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'hahahahaha'}</div>
					// </div>
					// `
					// let contentDiv2 = `
					// <div style="display: flex; align-items: center; margin-top: 5px;">
					// 	<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
					// 	<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'hahahahaha'}</div>
					// </div>
					// `
					// return titleDiv + contentDiv1 + contentDiv2;

					// let tempArr = expansion_data[value[0].dataIndex] || []
					// if (!tempArr || tempArr.length == 0) {
					// 	return
					// }
					// let startTime = parseInt(value[0].name);
					// let endTime = startTime + 9;
					// let startHours = Math.floor(startTime / 60);
					// let startHoursStr = startHours < 10 ? '0' + startHours : startHours;
					// let startMinutes = startTime - (startHours * 60);
					// let startMinutesStr = startMinutes < 10 ? '0' + startMinutes : startMinutes;
					// let endHours = Math.floor(endTime / 60);
					// let endHoursStr = endHours < 10 ? '0' + endHours : endHours;
					// let endMinutes = endTime - (endHours * 60);
					// let endMinutesStr = endMinutes < 10 ? '0' + endMinutes : endMinutes;
					// let topStr1 = startHoursStr + ':' + startMinutesStr + '～' + endHoursStr + ':' + endMinutesStr + ' 发生';
					// let topStr2 = value[0].value;
					// let bottomStr = '';
					// for (let i = 0; i < tempArr.length; i++) {
					// 	let item = tempArr[i];
					// 	if (i == 0) {
					// 		bottomStr += item;
					// 	} else {
					// 		bottomStr = bottomStr + '、' + item;
					// 	}
					// }
					
					// let divStr = "<div style='display: flex; flex-direction: column;'><div style='display: flex;'><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>" + topStr1 + "</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 17px;'>" + topStr2 + "</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>次</div></div><div style='display: flex; margin-top: 2px;'><div style='width: 6px; height: 6px; background: #4A7CE8; border-radius: 3px; margin-top: 6px;'></div><div style='flex: 1; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px; margin-left: 4px; max-width: 285px; white-space: wrap;'>" + bottomStr + "</div></div></div>"
					// return divStr;
					// return "<div style='display: flex; flex-direction: column;'><div style='display: flex;'><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>04:01～04:10 发生</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 17px;'>9</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>次</div></div><div style='display: flex; margin-top: 2px;'><div style='width: 6px; height: 6px; background: #4A7CE8; border-radius: 3px; margin-top: 6px;'></div><div style='flex: 1; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px; margin-left: 4px; width: 264px; white-space: wrap;'>04:01～04:01、04:02～04:02、04:03～04:03、04:04～04:04、04:05～04:05、04:06～04:06、04:07～04:07、04:08～04:08、04:09～04:12</div></div></div>";
				},
			},
			xAxis: [
				{
					gridIndex: 0,
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: false
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "rgba(144, 148, 166, 0.1)",
							type: "solid",
						},
					},
					splitLine: {
						show: false
					},
				},
				{
					gridIndex: 1,
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: false
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "rgba(144, 148, 166, 0.1)",
							type: "solid",
						},
					},
					splitLine: {
						show: false
					},
				}
			],
			yAxis: [
				{
					gridIndex: 0,
					data: yAxis_data,
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: true,
						textStyle: {
							color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
							fontSize: 10
						},
						formatter: function () {
							return "";
						},
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: "rgba(94, 103, 121, 0.1)",
							type: "dotted",
						},
					},
					inverse: true
				},
				{
					gridIndex: 1,
					data: yAxis_data,
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: true,
						textStyle: {
							color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
							fontSize: 10
						},
						formatter: function () {
							return "";
						},
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: "rgba(94, 103, 121, 0.1)",
							type: "dotted",
						},
					},
					inverse: true
				}
			],
			visualMap: {
				show: false,
				seriesIndex: 1,
				pieces: pieces
			},
			series: [
				{
					type: 'bar',
					xAxisIndex: 0,
					yAxisIndex: 0,
					data: barArr,
					barWidth: 13,
					itemStyle: {
						normal: {
							barBorderRadius: [1, 1, 1, 1],
							color: '#4A7CE8'
						}
					},
				},
				{
					type: 'line',
					xAxisIndex: 1,
					yAxisIndex: 1,
					symbol: 'circle',
					itemStyle: {
					  color: 'orange'
					},
					lineStyle: {
					  color: 'rgba(110, 197, 245, 1)',
					  width: 1
					},
					data: lineArr
				}
			]
		};
		this.lastThirtyDayLeaveBedCharts.setOption(option, true);
		this.lastThirtyDayLeaveBedCharts.resize();
	},
	handleChange(value) {
		let tempAlarmModel = JSON.parse(JSON.stringify(this.alarmModel));
		tempAlarmModel.breathFast = value;
		this.alarmModel = tempAlarmModel;
		console.log(`selected ${value}`);
	},
	handleBlur() {
		console.log('blur');
	},
	handleFocus() {
		console.log('focus');
	},
	filterOption(input, option) {
		console.log('filterOption');
		return false;
		return (
			option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		);
	},
	clickSetAlarm() {
		// 1.接口获取呼吸过速报警阈值
		this.getAlarmModel();
	},
	alarmSetAlertClickCancel() {
		this.isShowAlarmSetAlert = false;
	},
	alarmSetAlertClickSure() {
		// 1.设置呼吸过速报警阈值
		this.setAlarmBpm();
	},
	getAlarmModel() {
		this.$get(
			'/api/dean/v5/getHealthAlarmConfig',
			{
				"bedId": this.bedId
			},
			(res) => {
				if (res.code == 0) {
					this.alarmModel = res.data;
					// 2.弹窗
					this.isShowAlarmSetAlert = true;
				} else {
					console.log(res.msg);
				}
			},
			(err) => {
				console.log(err);
			}
		);
	},
	setAlarmBpm() {
		this.$post(
				'/api/dean/v5/setHealthAlarmConfig',
				{
					"bedId": this.bedId,
					"breathFast": this.alarmModel.breathFast
				},
				(res) => {
					if (res.code == 0) {
						this.$message.success('设置成功');
						// 2.弹窗
						this.isShowAlarmSetAlert = false;
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
	},
    // 外界调用这个组件
    openComponent_tan_needGz_portrait(data, pageName){

		this.leaveSelectIndex = undefined;
		this.allData = null;
		this.leaveLeftData = null;
		this.leaveRightData = null;
		this.leaveIsShowRightCharts = true;
		this.leaveHoverindex = undefined;

      console.log('浏览器窗口可见部分高度' + window.innerHeight)
      this.innerHeight = Number(window.innerHeight) - 66
      console.log('调用了数字画像')
      console.log(data)
      this.bedId = data.bedId
      this.tan_needGZ_single = true;

      
      this.getDigitalPortraitBySnBedId()      //详情_数字画像

      this.$nextTick((res) =>{

        // let mmm = portFn.function_reg_str_to_arr('<Warning/> 最近一天您的体动指数是<Text_R>23</Text_R>，明显和您日常的表现有较大差异')
        // console.log(mmm)
      })

	  if (pageName) {
			let clickType;
			if (pageName == 'lookAllPortrait0') {
				clickType = 12;
			} else if (pageName == 'lookAllPortrait1') {
				clickType = 14;
			}
			this.$get(
				'api/dean/v5/clickLog', {
					clickType: clickType
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.clickId = res.data.id;
						} 
					} else {
					}
				}, (err) => {}
			);
		} else {
			this.clickId = null;
		}
    },
	clickClose() {
		this.myChart_Line = null;
		this.myChart_Bar = null;
		this.tan_needGZ_single = false;
		if (this.clickId !== null) {
			this.$get(
				'api/dean/v5/closeLog', {
					id: this.clickId
				},
				(res) => {
					this.clickId = null;
				}, (err) => {}
			);
		}
	},
    // 详情_数字画像
    getDigitalPortraitBySnBedId(){
      this.hxqk_isExpand = true
      this.tdqk_isExpand = true
      this.xtqk_isExpand = true
      this.zxgl_isExpand = true
      this.yjlc_isExpand = true
      this.smqk_isExpand = true
      this.isDomOver = null
      console.log(788787)
      let obj = {
        bedId: this.bedId
        // bedId: '-123'
        // bedId: '500'
      }
      const loading = this.$loading ? this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      }) : null
      this.$get(
        'api/v4/home/getDigitalPortraitBySnBedId',
        obj,
        (res) => {
// 			res = {
// 	"code": 0,
// 	"msg": null,
// 	"data": {
// 		"lastDate": "2024-04-16",
// 		"isStart": true,
// 		"buAndFlName": "浙江福康通智慧养老-1层-2房-5号",
// 		"summarize": "呼吸具有<Tab_Warning_Text_R>呼吸急促</Tab_Warning_Text_R>的表现，体动具有<Tab_Warning_Text_R>睡眠不踏实</Tab_Warning_Text_R>的表现，睡眠具有<Tab_Text_P>高效睡眠</Tab_Text_P>的表现，心跳、作息规律、夜间离床整体表现正常，暂无明显特征",
// 		"changeNum": 1,
// 		"twinInfoVo": {
// 			"isUnlock": true,
// 			"sex": "0",
// 			"ageGroup": "0",
// 			"integralDetails": {
// 				"sleepTotalScore": 2907,
// 				"sleepTotalTimes": 39,
// 				"sleepTotalLen": 293,
// 				"breTotalTimes": 758849,
// 				"heartTotalTimes": 2431330,
// 				"hasOccurPrfList": [{
// 					"dimension": 2,
// 					"realValue": "睡眠不踏实",
// 					"conclusion": "睡眠**",
// 					"times": 3,
// 					"isWarn": true,
// 					"isNew": true,
// 					"isNewShow": true
// 				}, {
// 					"dimension": 4,
// 					"realValue": "高效起床人",
// 					"conclusion": "高效**",
// 					"times": 2,
// 					"isWarn": false,
// 					"isNew": false,
// 					"isNewShow": true
// 				}, {
// 					"dimension": 6,
// 					"realValue": "高效睡眠",
// 					"conclusion": "高效**",
// 					"times": 1,
// 					"isWarn": false,
// 					"isNew": true,
// 					"isNewShow": true
// 				}]
// 			},
// 			"scrollingTextList": [{
// 				"text": "持续使用设备守护您的睡眠，您的画像会与您保持同步，并及时发现潜在问题",
// 				"times": 1
// 			}],
// 			"hasOccurPrfNewList": [{
// 				"dimension": 2,
// 				"realValue": "睡眠不踏实",
// 				"conclusion": "睡眠**",
// 				"times": 3,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}, {
// 				"dimension": 6,
// 				"realValue": "高效睡眠",
// 				"conclusion": "高效**",
// 				"times": 1,
// 				"isWarn": false,
// 				"isNew": true,
// 				"isNewShow": true
// 			}],
// 			"hasOccurPrfNewV2List": [{
// 				"dimension": 1,
// 				"realValue": "呼吸急促",
// 				"conclusion": "呼吸**",
// 				"times": 1,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}, {
// 				"dimension": 2,
// 				"realValue": "睡眠不踏实",
// 				"conclusion": "睡眠**",
// 				"times": 3,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}, {
// 				"dimension": 6,
// 				"realValue": "高效睡眠",
// 				"conclusion": "高效**",
// 				"times": 1,
// 				"isWarn": false,
// 				"isNew": true,
// 				"isNewShow": true
// 			}]
// 		},
// 		"breathInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsBreath": {
// 				"xaxis": ["5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38"],
// 				"data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.01, 0.01, 0.03, 0.1, 0.2, 0.22, 0.19, 0.13, 0.07, 0.02, 0.01, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 				"range": ["13", "21"],
// 				"desc": "75%呼吸率都集中在13～21次/分之间，没有异常",
// 				"descLabel": "·75%呼吸率都集中在13～21次/分之间，没有异常",
// 				"descAnimation": "由您呼吸率分布图可见，75%的呼吸率都集中在13～21次/分之间，没有异常"
// 			},
// 			"secretsBreathDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": [{
// 					"date": "03-18",
// 					"min": "16",
// 					"median": "22",
// 					"max": "28"
// 				}, {
// 					"date": "03-19",
// 					"min": "15",
// 					"median": "21",
// 					"max": "27"
// 				}, {
// 					"date": "03-20",
// 					"min": "15",
// 					"median": "21",
// 					"max": "26"
// 				}, {
// 					"date": "03-21",
// 					"min": "14",
// 					"median": "21",
// 					"max": "28"
// 				}, {
// 					"date": "03-22",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "03-23",
// 					"min": "12",
// 					"median": "21",
// 					"max": "28"
// 				}, {
// 					"date": "03-24",
// 					"min": "14",
// 					"median": "20",
// 					"max": "25"
// 				}, {
// 					"date": "03-25",
// 					"min": "15",
// 					"median": "21",
// 					"max": "28"
// 				}, {
// 					"date": "03-26",
// 					"min": "14",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "03-27",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "03-28",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27"
// 				}, {
// 					"date": "03-29",
// 					"min": "15",
// 					"median": "20",
// 					"max": "27"
// 				}, {
// 					"date": "03-30",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "03-31",
// 					"min": "16",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "04-01",
// 					"min": "15",
// 					"median": "21",
// 					"max": "26"
// 				}, {
// 					"date": "04-02",
// 					"min": "15",
// 					"median": "20",
// 					"max": "25"
// 				}, {
// 					"date": "04-03",
// 					"min": "16",
// 					"median": "21",
// 					"max": "25"
// 				}, {
// 					"date": "04-04",
// 					"min": "14",
// 					"median": "21",
// 					"max": "26"
// 				}, {
// 					"date": "04-05",
// 					"min": "15",
// 					"median": "21",
// 					"max": "28"
// 				}, {
// 					"date": "04-06",
// 					"min": "14",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "04-07",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27"
// 				}, {
// 					"date": "04-08",
// 					"min": "14",
// 					"median": "19",
// 					"max": "27"
// 				}, {
// 					"date": "04-09",
// 					"min": "14",
// 					"median": "20",
// 					"max": "28"
// 				}, {
// 					"date": "04-10",
// 					"min": "13",
// 					"median": "20",
// 					"max": "25"
// 				}, {
// 					"date": "04-11",
// 					"min": "14",
// 					"median": "20",
// 					"max": "28"
// 				}, {
// 					"date": "04-12",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27"
// 				}, {
// 					"date": "04-13",
// 					"min": "15",
// 					"median": "21",
// 					"max": "26"
// 				}, {
// 					"date": "04-14",
// 					"min": "14",
// 					"median": "19",
// 					"max": "25"
// 				}, {
// 					"date": "04-15",
// 					"min": "14",
// 					"median": "19",
// 					"max": "28"
// 				}, {
// 					"date": "今日",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27"
// 				}],
// 				"range": [18, 23],
// 				"desc": "呼吸率中位数整体表现比较稳定",
// 				"descLabel": "·呼吸率中位数整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsBreathDeviate": null,
// 			"secretsInExRatio": {
// 				"xaxis": ["0.1", "0.2", "0.3", "0.4", "0.5", "0.6", "0.7", "0.8", "0.9", "1.0", "1.1", "1.2", "1.3", "1.4", "1.5", "1.6", "1.7", "1.8", "1.9", "2.0", "2.1", "2.2", "2.3", "2.4"],
// 				"data": [0.03, 0.05, 0.05, 0.05, 0.07, 0.1, 0.13, 0.16, 0.07, 0.09, 0.04, 0.03, 0.02, 0.02, 0.02, 0.01, 0.01, 0.01, 0, 0.01, 0.01, 0.01, 0.01, 0.01],
// 				"range": ["0.8", "1.2"],
// 				"desc": "38%吸呼比都集中在0.8～1.2之间，没有异常",
// 				"descLabel": "·38%吸呼比都集中在0.8～1.2之间，没有异常",
// 				"descAnimation": "由您吸呼比分布如图可见，38%吸呼比都集中在0.8～1.2之间，没有异常"
// 			},
// 			"secretsInExRatioDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["0.8", "0.6", "0.7", "0.8", "0.8", "1.0", "0.8", "0.8", "0.8", "0.7", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8"],
// 				"range": [0.63, 0.97],
// 				"desc": "吸呼比整体表现比较稳定",
// 				"descLabel": "·吸呼比整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsInExRatioDeviate": {
// 				"desc": "最近30天里有2天的吸呼比和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的吸呼比和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "03月23日",
// 					"value": "1.0"
// 				}, {
// 					"date": "03月19日",
// 					"value": "0.6"
// 				}]
// 			},
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的呼吸情况整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"conclusionLabel": "基于以上，您的呼吸情况整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"recommend": null,
// 				"recommendLabel": null
// 			},
// 			"hasOccurPrfList": null
// 		},
// 		"bodyMoveInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsBodyMoveIndex": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"],
// 				"data": [0, 0, 0, 0, 0.03, 0.03, 0.07, 0.1, 0.13, 0.63],
// 				"range": ["20", "80"],
// 				"desc": "76%体动指数都集中在80以上，有点偏高",
// 				"descLabel": "·76%体动指数都集中在80以上，有点偏高",
// 				"descAnimation": "由您体动指数分布图可见，76%体动指数都集中在80以上，是睡眠不踏实的表现，这可能跟一些潜在的呼吸慢性病导致的睡眠障碍、失眠相关，或者跟睡前服用某些药物或饮品的刺激相关"
// 			},
// 			"secretsBodyMoveIndexDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["95", "93", "100", "79", "93", "100", "79", "100", "100", "56", "100", "82", "100", "61", "100", "42", "100", "88", "87", "100", "100", "89", "72", "100", "100", "100", "99", "66", "94", "100"],
// 				"range": [58, 100],
// 				"desc": "体动整体表现比较稳定",
// 				"descLabel": "·体动整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsBodyMoveIndexDayDeviate": {
// 				"desc": "最近30天里有2天的体动指数和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的体动指数和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "04月02日",
// 					"value": "42"
// 				}, {
// 					"date": "03月27日",
// 					"value": "56"
// 				}]
// 			},
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您具有睡眠不踏实的表现，这可能跟一些潜在的呼吸慢性病导致的睡眠障碍、失眠相关，或者跟睡前服用某些药物或饮品的刺激相关。",
// 				"conclusionLabel": "基于以上，您具有<Tab_Warning_Text_R>睡眠不踏实</Tab_Warning_Text_R>的表现，这可能跟一些潜在的呼吸慢性病导致的睡眠障碍、失眠相关，或者跟睡前服用某些药物或饮品的刺激相关。",
// 				"recommend": "睡前2小时不要喝咖啡或酒，不要过度饮水，控制一下饮食\n尝试练习冥想、瑜伽等方式，减少焦虑和压力，有助于改善睡眠质量\n如已患有明确的呼吸疾病、内分泌疾病等，请遵循医嘱治疗改善\n可以持续观察数据的变化，如果依然没有改善，并持续加重并开始伴随其他症状，如体温上升、头晕等，请尽快就医。",
// 				"recommendLabel": {
// 					"recommendList": [{
// 						"imageType": "1",
// 						"recommend": "睡前2小时不要喝咖啡或酒，不要过度饮水，控制一下饮食"
// 					}, {
// 						"imageType": "4",
// 						"recommend": "尝试练习冥想、瑜伽等方式，减少焦虑和压力，有助于改善睡眠质量"
// 					}, {
// 						"imageType": "3",
// 						"recommend": "如已患有明确的呼吸疾病、内分泌疾病等，请遵循医嘱治疗改善"
// 					}],
// 					"recommend": "可以持续观察数据的变化，如果依然没有改善，并持续加重并开始伴随其他症状，如体温上升、头晕等，请尽快就医。"
// 				}
// 			},
// 			"hasOccurPrfList": [{
// 				"dimension": 2,
// 				"realValue": "睡眠不踏实",
// 				"conclusion": "睡眠**",
// 				"times": 3,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}]
// 		},
// 		"heartInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": {
// 				"accDays": 39,
// 				"remainDays": 16,
// 				"totalDays": 55
// 			},
// 			"unSecretsData": {
// 				"data": [{
// 					"date": "03-09",
// 					"min": "54",
// 					"median": "61",
// 					"max": "83"
// 				}, {
// 					"date": "03-10",
// 					"min": "48",
// 					"median": "55",
// 					"max": "65"
// 				}, {
// 					"date": "03-11",
// 					"min": "48",
// 					"median": "57",
// 					"max": "73"
// 				}, {
// 					"date": "03-12",
// 					"min": "45",
// 					"median": "53",
// 					"max": "63"
// 				}, {
// 					"date": "03-13",
// 					"min": "49",
// 					"median": "59",
// 					"max": "75"
// 				}, {
// 					"date": "03-14",
// 					"min": "60",
// 					"median": "68",
// 					"max": "81"
// 				}, {
// 					"date": "03-15",
// 					"min": "56",
// 					"median": "67",
// 					"max": "79"
// 				}, {
// 					"date": "03-16",
// 					"min": "46",
// 					"median": "54",
// 					"max": "80"
// 				}, {
// 					"date": "03-17",
// 					"min": "51",
// 					"median": "60",
// 					"max": "74"
// 				}, {
// 					"date": "03-18",
// 					"min": "43",
// 					"median": "52",
// 					"max": "76"
// 				}, {
// 					"date": "03-19",
// 					"min": "46",
// 					"median": "56",
// 					"max": "76"
// 				}, {
// 					"date": "03-20",
// 					"min": "52",
// 					"median": "60",
// 					"max": "72"
// 				}, {
// 					"date": "03-21",
// 					"min": "43",
// 					"median": "51",
// 					"max": "62"
// 				}, {
// 					"date": "03-22",
// 					"min": "56",
// 					"median": "65",
// 					"max": "75"
// 				}, {
// 					"date": "03-23",
// 					"min": "52",
// 					"median": "60",
// 					"max": "71"
// 				}, {
// 					"date": "03-24",
// 					"min": "51",
// 					"median": "60",
// 					"max": "79"
// 				}, {
// 					"date": "03-25",
// 					"min": "64",
// 					"median": "73",
// 					"max": "85"
// 				}, {
// 					"date": "03-26",
// 					"min": "58",
// 					"median": "66",
// 					"max": "82"
// 				}, {
// 					"date": "03-27",
// 					"min": "56",
// 					"median": "62",
// 					"max": "79"
// 				}, {
// 					"date": "03-28",
// 					"min": "55",
// 					"median": "67",
// 					"max": "84"
// 				}, {
// 					"date": "03-29",
// 					"min": "55",
// 					"median": "63",
// 					"max": "82"
// 				}, {
// 					"date": "03-30",
// 					"min": "56",
// 					"median": "66",
// 					"max": "77"
// 				}, {
// 					"date": "03-31",
// 					"min": "56",
// 					"median": "63",
// 					"max": "78"
// 				}, {
// 					"date": "04-01",
// 					"min": "60",
// 					"median": "70",
// 					"max": "80"
// 				}, {
// 					"date": "04-02",
// 					"min": "58",
// 					"median": "64",
// 					"max": "77"
// 				}, {
// 					"date": "04-03",
// 					"min": "56",
// 					"median": "64",
// 					"max": "74"
// 				}, {
// 					"date": "04-04",
// 					"min": "51",
// 					"median": "60",
// 					"max": "85"
// 				}, {
// 					"date": "04-05",
// 					"min": "51",
// 					"median": "62",
// 					"max": "79"
// 				}, {
// 					"date": "04-06",
// 					"min": "59",
// 					"median": "67",
// 					"max": "76"
// 				}, {
// 					"date": "04-07",
// 					"min": "59",
// 					"median": "67",
// 					"max": "79"
// 				}, {
// 					"date": "04-08",
// 					"min": "58",
// 					"median": "65",
// 					"max": "76"
// 				}, {
// 					"date": "04-09",
// 					"min": "48",
// 					"median": "68",
// 					"max": "82"
// 				}, {
// 					"date": "04-10",
// 					"min": "52",
// 					"median": "62",
// 					"max": "73"
// 				}, {
// 					"date": "04-11",
// 					"min": "59",
// 					"median": "67",
// 					"max": "81"
// 				}, {
// 					"date": "04-12",
// 					"min": "59",
// 					"median": "67",
// 					"max": "84"
// 				}, {
// 					"date": "04-13",
// 					"min": "66",
// 					"median": "73",
// 					"max": "88"
// 				}, {
// 					"date": "04-14",
// 					"min": "55",
// 					"median": "62",
// 					"max": "76"
// 				}, {
// 					"date": "04-15",
// 					"min": "55",
// 					"median": "63",
// 					"max": "81"
// 				}, {
// 					"date": "今日",
// 					"min": "59",
// 					"median": "66",
// 					"max": "77"
// 				}],
// 				"desc": "我们现在对您还不够熟悉，再有16晚睡眠，我们就能看到您的大致情况咯，继续坚持使用设备守护哦",
// 				"descLabel": "·我们现在对您还不够熟悉，再有16晚睡眠，我们就能看到您的大致情况咯，继续坚持使用设备守护哦"
// 			},
// 			"deviateTheDay": null,
// 			"secretsHeart": null,
// 			"secretsHeartDay": null,
// 			"secretsHeartDeviate": null,
// 			"conclusionRecommend": null,
// 			"hasOccurPrfList": null
// 		},
// 		"dailyRoutineInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsDailyRoutine": {
// 				"data": [{
// 					"date": "03-18",
// 					"getBed": "20:00",
// 					"sleepSt": "20:27",
// 					"sleepEd": "04:54",
// 					"leaveBed": "07:57"
// 				}, {
// 					"date": "03-19",
// 					"getBed": "20:00",
// 					"sleepSt": "21:08",
// 					"sleepEd": "05:50",
// 					"leaveBed": "06:53"
// 				}, {
// 					"date": "03-20",
// 					"getBed": "20:00",
// 					"sleepSt": "20:40",
// 					"sleepEd": "06:51",
// 					"leaveBed": "06:59"
// 				}, {
// 					"date": "03-21",
// 					"getBed": "23:08",
// 					"sleepSt": "23:40",
// 					"sleepEd": "06:49",
// 					"leaveBed": "07:01"
// 				}, {
// 					"date": "03-22",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "05:55",
// 					"leaveBed": "06:58"
// 				}, {
// 					"date": "03-23",
// 					"getBed": "01:31",
// 					"sleepSt": "03:01",
// 					"sleepEd": "06:42",
// 					"leaveBed": "06:55"
// 				}, {
// 					"date": "03-24",
// 					"getBed": "20:00",
// 					"sleepSt": "20:09",
// 					"sleepEd": "08:00",
// 					"leaveBed": "08:00"
// 				}, {
// 					"date": "03-25",
// 					"getBed": "20:00",
// 					"sleepSt": "20:37",
// 					"sleepEd": "06:11",
// 					"leaveBed": "06:34"
// 				}, {
// 					"date": "03-26",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "07:23",
// 					"leaveBed": "07:44"
// 				}, {
// 					"date": "03-27",
// 					"getBed": "00:02",
// 					"sleepSt": "00:07",
// 					"sleepEd": "07:04",
// 					"leaveBed": "07:21"
// 				}, {
// 					"date": "03-28",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "07:26",
// 					"leaveBed": "07:33"
// 				}, {
// 					"date": "03-29",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "06:47",
// 					"leaveBed": "07:17"
// 				}, {
// 					"date": "03-30",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "07:12",
// 					"leaveBed": "07:20"
// 				}, {
// 					"date": "03-31",
// 					"getBed": "20:00",
// 					"sleepSt": "21:09",
// 					"sleepEd": "06:22",
// 					"leaveBed": "06:46"
// 				}, {
// 					"date": "04-01",
// 					"getBed": "20:34",
// 					"sleepSt": "21:43",
// 					"sleepEd": "07:04",
// 					"leaveBed": "07:30"
// 				}, {
// 					"date": "04-02",
// 					"getBed": "20:00",
// 					"sleepSt": "20:03",
// 					"sleepEd": "07:03",
// 					"leaveBed": "07:13"
// 				}, {
// 					"date": "04-03",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "04:52",
// 					"leaveBed": "05:36"
// 				}, {
// 					"date": "04-04",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "05:08",
// 					"leaveBed": "07:26"
// 				}, {
// 					"date": "04-05",
// 					"getBed": "20:00",
// 					"sleepSt": "20:25",
// 					"sleepEd": "05:32",
// 					"leaveBed": "07:28"
// 				}, {
// 					"date": "04-06",
// 					"getBed": "20:00",
// 					"sleepSt": "23:17",
// 					"sleepEd": "05:38",
// 					"leaveBed": "07:35"
// 				}, {
// 					"date": "04-07",
// 					"getBed": "20:00",
// 					"sleepSt": "20:18",
// 					"sleepEd": "06:11",
// 					"leaveBed": "06:49"
// 				}, {
// 					"date": "04-08",
// 					"getBed": "20:31",
// 					"sleepSt": "21:20",
// 					"sleepEd": "06:11",
// 					"leaveBed": "06:17"
// 				}, {
// 					"date": "04-09",
// 					"getBed": "20:00",
// 					"sleepSt": "20:47",
// 					"sleepEd": "06:13",
// 					"leaveBed": "08:00"
// 				}, {
// 					"date": "04-10",
// 					"getBed": "20:00",
// 					"sleepSt": "20:38",
// 					"sleepEd": "04:46",
// 					"leaveBed": "06:05"
// 				}, {
// 					"date": "04-11",
// 					"getBed": "20:00",
// 					"sleepSt": "23:47",
// 					"sleepEd": "06:12",
// 					"leaveBed": "06:50"
// 				}, {
// 					"date": "04-12",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "05:20",
// 					"leaveBed": "05:47"
// 				}, {
// 					"date": "04-13",
// 					"getBed": "20:00",
// 					"sleepSt": "22:32",
// 					"sleepEd": "05:47",
// 					"leaveBed": "06:04"
// 				}, {
// 					"date": "04-14",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "05:57",
// 					"leaveBed": "06:16"
// 				}, {
// 					"date": "04-15",
// 					"getBed": "20:00",
// 					"sleepSt": "20:33",
// 					"sleepEd": "05:31",
// 					"leaveBed": "06:26"
// 				}, {
// 					"date": "今日",
// 					"getBed": "20:58",
// 					"sleepSt": "21:19",
// 					"sleepEd": "04:55",
// 					"leaveBed": "06:59"
// 				}],
// 				"timeRange": ["20:00", "08:00"],
// 				"highFreTime": {
// 					"getBedSt": null,
// 					"getBedEd": null,
// 					"sleepStSt": null,
// 					"sleepStEd": null,
// 					"sleepEdSt": null,
// 					"sleepEdEd": null,
// 					"leaveBedSt": null,
// 					"leaveBedEd": null
// 				},
// 				"desc": "暂时没有特别规律的作息时间，可以尝试规律作息，提高睡眠质量",
// 				"descLabel": "·暂时没有特别规律的作息时间，可以尝试规律作息，提高睡眠质量",
// 				"descAnimation": "由您作息时间点分布图可见，暂时没有特别规律的作息时间，可以尝试规律作息，提高睡眠质量"
// 			},
// 			"secretsDailyRoutineDeviate": null,
// 			"secretsSleep": {
// 				"xaxis": ["10", "20", "30", "40", "50", "60", "70", "80", "90", "100", "110", "120"],
// 				"data": [0.07, 0.2, 0.27, 0.2, 0, 0.2, 0, 0, 0.07, 0, 0],
// 				"range": ["10", "80"],
// 				"desc": "93%入睡时长都集中在10～80分钟之间，没有异常",
// 				"descLabel": "·93%入睡时长都集中在10～80分钟之间，没有异常",
// 				"descAnimation": "由您入睡时长分布图可见，93%入睡时长都集中在10～80分钟之间，没有异常"
// 			},
// 			"secretsSleepDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["27", "68", "40", "32", "0", "90", "9", "37", "0", "5", "0", "0", "0", "69", "69", "3", "0", "0", "25", "197", "18", "49", "47", "38", "227", "0", "152", "0", "33", "21"],
// 				"range": [0, 121],
// 				"desc": "入睡时长有点不稳定，但无需过度担心",
// 				"descLabel": "·入睡时长有点不稳定，但无需过度担心",
// 				"descAnimation": null
// 			},
// 			"secretsSleepDayDeviate": {
// 				"desc": "最近30天里有3天的入睡时长和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>3</Text_R>天的入睡时长和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "04月13日",
// 					"value": "2小时32分钟"
// 				}, {
// 					"date": "04月11日",
// 					"value": "3小时47分钟"
// 				}, {
// 					"date": "04月06日",
// 					"value": "3小时17分钟"
// 				}]
// 			},
// 			"secretsBed": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100", "110", "120"],
// 				"data": [0.19, 0.22, 0.19, 0.11, 0.04, 0.04, 0.07, 0.04, 0, 0, 0.04, 0.07],
// 				"range": ["10", "30"],
// 				"desc": "51%起床时长都集中在10～30分钟之间，没有异常",
// 				"descLabel": "·51%起床时长都集中在10～30分钟之间，没有异常",
// 				"descAnimation": "由您起床时长分布图可见，51%起床时长都集中在10～30分钟之间，没有异常"
// 			},
// 			"secretsBedDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["183", "63", "8", "12", "63", "13", "0", "23", "21", "17", "7", "30", "8", "24", "26", "10", "44", "138", "116", "117", "38", "6", "107", "79", "38", "27", "17", "19", "55", "124"],
// 				"range": [0, 259],
// 				"desc": "起床时长整体表现比较稳定",
// 				"descLabel": "·起床时长整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsBedDayDeviate": null,
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的作息规律整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"conclusionLabel": "基于以上，您的作息规律整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"recommend": null,
// 				"recommendLabel": null
// 			},
// 			"hasOccurPrfList": [{
// 				"dimension": 4,
// 				"realValue": "高效起床人",
// 				"conclusion": "高效**",
// 				"times": 2,
// 				"isWarn": false,
// 				"isNew": false,
// 				"isNewShow": true
// 			}]
// 		},
// 		"leaveBedInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsLeaveBedTimes": {
// 				"xaxis": ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
// 				"data": [0.2, 0.47, 0.13, 0.1, 0.1, 0, 0, 0, 0, 0],
// 				"range": ["0", "3"],
// 				"desc": "90%夜间离床次数都集中0～3次，没有异常",
// 				"descLabel": "·90%夜间离床次数都集中0～3次，没有异常",
// 				"descAnimation": "由您离床次数分布图可见，90%离床次数都集中在0～3次之间，没有异常"
// 			},
// 			"secretsLeaveBedTimesDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["1", "2", "4", "0", "2", "0", "2", "1", "3", "0", "4", "1", "4", "1", "3", "0", "1", "1", "3", "0", "1", "1", "1", "1", "1", "1", "0", "1", "1", "2"],
// 				"range": [0, 3],
// 				"desc": "离床次数整体表现比较稳定",
// 				"descLabel": "·离床次数整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsLeaveBedTimesDayDeviate": {
// 				"desc": "最近30天里有3天的离床次数和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>3</Text_R>天的离床次数和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "03月30日",
// 					"value": "4次"
// 				}, {
// 					"date": "03月28日",
// 					"value": "4次"
// 				}, {
// 					"date": "03月20日",
// 					"value": "4次"
// 				}]
// 			},
// 			"secretsLeaveBedDuration": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100", "110", "120", "130", "140", "150", "160", "170", "180", "190", "200", "210", "220", "230", "240"],
// 				"data": [0.98, 0.02, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 				"range": ["0", "30"],
// 				"desc": "100%离床时长都集中在30分钟以下，没有异常",
// 				"descLabel": "·100%离床时长都集中在30分钟以下，没有异常",
// 				"descAnimation": "由您离床时长分布图可见，100%离床时长都集中在30分钟以下，没有异常"
// 			},
// 			"secretsLeaveBedDurationDeviate": {
// 				"desc": "最近30天里有2天的离床时长和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的离床时长和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "04月01日",
// 					"duration": "9分钟",
// 					"time": "03:37"
// 				}, {
// 					"date": "03月22日",
// 					"duration": "13分钟",
// 					"time": "20:49"
// 				}]
// 			},
// 			"secretsLeaveBedTimeDuration": {
// 				"referenceList": [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40],
// 				"data": [{
// 					"date": "03-18",
// 					"timeDuration": [{
// 						"timeSt": "21:43",
// 						"timeEd": "21:46",
// 						"duration": 3
// 					}]
// 				}, {
// 					"date": "03-19",
// 					"timeDuration": [{
// 						"timeSt": "22:51",
// 						"timeEd": "22:52",
// 						"duration": 1
// 					}, {
// 						"timeSt": "04:40",
// 						"timeEd": "04:42",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-20",
// 					"timeDuration": [{
// 						"timeSt": "21:40",
// 						"timeEd": "21:41",
// 						"duration": 1
// 					}, {
// 						"timeSt": "23:31",
// 						"timeEd": "23:32",
// 						"duration": 1
// 					}, {
// 						"timeSt": "02:15",
// 						"timeEd": "02:16",
// 						"duration": 1
// 					}, {
// 						"timeSt": "05:45",
// 						"timeEd": "05:46",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "03-21",
// 					"timeDuration": null
// 				}, {
// 					"date": "03-22",
// 					"timeDuration": [{
// 						"timeSt": "20:49",
// 						"timeEd": "21:02",
// 						"duration": 13
// 					}, {
// 						"timeSt": "02:43",
// 						"timeEd": "02:45",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-23",
// 					"timeDuration": null
// 				}, {
// 					"date": "03-24",
// 					"timeDuration": [{
// 						"timeSt": "21:38",
// 						"timeEd": "21:39",
// 						"duration": 1
// 					}, {
// 						"timeSt": "06:09",
// 						"timeEd": "06:11",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-25",
// 					"timeDuration": [{
// 						"timeSt": "02:09",
// 						"timeEd": "02:11",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-26",
// 					"timeDuration": [{
// 						"timeSt": "20:34",
// 						"timeEd": "20:36",
// 						"duration": 2
// 					}, {
// 						"timeSt": "23:22",
// 						"timeEd": "23:23",
// 						"duration": 1
// 					}, {
// 						"timeSt": "01:38",
// 						"timeEd": "01:39",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "03-27",
// 					"timeDuration": null
// 				}, {
// 					"date": "03-28",
// 					"timeDuration": [{
// 						"timeSt": "21:43",
// 						"timeEd": "21:44",
// 						"duration": 1
// 					}, {
// 						"timeSt": "23:28",
// 						"timeEd": "23:29",
// 						"duration": 1
// 					}, {
// 						"timeSt": "00:31",
// 						"timeEd": "00:32",
// 						"duration": 1
// 					}, {
// 						"timeSt": "06:12",
// 						"timeEd": "06:13",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "03-29",
// 					"timeDuration": [{
// 						"timeSt": "02:15",
// 						"timeEd": "02:16",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "03-30",
// 					"timeDuration": [{
// 						"timeSt": "21:56",
// 						"timeEd": "21:58",
// 						"duration": 2
// 					}, {
// 						"timeSt": "00:06",
// 						"timeEd": "00:07",
// 						"duration": 1
// 					}, {
// 						"timeSt": "02:23",
// 						"timeEd": "02:25",
// 						"duration": 2
// 					}, {
// 						"timeSt": "05:05",
// 						"timeEd": "05:07",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-31",
// 					"timeDuration": [{
// 						"timeSt": "00:19",
// 						"timeEd": "00:21",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-01",
// 					"timeDuration": [{
// 						"timeSt": "22:51",
// 						"timeEd": "22:52",
// 						"duration": 1
// 					}, {
// 						"timeSt": "23:11",
// 						"timeEd": "23:12",
// 						"duration": 1
// 					}, {
// 						"timeSt": "03:37",
// 						"timeEd": "03:46",
// 						"duration": 9
// 					}]
// 				}, {
// 					"date": "04-02",
// 					"timeDuration": null
// 				}, {
// 					"date": "04-03",
// 					"timeDuration": [{
// 						"timeSt": "00:42",
// 						"timeEd": "00:44",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-04",
// 					"timeDuration": [{
// 						"timeSt": "22:11",
// 						"timeEd": "22:13",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-05",
// 					"timeDuration": [{
// 						"timeSt": "20:57",
// 						"timeEd": "20:58",
// 						"duration": 1
// 					}, {
// 						"timeSt": "22:31",
// 						"timeEd": "22:33",
// 						"duration": 2
// 					}, {
// 						"timeSt": "01:28",
// 						"timeEd": "01:29",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "04-06",
// 					"timeDuration": null
// 				}, {
// 					"date": "04-07",
// 					"timeDuration": [{
// 						"timeSt": "00:37",
// 						"timeEd": "00:39",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-08",
// 					"timeDuration": [{
// 						"timeSt": "22:40",
// 						"timeEd": "22:42",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-09",
// 					"timeDuration": [{
// 						"timeSt": "22:46",
// 						"timeEd": "22:48",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-10",
// 					"timeDuration": [{
// 						"timeSt": "21:19",
// 						"timeEd": "21:20",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "04-11",
// 					"timeDuration": [{
// 						"timeSt": "02:41",
// 						"timeEd": "02:42",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "04-12",
// 					"timeDuration": [{
// 						"timeSt": "01:37",
// 						"timeEd": "01:39",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-13",
// 					"timeDuration": null
// 				}, {
// 					"date": "04-14",
// 					"timeDuration": [{
// 						"timeSt": "23:36",
// 						"timeEd": "23:38",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-15",
// 					"timeDuration": [{
// 						"timeSt": "22:37",
// 						"timeEd": "22:38",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "今日",
// 					"timeDuration": [{
// 						"timeSt": "23:03",
// 						"timeEd": "23:04",
// 						"duration": 1
// 					}, {
// 						"timeSt": "03:29",
// 						"timeEd": "03:31",
// 						"duration": 2
// 					}]
// 				}],
// 				"timeRange": ["20:34", "06:12"],
// 				"highFreTime": [{
// 					"timeSt": "18:53",
// 					"timeEd": "05:56",
// 					"duration": 663
// 				}],
// 				"desc": "通常会在18:53～05:56离床，没有明显异常",
// 				"descLabel": "·通常会在18:53～05:56离床，没有明显异常",
// 				"descAnimation": "由您每次离床发生的时间点和时长分布可见，您通常会在18:53～05:56离床，没有明显异常"
// 			},
// 			"secretsLeaveBedTimeDurationDeviate": {
// 				"desc": "最近30天里有2天的离床时间点和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的离床时间点和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "03月28日",
// 					"duration": "1分钟",
// 					"time": "06:12"
// 				}, {
// 					"date": "03月24日",
// 					"duration": "2分钟",
// 					"time": "06:09"
// 				}]
// 			},
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的离床整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"conclusionLabel": "基于以上，您的离床整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"recommend": null,
// 				"recommendLabel": null
// 			},
// 			"hasOccurPrfList": null
// 		},
// 		"sleepInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsSleepDuration": {
// 				"xaxis": ["120", "130", "140", "150", "160", "170", "180", "190", "200", "210", "220", "230", "240", "250", "260", "270", "280", "290", "300", "310", "320", "330", "340", "350", "360", "370", "380", "390", "400", "410", "420", "430", "440", "450", "460", "470", "480", "490", "500", "510", "520", "530", "540", "550", "560", "570", "580", "590", "600", "610", "620", "630", "640", "650", "660", "670", "680", "690", "700", "710", "720"],
// 				"data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.03, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.07, 0.07, 0, 0, 0.07, 0.1, 0.07, 0.13, 0.07, 0.03, 0, 0, 0.07, 0.03, 0, 0, 0, 0.03, 0.07, 0.03, 0, 0.03, 0.03, 0, 0.03, 0, 0, 0, 0, 0, 0, 0.03, 0, 0, 0, 0, 0, 0],
// 				"range": ["420", "540"],
// 				"desc": "33%睡眠时长都集中在7～9h之间，没有明显异常",
// 				"descLabel": "·33%睡眠时长都集中在7～9h之间，没有明显异常",
// 				"descAnimation": "由您睡眠时长分布图可见，33%睡眠时长都集中在7～9h之间，没有明显异常"
// 			},
// 			"secretsSleepDurationDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["388", "404", "478", "411", "424", "221", "530", "413", "584", "418", "411", "526", "396", "521", "347", "651", "394", "514", "403", "382", "436", "468", "559", "349", "357", "350", "390", "565", "467", "425"],
// 				"range": [220, 676],
// 				"desc": "睡眠时长有点不稳定，但无需过度担心",
// 				"descLabel": "·睡眠时长有点不稳定，但无需过度担心",
// 				"descAnimation": null
// 			},
// 			"secretsSleepDurationDayDeviate": null,
// 			"secretsSleepEfficiency": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"],
// 				"data": [0, 0, 0, 0, 0, 0.3, 0.23, 0.23, 0.13, 0.1],
// 				"range": ["60", "100"],
// 				"desc": "53%睡眠效率都集中在90%以上，这很棒",
// 				"descLabel": "·53%睡眠效率都集中在90%以上，这很棒",
// 				"descAnimation": "由您睡眠效率分布图可见，53%睡眠效率都集中在90%以上，是高效睡眠的表现，这很棒"
// 			},
// 			"secretsSleepEfficiencyDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["54", "61", "72", "86", "64", "68", "73", "65", "82", "95", "59", "77", "58", "81", "52", "96", "68", "74", "58", "57", "68", "79", "80", "57", "54", "59", "64", "91", "74", "70"],
// 				"range": [29, 100],
// 				"desc": "睡眠效率整体表现比较稳定",
// 				"descLabel": "·睡眠效率整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsSleepEfficiencyDayDeviate": null,
// 			"secretsSleepCrush": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"],
// 				"data": [0.2, 0.17, 0.07, 0.07, 0.03, 0.07, 0.07, 0.17, 0.03, 0.13],
// 				"range": ["0", "80"],
// 				"desc": "86%睡眠破碎指标都集中在20以下，这很棒",
// 				"descLabel": "·86%睡眠破碎指标都集中在20以下，这很棒",
// 				"descAnimation": "由您睡眠破碎指标分布图可见，86%睡眠破碎指标在20以下，这很棒"
// 			},
// 			"secretsSleepCrushDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["60", "57", "54", "9", "74", "0", "67", "77", "33", "0", "100", "46", "100", "12", "100", "3", "70", "13", "70", "0", "71", "26", "2", "80", "15", "100", "23", "11", "30", "14"],
// 				"range": [0, 100],
// 				"desc": "睡眠破碎指标整体表现比较稳定",
// 				"descLabel": "·睡眠破碎指标整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsSleepCrushDayDeviate": null,
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的睡眠具有高效睡眠的表现，暂无明显的异常特征。要继续保持哦～",
// 				"conclusionLabel": "基于以上，您的睡眠具有<Tab_Text_P>高效睡眠</Tab_Text_P>的表现，暂无明显的异常特征。要继续保持哦～",
// 				"recommend": null,
// 				"recommendLabel": null
// 			},
// 			"hasOccurPrfList": [{
// 				"dimension": 6,
// 				"realValue": "高效睡眠",
// 				"conclusion": "高效**",
// 				"times": 1,
// 				"isWarn": false,
// 				"isNew": true,
// 				"isNewShow": true
// 			}]
// 		},
// 		"breathInfoV2": {
// 			"clickFlag": 3,
// 			"changeNum": 1,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": {
// 				"desc": "最近一天您的呼吸率中位数是21次/分，明显和您日常的表现有较大差异",
// 				"descLabel": "<Warning/> 最近一天您的呼吸率中位数是<Text_R>21次/分</Text_R>，明显和您日常的表现有较大差异",
// 				"remindAndSuggest": "我们发现您睡眠的呼吸率和日常差异较大，身体有没有哪里不舒服？或者昨天有没有大量饮酒或者咖啡茶之类的饮品？如果没有明显的不适，可以不用放在心上，建议持续观察您的呼吸情况",
// 				"remindAndSuggestLabel": "·我们发现您睡眠的呼吸率和日常差异较大，身体有没有哪里不舒服？或者昨天有没有大量饮酒或者咖啡茶之类的饮品？如果没有明显的不适，可以不用放在心上，建议持续观察您的呼吸情况"
// 			},
// 			"secretsBreath": {
// 				"brPdfFlag": 0,
// 				"xaxis": ["18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "今"],
// 				"xaxisCn": ["18日", "19日", "20日", "21日", "22日", "23日", "24日", "25日", "26日", "27日", "28日", "29日", "30日", "31日", "01日", "02日", "03日", "04日", "05日", "06日", "07日", "08日", "09日", "10日", "11日", "12日", "13日", "14日", "15日", "今"],
// 				"data": [{
// 					"date": "18",
// 					"dateCn": "18日",
// 					"min": "16",
// 					"median": "21",
// 					"max": "28",
// 					"extendData": {
// 						"date": "03月18日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "19",
// 					"dateCn": "19日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "27",
// 					"extendData": {
// 						"date": "03月19日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "20",
// 					"dateCn": "20日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月20日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "21",
// 					"dateCn": "21日",
// 					"min": "14",
// 					"median": "21",
// 					"max": "28",
// 					"extendData": {
// 						"date": "03月21日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "22",
// 					"dateCn": "22日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月22日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "23",
// 					"dateCn": "23日",
// 					"min": "12",
// 					"median": "20",
// 					"max": "28",
// 					"extendData": {
// 						"date": "03月23日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "24",
// 					"dateCn": "24日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "25",
// 					"extendData": {
// 						"date": "03月24日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "25",
// 					"dateCn": "25日",
// 					"min": "15",
// 					"median": "21",
// 					"max": "28",
// 					"extendData": {
// 						"date": "03月25日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "26",
// 					"dateCn": "26日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月26日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "27",
// 					"dateCn": "27日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月27日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "28",
// 					"dateCn": "28日",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27",
// 					"extendData": {
// 						"date": "03月28日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "29",
// 					"dateCn": "29日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "27",
// 					"extendData": {
// 						"date": "03月29日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "30",
// 					"dateCn": "30日",
// 					"min": "15",
// 					"median": "19",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月30日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "31",
// 					"dateCn": "31日",
// 					"min": "16",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月31日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "01",
// 					"dateCn": "01日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "04月01日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "02",
// 					"dateCn": "02日",
// 					"min": "15",
// 					"median": "19",
// 					"max": "25",
// 					"extendData": {
// 						"date": "04月02日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "03",
// 					"dateCn": "03日",
// 					"min": "16",
// 					"median": "20",
// 					"max": "25",
// 					"extendData": {
// 						"date": "04月03日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "04",
// 					"dateCn": "04日",
// 					"min": "14",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "04月04日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "05",
// 					"dateCn": "05日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "28",
// 					"extendData": {
// 						"date": "04月05日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "06",
// 					"dateCn": "06日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "26",
// 					"extendData": {
// 						"date": "04月06日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "07",
// 					"dateCn": "07日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "27",
// 					"extendData": {
// 						"date": "04月07日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "08",
// 					"dateCn": "08日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "27",
// 					"extendData": {
// 						"date": "04月08日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "09",
// 					"dateCn": "09日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "28",
// 					"extendData": {
// 						"date": "04月09日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "10",
// 					"dateCn": "10日",
// 					"min": "13",
// 					"median": "19",
// 					"max": "25",
// 					"extendData": {
// 						"date": "04月10日",
// 						"deviateFlag": 1,
// 						"deviateDesc": "呼吸率表现和日常差异较大，可以关注一下",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": [0, 0, 0, 0, 0, 0, 0, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0002, 0.0002, 0.0002, 0.0003, 0.0004, 0.0004, 0.0005, 0.0007, 0.0008, 0.001, 0.0011, 0.0014, 0.0016, 0.0019, 0.0023, 0.0026, 0.0031, 0.0036, 0.0041, 0.0047, 0.0054, 0.0061, 0.0069, 0.0078, 0.0088, 0.0097, 0.0108, 0.0119, 0.0131, 0.0143, 0.0155, 0.0167, 0.018, 0.0192, 0.0204, 0.0216, 0.0227, 0.0238, 0.0248, 0.0257, 0.0265, 0.0271, 0.0277, 0.0281, 0.0284, 0.0285, 0.0285, 0.0283, 0.028, 0.0276, 0.027, 0.0263, 0.0255, 0.0246, 0.0235, 0.0225, 0.0213, 0.0201, 0.0189, 0.0177, 0.0164, 0.0152, 0.014, 0.0128, 0.0117, 0.0106, 0.0096, 0.0086, 0.0077, 0.0068, 0.006, 0.0053, 0.0047, 0.0041, 0.0035, 0.0031, 0.0026, 0.0023, 0.0019, 0.0016, 0.0014, 0.0012, 0.001, 0.0008, 0.0007, 0.0006, 0.0005, 0.0004, 0.0003, 0.0003, 0.0002, 0.0002, 0.0002, 0.0002, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": 21,
// 						"deviateBpmFocus": 21,
// 						"range": [13, 25],
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "11",
// 					"dateCn": "11日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "28",
// 					"extendData": {
// 						"date": "04月11日",
// 						"deviateFlag": 2,
// 						"deviateDesc": "",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": [0, 0, 0, 0, 0, 0, 0, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0002, 0.0002, 0.0002, 0.0003, 0.0003, 0.0004, 0.0005, 0.0006, 0.0007, 0.0008, 0.001, 0.0012, 0.0014, 0.0017, 0.002, 0.0023, 0.0027, 0.0031, 0.0036, 0.0041, 0.0047, 0.0053, 0.006, 0.0067, 0.0075, 0.0084, 0.0092, 0.0102, 0.0112, 0.0122, 0.0132, 0.0142, 0.0153, 0.0164, 0.0174, 0.0185, 0.0195, 0.0204, 0.0214, 0.0222, 0.023, 0.0237, 0.0244, 0.0249, 0.0254, 0.0257, 0.026, 0.0261, 0.0261, 0.026, 0.0258, 0.0255, 0.0251, 0.0246, 0.024, 0.0234, 0.0226, 0.0218, 0.0209, 0.02, 0.019, 0.018, 0.017, 0.0159, 0.0149, 0.0139, 0.0128, 0.0118, 0.0109, 0.0099, 0.009, 0.0082, 0.0074, 0.0066, 0.0059, 0.0053, 0.0047, 0.0041, 0.0036, 0.0032, 0.0028, 0.0024, 0.0021, 0.0018, 0.0015, 0.0013, 0.0011, 0.001, 0.0008, 0.0007, 0.0006, 0.0006, 0.0005, 0.0004, 0.0004, 0.0004, 0.0003, 0.0003, 0.0003, 0.0003, 0.0003, 0.0003, 0.0003, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": 22,
// 						"deviateBpmFocus": 22,
// 						"range": [14, 28],
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "12",
// 					"dateCn": "12日",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27",
// 					"extendData": {
// 						"date": "04月12日",
// 						"deviateFlag": 1,
// 						"deviateDesc": "呼吸率表现和日常差异较大，可以关注一下",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0002, 0.0002, 0.0002, 0.0003, 0.0004, 0.0005, 0.0006, 0.0007, 0.0008, 0.001, 0.0012, 0.0014, 0.0017, 0.002, 0.0024, 0.0028, 0.0033, 0.0038, 0.0045, 0.0051, 0.0059, 0.0067, 0.0076, 0.0086, 0.0096, 0.0108, 0.0119, 0.0132, 0.0144, 0.0157, 0.0171, 0.0184, 0.0197, 0.021, 0.0223, 0.0235, 0.0246, 0.0256, 0.0266, 0.0274, 0.028, 0.0286, 0.029, 0.0292, 0.0292, 0.0291, 0.0289, 0.0285, 0.0279, 0.0273, 0.0265, 0.0255, 0.0245, 0.0234, 0.0223, 0.021, 0.0198, 0.0185, 0.0173, 0.016, 0.0147, 0.0135, 0.0124, 0.0112, 0.0102, 0.0091, 0.0082, 0.0073, 0.0065, 0.0057, 0.005, 0.0044, 0.0039, 0.0033, 0.0029, 0.0025, 0.0021, 0.0018, 0.0015, 0.0013, 0.0011, 0.0009, 0.0008, 0.0006, 0.0005, 0.0004, 0.0004, 0.0003, 0.0002, 0.0002, 0.0002, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": 21,
// 						"deviateBpmFocus": 21,
// 						"range": [14, 27],
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "13",
// 					"dateCn": "13日",
// 					"min": "15",
// 					"median": "21",
// 					"max": "26",
// 					"extendData": {
// 						"date": "04月13日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "14",
// 					"dateCn": "14日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "25",
// 					"extendData": {
// 						"date": "04月14日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "15",
// 					"dateCn": "15日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "28",
// 					"extendData": {
// 						"date": "04月15日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "今",
// 					"dateCn": "今",
// 					"min": "14",
// 					"median": "19",
// 					"max": "27",
// 					"extendData": {
// 						"date": "04月16日（今日）",
// 						"deviateFlag": 1,
// 						"deviateDesc": "呼吸率表现和日常差异较大，可以关注一下",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0002, 0.0002, 0.0003, 0.0003, 0.0004, 0.0005, 0.0006, 0.0007, 0.0009, 0.0011, 0.0013, 0.0015, 0.0018, 0.0022, 0.0026, 0.0031, 0.0036, 0.0042, 0.0049, 0.0056, 0.0064, 0.0073, 0.0083, 0.0094, 0.0105, 0.0117, 0.013, 0.0143, 0.0157, 0.0171, 0.0185, 0.0199, 0.0212, 0.0226, 0.0239, 0.0251, 0.0262, 0.0272, 0.028, 0.0288, 0.0293, 0.0298, 0.03, 0.0301, 0.03, 0.0297, 0.0293, 0.0287, 0.0279, 0.0271, 0.0261, 0.025, 0.0238, 0.0225, 0.0212, 0.0199, 0.0186, 0.0172, 0.0159, 0.0146, 0.0133, 0.0121, 0.0109, 0.0098, 0.0088, 0.0078, 0.0069, 0.0061, 0.0053, 0.0046, 0.004, 0.0035, 0.003, 0.0026, 0.0022, 0.0019, 0.0016, 0.0013, 0.0011, 0.0009, 0.0008, 0.0006, 0.0005, 0.0004, 0.0003, 0.0003, 0.0002, 0.0002, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": 21,
// 						"deviateBpmFocus": 21,
// 						"range": [14, 27],
// 						"normalBpm": 25
// 					}
// 				}],
// 				"desc": "呼吸率日常表现多集中在25次/分左右，有点偏快",
// 				"descLabel": "·呼吸率日常表现多集中在25次/分左右，有点偏快"
// 			},
// 			"secretsBreathDeviate": {
// 				"desc": "最近30天里有3天的呼吸率中位数和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>3</Text_R>天的呼吸率中位数和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "04月10日",
// 					"value": "21次/分"
// 				}, {
// 					"date": "04月12日",
// 					"value": "21次/分"
// 				}, {
// 					"date": "04月16日",
// 					"value": "21次/分"
// 				}]
// 			},
// 			"secretsInExRatio": {
// 				"xaxis": ["0.1", "0.2", "0.3", "0.4", "0.5", "0.6", "0.7", "0.8", "0.9", "1.0", "1.1", "1.2", "1.3", "1.4", "1.5", "1.6", "1.7", "1.8", "1.9", "2.0", "2.1", "2.2", "2.3", "2.4"],
// 				"data": [0.03, 0.05, 0.05, 0.05, 0.07, 0.1, 0.13, 0.16, 0.07, 0.09, 0.04, 0.03, 0.02, 0.02, 0.02, 0.01, 0.01, 0.01, 0, 0.01, 0.01, 0.01, 0.01, 0.01],
// 				"range": ["0.8", "1.2"],
// 				"desc": "38%吸呼比都集中在0.8～1.2之间，没有异常",
// 				"descLabel": "·38%吸呼比都集中在0.8～1.2之间，没有异常",
// 				"descAnimation": "由您吸呼比分布如图可见，38%吸呼比都集中在0.8～1.2之间，没有异常"
// 			},
// 			"secretsInExRatioDeviate": {
// 				"desc": "最近30天里有2天的吸呼比和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的吸呼比和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "03月23日",
// 					"value": "1.0"
// 				}, {
// 					"date": "03月19日",
// 					"value": "0.6"
// 				}]
// 			},
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的呼吸具有呼吸急促的表现，这可能跟一些潜在的身体不适相关，有出现嗜睡、疲劳、头痛的几率。",
// 				"conclusionLabel": "基于以上，您的呼吸具有<Tab_Warning_Text_R>呼吸急促</Tab_Warning_Text_R>的表现，这可能跟一些潜在的身体不适相关，有出现嗜睡、疲劳、头痛的几率。",
// 				"recommend": "合理饮食，控制体重，远离烟酒\n每周坚持3～5次30分钟有氧运动，放松心情，释放压力\n如果存在呼吸道感染或哮喘等疾病，需要按照医生建议进行治疗和管理\n可以观察数据的变化，如果持续加重并伴随其他症状，如胸痛、发热等，请尽快就医。",
// 				"recommendLabel": {
// 					"recommendList": [{
// 						"imageType": "1",
// 						"recommend": "合理饮食，控制体重，远离烟酒"
// 					}, {
// 						"imageType": "2",
// 						"recommend": "每周坚持3～5次30分钟有氧运动，放松心情，释放压力"
// 					}, {
// 						"imageType": "3",
// 						"recommend": "如果存在呼吸道感染或哮喘等疾病，需要按照医生建议进行治疗和管理"
// 					}],
// 					"recommend": "可以观察数据的变化，如果持续加重并伴随其他症状，如胸痛、发热等，请尽快就医。"
// 				}
// 			},
// 			"hasOccurPrfList": [{
// 				"dimension": 1,
// 				"realValue": "呼吸急促",
// 				"conclusion": "呼吸**",
// 				"times": 1,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}]
// 		}
// 	}
// }

// res = {
// 	"code": 0,
// 	"msg": null,
// 	"data": {
// 		"lastDate": "2024-04-16",
// 		"isStart": true,
// 		"buAndFlName": "浙江福康通智慧养老-1层-2房-5号",
// 		"summarize": "呼吸具有<Tab_Warning_Text_R>呼吸急促</Tab_Warning_Text_R>的表现，体动具有<Tab_Warning_Text_R>睡眠不踏实</Tab_Warning_Text_R>的表现，睡眠具有<Tab_Text_P>高效睡眠</Tab_Text_P>的表现，心跳、作息规律、夜间离床整体表现正常，暂无明显特征",
// 		"changeNum": 1,
// 		"twinInfoVo": {
// 			"isUnlock": true,
// 			"sex": "0",
// 			"ageGroup": "0",
// 			"integralDetails": {
// 				"sleepTotalScore": 2907,
// 				"sleepTotalTimes": 39,
// 				"sleepTotalLen": 293,
// 				"breTotalTimes": 758849,
// 				"heartTotalTimes": 2431330,
// 				"hasOccurPrfList": [{
// 					"dimension": 2,
// 					"realValue": "睡眠不踏实",
// 					"conclusion": "睡眠**",
// 					"times": 3,
// 					"isWarn": true,
// 					"isNew": true,
// 					"isNewShow": true
// 				}, {
// 					"dimension": 4,
// 					"realValue": "高效起床人",
// 					"conclusion": "高效**",
// 					"times": 2,
// 					"isWarn": false,
// 					"isNew": false,
// 					"isNewShow": true
// 				}, {
// 					"dimension": 6,
// 					"realValue": "高效睡眠",
// 					"conclusion": "高效**",
// 					"times": 1,
// 					"isWarn": false,
// 					"isNew": true,
// 					"isNewShow": true
// 				}]
// 			},
// 			"scrollingTextList": [{
// 				"text": "持续使用设备守护您的睡眠，您的画像会与您保持同步，并及时发现潜在问题",
// 				"times": 1
// 			}],
// 			"hasOccurPrfNewList": [{
// 				"dimension": 2,
// 				"realValue": "睡眠不踏实",
// 				"conclusion": "睡眠**",
// 				"times": 3,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}, {
// 				"dimension": 6,
// 				"realValue": "高效睡眠",
// 				"conclusion": "高效**",
// 				"times": 1,
// 				"isWarn": false,
// 				"isNew": true,
// 				"isNewShow": true
// 			}],
// 			"hasOccurPrfNewV2List": [{
// 				"dimension": 1,
// 				"realValue": "呼吸急促",
// 				"conclusion": "呼吸**",
// 				"times": 1,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}, {
// 				"dimension": 2,
// 				"realValue": "睡眠不踏实",
// 				"conclusion": "睡眠**",
// 				"times": 3,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}, {
// 				"dimension": 6,
// 				"realValue": "高效睡眠",
// 				"conclusion": "高效**",
// 				"times": 1,
// 				"isWarn": false,
// 				"isNew": true,
// 				"isNewShow": true
// 			}]
// 		},
// 		"breathInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsBreath": {
// 				"xaxis": ["5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38"],
// 				"data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.01, 0.01, 0.03, 0.1, 0.2, 0.22, 0.19, 0.13, 0.07, 0.02, 0.01, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 				"range": ["13", "21"],
// 				"desc": "75%呼吸率都集中在13～21次/分之间，没有异常",
// 				"descLabel": "·75%呼吸率都集中在13～21次/分之间，没有异常",
// 				"descAnimation": "由您呼吸率分布图可见，75%的呼吸率都集中在13～21次/分之间，没有异常"
// 			},
// 			"secretsBreathDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": [{
// 					"date": "03-18",
// 					"min": "16",
// 					"median": "22",
// 					"max": "28"
// 				}, {
// 					"date": "03-19",
// 					"min": "15",
// 					"median": "21",
// 					"max": "27"
// 				}, {
// 					"date": "03-20",
// 					"min": "15",
// 					"median": "21",
// 					"max": "26"
// 				}, {
// 					"date": "03-21",
// 					"min": "14",
// 					"median": "21",
// 					"max": "28"
// 				}, {
// 					"date": "03-22",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "03-23",
// 					"min": "12",
// 					"median": "21",
// 					"max": "28"
// 				}, {
// 					"date": "03-24",
// 					"min": "14",
// 					"median": "20",
// 					"max": "25"
// 				}, {
// 					"date": "03-25",
// 					"min": "15",
// 					"median": "21",
// 					"max": "28"
// 				}, {
// 					"date": "03-26",
// 					"min": "14",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "03-27",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "03-28",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27"
// 				}, {
// 					"date": "03-29",
// 					"min": "15",
// 					"median": "20",
// 					"max": "27"
// 				}, {
// 					"date": "03-30",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "03-31",
// 					"min": "16",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "04-01",
// 					"min": "15",
// 					"median": "21",
// 					"max": "26"
// 				}, {
// 					"date": "04-02",
// 					"min": "15",
// 					"median": "20",
// 					"max": "25"
// 				}, {
// 					"date": "04-03",
// 					"min": "16",
// 					"median": "21",
// 					"max": "25"
// 				}, {
// 					"date": "04-04",
// 					"min": "14",
// 					"median": "21",
// 					"max": "26"
// 				}, {
// 					"date": "04-05",
// 					"min": "15",
// 					"median": "21",
// 					"max": "28"
// 				}, {
// 					"date": "04-06",
// 					"min": "14",
// 					"median": "20",
// 					"max": "26"
// 				}, {
// 					"date": "04-07",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27"
// 				}, {
// 					"date": "04-08",
// 					"min": "14",
// 					"median": "19",
// 					"max": "27"
// 				}, {
// 					"date": "04-09",
// 					"min": "14",
// 					"median": "20",
// 					"max": "28"
// 				}, {
// 					"date": "04-10",
// 					"min": "13",
// 					"median": "20",
// 					"max": "25"
// 				}, {
// 					"date": "04-11",
// 					"min": "14",
// 					"median": "20",
// 					"max": "28"
// 				}, {
// 					"date": "04-12",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27"
// 				}, {
// 					"date": "04-13",
// 					"min": "15",
// 					"median": "21",
// 					"max": "26"
// 				}, {
// 					"date": "04-14",
// 					"min": "14",
// 					"median": "19",
// 					"max": "25"
// 				}, {
// 					"date": "04-15",
// 					"min": "14",
// 					"median": "19",
// 					"max": "28"
// 				}, {
// 					"date": "今日",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27"
// 				}],
// 				"range": [18, 23],
// 				"desc": "呼吸率中位数整体表现比较稳定",
// 				"descLabel": "·呼吸率中位数整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsBreathDeviate": null,
// 			"secretsInExRatio": {
// 				"xaxis": ["0.1", "0.2", "0.3", "0.4", "0.5", "0.6", "0.7", "0.8", "0.9", "1.0", "1.1", "1.2", "1.3", "1.4", "1.5", "1.6", "1.7", "1.8", "1.9", "2.0", "2.1", "2.2", "2.3", "2.4"],
// 				"data": [0.03, 0.05, 0.05, 0.05, 0.07, 0.1, 0.13, 0.16, 0.07, 0.09, 0.04, 0.03, 0.02, 0.02, 0.02, 0.01, 0.01, 0.01, 0, 0.01, 0.01, 0.01, 0.01, 0.01],
// 				"range": ["0.8", "1.2"],
// 				"desc": "38%吸呼比都集中在0.8～1.2之间，没有异常",
// 				"descLabel": "·38%吸呼比都集中在0.8～1.2之间，没有异常",
// 				"descAnimation": "由您吸呼比分布如图可见，38%吸呼比都集中在0.8～1.2之间，没有异常"
// 			},
// 			"secretsInExRatioDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["0.8", "0.6", "0.7", "0.8", "0.8", "1.0", "0.8", "0.8", "0.8", "0.7", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8", "0.8"],
// 				"range": [0.63, 0.97],
// 				"desc": "吸呼比整体表现比较稳定",
// 				"descLabel": "·吸呼比整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsInExRatioDeviate": {
// 				"desc": "最近30天里有2天的吸呼比和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的吸呼比和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "03月23日",
// 					"value": "1.0"
// 				}, {
// 					"date": "03月19日",
// 					"value": "0.6"
// 				}]
// 			},
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的呼吸情况整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"conclusionLabel": "基于以上，您的呼吸情况整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"recommend": null,
// 				"recommendLabel": null
// 			},
// 			"hasOccurPrfList": null
// 		},
// 		"bodyMoveInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsBodyMoveIndex": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"],
// 				"data": [0, 0, 0, 0, 0.03, 0.03, 0.07, 0.1, 0.13, 0.63],
// 				"range": ["20", "80"],
// 				"desc": "76%体动指数都集中在80以上，有点偏高",
// 				"descLabel": "·76%体动指数都集中在80以上，有点偏高",
// 				"descAnimation": "由您体动指数分布图可见，76%体动指数都集中在80以上，是睡眠不踏实的表现，这可能跟一些潜在的呼吸慢性病导致的睡眠障碍、失眠相关，或者跟睡前服用某些药物或饮品的刺激相关"
// 			},
// 			"secretsBodyMoveIndexDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["95", "93", "100", "79", "93", "100", "79", "100", "100", "56", "100", "82", "100", "61", "100", "42", "100", "88", "87", "100", "100", "89", "72", "100", "100", "100", "99", "66", "94", "100"],
// 				"range": [58, 100],
// 				"desc": "体动整体表现比较稳定",
// 				"descLabel": "·体动整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsBodyMoveIndexDayDeviate": {
// 				"desc": "最近30天里有2天的体动指数和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的体动指数和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "04月02日",
// 					"value": "42"
// 				}, {
// 					"date": "03月27日",
// 					"value": "56"
// 				}]
// 			},
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您具有睡眠不踏实的表现，这可能跟一些潜在的呼吸慢性病导致的睡眠障碍、失眠相关，或者跟睡前服用某些药物或饮品的刺激相关。",
// 				"conclusionLabel": "基于以上，您具有<Tab_Warning_Text_R>睡眠不踏实</Tab_Warning_Text_R>的表现，这可能跟一些潜在的呼吸慢性病导致的睡眠障碍、失眠相关，或者跟睡前服用某些药物或饮品的刺激相关。",
// 				"recommend": "睡前2小时不要喝咖啡或酒，不要过度饮水，控制一下饮食\n尝试练习冥想、瑜伽等方式，减少焦虑和压力，有助于改善睡眠质量\n如已患有明确的呼吸疾病、内分泌疾病等，请遵循医嘱治疗改善\n可以持续观察数据的变化，如果依然没有改善，并持续加重并开始伴随其他症状，如体温上升、头晕等，请尽快就医。",
// 				"recommendLabel": {
// 					"recommendList": [{
// 						"imageType": "1",
// 						"recommend": "睡前2小时不要喝咖啡或酒，不要过度饮水，控制一下饮食"
// 					}, {
// 						"imageType": "4",
// 						"recommend": "尝试练习冥想、瑜伽等方式，减少焦虑和压力，有助于改善睡眠质量"
// 					}, {
// 						"imageType": "3",
// 						"recommend": "如已患有明确的呼吸疾病、内分泌疾病等，请遵循医嘱治疗改善"
// 					}],
// 					"recommend": "可以持续观察数据的变化，如果依然没有改善，并持续加重并开始伴随其他症状，如体温上升、头晕等，请尽快就医。"
// 				}
// 			},
// 			"hasOccurPrfList": [{
// 				"dimension": 2,
// 				"realValue": "睡眠不踏实",
// 				"conclusion": "睡眠**",
// 				"times": 3,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}]
// 		},
// 		"heartInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": {
// 				"accDays": 39,
// 				"remainDays": 16,
// 				"totalDays": 55
// 			},
// 			"unSecretsData": {
// 				"data": [{
// 					"date": "03-09",
// 					"min": "54",
// 					"median": "61",
// 					"max": "83"
// 				}, {
// 					"date": "03-10",
// 					"min": "48",
// 					"median": "55",
// 					"max": "65"
// 				}, {
// 					"date": "03-11",
// 					"min": "48",
// 					"median": "57",
// 					"max": "73"
// 				}, {
// 					"date": "03-12",
// 					"min": "45",
// 					"median": "53",
// 					"max": "63"
// 				}, {
// 					"date": "03-13",
// 					"min": "49",
// 					"median": "59",
// 					"max": "75"
// 				}, {
// 					"date": "03-14",
// 					"min": "60",
// 					"median": "68",
// 					"max": "81"
// 				}, {
// 					"date": "03-15",
// 					"min": "56",
// 					"median": "67",
// 					"max": "79"
// 				}, {
// 					"date": "03-16",
// 					"min": "46",
// 					"median": "54",
// 					"max": "80"
// 				}, {
// 					"date": "03-17",
// 					"min": "51",
// 					"median": "60",
// 					"max": "74"
// 				}, {
// 					"date": "03-18",
// 					"min": "43",
// 					"median": "52",
// 					"max": "76"
// 				}, {
// 					"date": "03-19",
// 					"min": "46",
// 					"median": "56",
// 					"max": "76"
// 				}, {
// 					"date": "03-20",
// 					"min": "52",
// 					"median": "60",
// 					"max": "72"
// 				}, {
// 					"date": "03-21",
// 					"min": "43",
// 					"median": "51",
// 					"max": "62"
// 				}, {
// 					"date": "03-22",
// 					"min": "56",
// 					"median": "65",
// 					"max": "75"
// 				}, {
// 					"date": "03-23",
// 					"min": "52",
// 					"median": "60",
// 					"max": "71"
// 				}, {
// 					"date": "03-24",
// 					"min": "51",
// 					"median": "60",
// 					"max": "79"
// 				}, {
// 					"date": "03-25",
// 					"min": "64",
// 					"median": "73",
// 					"max": "85"
// 				}, {
// 					"date": "03-26",
// 					"min": "58",
// 					"median": "66",
// 					"max": "82"
// 				}, {
// 					"date": "03-27",
// 					"min": "56",
// 					"median": "62",
// 					"max": "79"
// 				}, {
// 					"date": "03-28",
// 					"min": "55",
// 					"median": "67",
// 					"max": "84"
// 				}, {
// 					"date": "03-29",
// 					"min": "55",
// 					"median": "63",
// 					"max": "82"
// 				}, {
// 					"date": "03-30",
// 					"min": "56",
// 					"median": "66",
// 					"max": "77"
// 				}, {
// 					"date": "03-31",
// 					"min": "56",
// 					"median": "63",
// 					"max": "78"
// 				}, {
// 					"date": "04-01",
// 					"min": "60",
// 					"median": "70",
// 					"max": "80"
// 				}, {
// 					"date": "04-02",
// 					"min": "58",
// 					"median": "64",
// 					"max": "77"
// 				}, {
// 					"date": "04-03",
// 					"min": "56",
// 					"median": "64",
// 					"max": "74"
// 				}, {
// 					"date": "04-04",
// 					"min": "51",
// 					"median": "60",
// 					"max": "85"
// 				}, {
// 					"date": "04-05",
// 					"min": "51",
// 					"median": "62",
// 					"max": "79"
// 				}, {
// 					"date": "04-06",
// 					"min": "59",
// 					"median": "67",
// 					"max": "76"
// 				}, {
// 					"date": "04-07",
// 					"min": "59",
// 					"median": "67",
// 					"max": "79"
// 				}, {
// 					"date": "04-08",
// 					"min": "58",
// 					"median": "65",
// 					"max": "76"
// 				}, {
// 					"date": "04-09",
// 					"min": "48",
// 					"median": "68",
// 					"max": "82"
// 				}, {
// 					"date": "04-10",
// 					"min": "52",
// 					"median": "62",
// 					"max": "73"
// 				}, {
// 					"date": "04-11",
// 					"min": "59",
// 					"median": "67",
// 					"max": "81"
// 				}, {
// 					"date": "04-12",
// 					"min": "59",
// 					"median": "67",
// 					"max": "84"
// 				}, {
// 					"date": "04-13",
// 					"min": "66",
// 					"median": "73",
// 					"max": "88"
// 				}, {
// 					"date": "04-14",
// 					"min": "55",
// 					"median": "62",
// 					"max": "76"
// 				}, {
// 					"date": "04-15",
// 					"min": "55",
// 					"median": "63",
// 					"max": "81"
// 				}, {
// 					"date": "今日",
// 					"min": "59",
// 					"median": "66",
// 					"max": "77"
// 				}],
// 				"desc": "我们现在对您还不够熟悉，再有16晚睡眠，我们就能看到您的大致情况咯，继续坚持使用设备守护哦",
// 				"descLabel": "·我们现在对您还不够熟悉，再有16晚睡眠，我们就能看到您的大致情况咯，继续坚持使用设备守护哦"
// 			},
// 			"deviateTheDay": null,
// 			"secretsHeart": null,
// 			"secretsHeartDay": null,
// 			"secretsHeartDeviate": null,
// 			"conclusionRecommend": null,
// 			"hasOccurPrfList": null
// 		},
// 		"dailyRoutineInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsDailyRoutine": {
// 				"data": [{
// 					"date": "03-18",
// 					"getBed": "20:00",
// 					"sleepSt": "20:27",
// 					"sleepEd": "04:54",
// 					"leaveBed": "07:57"
// 				}, {
// 					"date": "03-19",
// 					"getBed": "20:00",
// 					"sleepSt": "21:08",
// 					"sleepEd": "05:50",
// 					"leaveBed": "06:53"
// 				}, {
// 					"date": "03-20",
// 					"getBed": "20:00",
// 					"sleepSt": "20:40",
// 					"sleepEd": "06:51",
// 					"leaveBed": "06:59"
// 				}, {
// 					"date": "03-21",
// 					"getBed": "23:08",
// 					"sleepSt": "23:40",
// 					"sleepEd": "06:49",
// 					"leaveBed": "07:01"
// 				}, {
// 					"date": "03-22",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "05:55",
// 					"leaveBed": "06:58"
// 				}, {
// 					"date": "03-23",
// 					"getBed": "01:31",
// 					"sleepSt": "03:01",
// 					"sleepEd": "06:42",
// 					"leaveBed": "06:55"
// 				}, {
// 					"date": "03-24",
// 					"getBed": "20:00",
// 					"sleepSt": "20:09",
// 					"sleepEd": "08:00",
// 					"leaveBed": "08:00"
// 				}, {
// 					"date": "03-25",
// 					"getBed": "20:00",
// 					"sleepSt": "20:37",
// 					"sleepEd": "06:11",
// 					"leaveBed": "06:34"
// 				}, {
// 					"date": "03-26",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "07:23",
// 					"leaveBed": "07:44"
// 				}, {
// 					"date": "03-27",
// 					"getBed": "00:02",
// 					"sleepSt": "00:07",
// 					"sleepEd": "07:04",
// 					"leaveBed": "07:21"
// 				}, {
// 					"date": "03-28",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "07:26",
// 					"leaveBed": "07:33"
// 				}, {
// 					"date": "03-29",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "06:47",
// 					"leaveBed": "07:17"
// 				}, {
// 					"date": "03-30",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "07:12",
// 					"leaveBed": "07:20"
// 				}, {
// 					"date": "03-31",
// 					"getBed": "20:00",
// 					"sleepSt": "21:09",
// 					"sleepEd": "06:22",
// 					"leaveBed": "06:46"
// 				}, {
// 					"date": "04-01",
// 					"getBed": "20:34",
// 					"sleepSt": "21:43",
// 					"sleepEd": "07:04",
// 					"leaveBed": "07:30"
// 				}, {
// 					"date": "04-02",
// 					"getBed": "20:00",
// 					"sleepSt": "20:03",
// 					"sleepEd": "07:03",
// 					"leaveBed": "07:13"
// 				}, {
// 					"date": "04-03",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "04:52",
// 					"leaveBed": "05:36"
// 				}, {
// 					"date": "04-04",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "05:08",
// 					"leaveBed": "07:26"
// 				}, {
// 					"date": "04-05",
// 					"getBed": "20:00",
// 					"sleepSt": "20:25",
// 					"sleepEd": "05:32",
// 					"leaveBed": "07:28"
// 				}, {
// 					"date": "04-06",
// 					"getBed": "20:00",
// 					"sleepSt": "23:17",
// 					"sleepEd": "05:38",
// 					"leaveBed": "07:35"
// 				}, {
// 					"date": "04-07",
// 					"getBed": "20:00",
// 					"sleepSt": "20:18",
// 					"sleepEd": "06:11",
// 					"leaveBed": "06:49"
// 				}, {
// 					"date": "04-08",
// 					"getBed": "20:31",
// 					"sleepSt": "21:20",
// 					"sleepEd": "06:11",
// 					"leaveBed": "06:17"
// 				}, {
// 					"date": "04-09",
// 					"getBed": "20:00",
// 					"sleepSt": "20:47",
// 					"sleepEd": "06:13",
// 					"leaveBed": "08:00"
// 				}, {
// 					"date": "04-10",
// 					"getBed": "20:00",
// 					"sleepSt": "20:38",
// 					"sleepEd": "04:46",
// 					"leaveBed": "06:05"
// 				}, {
// 					"date": "04-11",
// 					"getBed": "20:00",
// 					"sleepSt": "23:47",
// 					"sleepEd": "06:12",
// 					"leaveBed": "06:50"
// 				}, {
// 					"date": "04-12",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "05:20",
// 					"leaveBed": "05:47"
// 				}, {
// 					"date": "04-13",
// 					"getBed": "20:00",
// 					"sleepSt": "22:32",
// 					"sleepEd": "05:47",
// 					"leaveBed": "06:04"
// 				}, {
// 					"date": "04-14",
// 					"getBed": "20:00",
// 					"sleepSt": "20:00",
// 					"sleepEd": "05:57",
// 					"leaveBed": "06:16"
// 				}, {
// 					"date": "04-15",
// 					"getBed": "20:00",
// 					"sleepSt": "20:33",
// 					"sleepEd": "05:31",
// 					"leaveBed": "06:26"
// 				}, {
// 					"date": "今日",
// 					"getBed": "20:58",
// 					"sleepSt": "21:19",
// 					"sleepEd": "04:55",
// 					"leaveBed": "06:59"
// 				}],
// 				"timeRange": ["20:00", "08:00"],
// 				"highFreTime": {
// 					"getBedSt": null,
// 					"getBedEd": null,
// 					"sleepStSt": null,
// 					"sleepStEd": null,
// 					"sleepEdSt": null,
// 					"sleepEdEd": null,
// 					"leaveBedSt": null,
// 					"leaveBedEd": null
// 				},
// 				"desc": "暂时没有特别规律的作息时间，可以尝试规律作息，提高睡眠质量",
// 				"descLabel": "·暂时没有特别规律的作息时间，可以尝试规律作息，提高睡眠质量",
// 				"descAnimation": "由您作息时间点分布图可见，暂时没有特别规律的作息时间，可以尝试规律作息，提高睡眠质量"
// 			},
// 			"secretsDailyRoutineDeviate": null,
// 			"secretsSleep": {
// 				"xaxis": ["10", "20", "30", "40", "50", "60", "70", "80", "90", "100", "110", "120"],
// 				"data": [0.07, 0.2, 0.27, 0.2, 0, 0.2, 0, 0, 0.07, 0, 0],
// 				"range": ["10", "80"],
// 				"desc": "93%入睡时长都集中在10～80分钟之间，没有异常",
// 				"descLabel": "·93%入睡时长都集中在10～80分钟之间，没有异常",
// 				"descAnimation": "由您入睡时长分布图可见，93%入睡时长都集中在10～80分钟之间，没有异常"
// 			},
// 			"secretsSleepDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["27", "68", "40", "32", "0", "90", "9", "37", "0", "5", "0", "0", "0", "69", "69", "3", "0", "0", "25", "197", "18", "49", "47", "38", "227", "0", "152", "0", "33", "21"],
// 				"range": [0, 121],
// 				"desc": "入睡时长有点不稳定，但无需过度担心",
// 				"descLabel": "·入睡时长有点不稳定，但无需过度担心",
// 				"descAnimation": null
// 			},
// 			"secretsSleepDayDeviate": {
// 				"desc": "最近30天里有3天的入睡时长和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>3</Text_R>天的入睡时长和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "04月13日",
// 					"value": "2小时32分钟"
// 				}, {
// 					"date": "04月11日",
// 					"value": "3小时47分钟"
// 				}, {
// 					"date": "04月06日",
// 					"value": "3小时17分钟"
// 				}]
// 			},
// 			"secretsBed": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100", "110", "120"],
// 				"data": [0.19, 0.22, 0.19, 0.11, 0.04, 0.04, 0.07, 0.04, 0, 0, 0.04, 0.07],
// 				"range": ["10", "30"],
// 				"desc": "51%起床时长都集中在10～30分钟之间，没有异常",
// 				"descLabel": "·51%起床时长都集中在10～30分钟之间，没有异常",
// 				"descAnimation": "由您起床时长分布图可见，51%起床时长都集中在10～30分钟之间，没有异常"
// 			},
// 			"secretsBedDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["183", "63", "8", "12", "63", "13", "0", "23", "21", "17", "7", "30", "8", "24", "26", "10", "44", "138", "116", "117", "38", "6", "107", "79", "38", "27", "17", "19", "55", "124"],
// 				"range": [0, 259],
// 				"desc": "起床时长整体表现比较稳定",
// 				"descLabel": "·起床时长整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsBedDayDeviate": null,
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的作息规律整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"conclusionLabel": "基于以上，您的作息规律整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"recommend": null,
// 				"recommendLabel": null
// 			},
// 			"hasOccurPrfList": [{
// 				"dimension": 4,
// 				"realValue": "高效起床人",
// 				"conclusion": "高效**",
// 				"times": 2,
// 				"isWarn": false,
// 				"isNew": false,
// 				"isNewShow": true
// 			}]
// 		},
// 		"leaveBedInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsLeaveBedTimes": {
// 				"xaxis": ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
// 				"data": [0.2, 0.47, 0.13, 0.1, 0.1, 0, 0, 0, 0, 0],
// 				"range": ["0", "3"],
// 				"desc": "90%夜间离床次数都集中0～3次，没有异常",
// 				"descLabel": "·90%夜间离床次数都集中0～3次，没有异常",
// 				"descAnimation": "由您离床次数分布图可见，90%离床次数都集中在0～3次之间，没有异常"
// 			},
// 			"secretsLeaveBedTimesDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["1", "2", "4", "0", "2", "0", "2", "1", "3", "0", "4", "1", "4", "1", "3", "0", "1", "1", "3", "0", "1", "1", "1", "1", "1", "1", "0", "1", "1", "2"],
// 				"range": [0, 3],
// 				"desc": "离床次数整体表现比较稳定",
// 				"descLabel": "·离床次数整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsLeaveBedTimesDayDeviate": {
// 				"desc": "最近30天里有3天的离床次数和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>3</Text_R>天的离床次数和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "03月30日",
// 					"value": "4次"
// 				}, {
// 					"date": "03月28日",
// 					"value": "4次"
// 				}, {
// 					"date": "03月20日",
// 					"value": "4次"
// 				}]
// 			},
// 			"secretsLeaveBedDuration": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100", "110", "120", "130", "140", "150", "160", "170", "180", "190", "200", "210", "220", "230", "240"],
// 				"data": [0.98, 0.02, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 				"range": ["0", "30"],
// 				"desc": "100%离床时长都集中在30分钟以下，没有异常",
// 				"descLabel": "·100%离床时长都集中在30分钟以下，没有异常",
// 				"descAnimation": "由您离床时长分布图可见，100%离床时长都集中在30分钟以下，没有异常"
// 			},
// 			"secretsLeaveBedDurationDeviate": {
// 				"desc": "最近30天里有2天的离床时长和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的离床时长和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "04月01日",
// 					"duration": "9分钟",
// 					"time": "03:37"
// 				}, {
// 					"date": "03月22日",
// 					"duration": "13分钟",
// 					"time": "20:49"
// 				}]
// 			},
// 			"secretsLeaveBedTimeDuration": {
// 				"referenceList": [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40],
// 				"data": [{
// 					"date": "03-18",
// 					"timeDuration": [{
// 						"timeSt": "21:43",
// 						"timeEd": "21:46",
// 						"duration": 3
// 					}]
// 				}, {
// 					"date": "03-19",
// 					"timeDuration": [{
// 						"timeSt": "22:51",
// 						"timeEd": "22:52",
// 						"duration": 1
// 					}, {
// 						"timeSt": "04:40",
// 						"timeEd": "04:42",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-20",
// 					"timeDuration": [{
// 						"timeSt": "21:40",
// 						"timeEd": "21:41",
// 						"duration": 1
// 					}, {
// 						"timeSt": "23:31",
// 						"timeEd": "23:32",
// 						"duration": 1
// 					}, {
// 						"timeSt": "02:15",
// 						"timeEd": "02:16",
// 						"duration": 1
// 					}, {
// 						"timeSt": "05:45",
// 						"timeEd": "05:46",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "03-21",
// 					"timeDuration": null
// 				}, {
// 					"date": "03-22",
// 					"timeDuration": [{
// 						"timeSt": "20:49",
// 						"timeEd": "21:02",
// 						"duration": 13
// 					}, {
// 						"timeSt": "02:43",
// 						"timeEd": "02:45",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-23",
// 					"timeDuration": null
// 				}, {
// 					"date": "03-24",
// 					"timeDuration": [{
// 						"timeSt": "21:38",
// 						"timeEd": "21:39",
// 						"duration": 1
// 					}, {
// 						"timeSt": "06:09",
// 						"timeEd": "06:11",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-25",
// 					"timeDuration": [{
// 						"timeSt": "02:09",
// 						"timeEd": "02:11",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-26",
// 					"timeDuration": [{
// 						"timeSt": "20:34",
// 						"timeEd": "20:36",
// 						"duration": 2
// 					}, {
// 						"timeSt": "23:22",
// 						"timeEd": "23:23",
// 						"duration": 1
// 					}, {
// 						"timeSt": "01:38",
// 						"timeEd": "01:39",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "03-27",
// 					"timeDuration": null
// 				}, {
// 					"date": "03-28",
// 					"timeDuration": [{
// 						"timeSt": "21:43",
// 						"timeEd": "21:44",
// 						"duration": 1
// 					}, {
// 						"timeSt": "23:28",
// 						"timeEd": "23:29",
// 						"duration": 1
// 					}, {
// 						"timeSt": "00:31",
// 						"timeEd": "00:32",
// 						"duration": 1
// 					}, {
// 						"timeSt": "06:12",
// 						"timeEd": "06:13",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "03-29",
// 					"timeDuration": [{
// 						"timeSt": "02:15",
// 						"timeEd": "02:16",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "03-30",
// 					"timeDuration": [{
// 						"timeSt": "21:56",
// 						"timeEd": "21:58",
// 						"duration": 2
// 					}, {
// 						"timeSt": "00:06",
// 						"timeEd": "00:07",
// 						"duration": 1
// 					}, {
// 						"timeSt": "02:23",
// 						"timeEd": "02:25",
// 						"duration": 2
// 					}, {
// 						"timeSt": "05:05",
// 						"timeEd": "05:07",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "03-31",
// 					"timeDuration": [{
// 						"timeSt": "00:19",
// 						"timeEd": "00:21",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-01",
// 					"timeDuration": [{
// 						"timeSt": "22:51",
// 						"timeEd": "22:52",
// 						"duration": 1
// 					}, {
// 						"timeSt": "23:11",
// 						"timeEd": "23:12",
// 						"duration": 1
// 					}, {
// 						"timeSt": "03:37",
// 						"timeEd": "03:46",
// 						"duration": 9
// 					}]
// 				}, {
// 					"date": "04-02",
// 					"timeDuration": null
// 				}, {
// 					"date": "04-03",
// 					"timeDuration": [{
// 						"timeSt": "00:42",
// 						"timeEd": "00:44",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-04",
// 					"timeDuration": [{
// 						"timeSt": "22:11",
// 						"timeEd": "22:13",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-05",
// 					"timeDuration": [{
// 						"timeSt": "20:57",
// 						"timeEd": "20:58",
// 						"duration": 1
// 					}, {
// 						"timeSt": "22:31",
// 						"timeEd": "22:33",
// 						"duration": 2
// 					}, {
// 						"timeSt": "01:28",
// 						"timeEd": "01:29",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "04-06",
// 					"timeDuration": null
// 				}, {
// 					"date": "04-07",
// 					"timeDuration": [{
// 						"timeSt": "00:37",
// 						"timeEd": "00:39",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-08",
// 					"timeDuration": [{
// 						"timeSt": "22:40",
// 						"timeEd": "22:42",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-09",
// 					"timeDuration": [{
// 						"timeSt": "22:46",
// 						"timeEd": "22:48",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-10",
// 					"timeDuration": [{
// 						"timeSt": "21:19",
// 						"timeEd": "21:20",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "04-11",
// 					"timeDuration": [{
// 						"timeSt": "02:41",
// 						"timeEd": "02:42",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "04-12",
// 					"timeDuration": [{
// 						"timeSt": "01:37",
// 						"timeEd": "01:39",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-13",
// 					"timeDuration": null
// 				}, {
// 					"date": "04-14",
// 					"timeDuration": [{
// 						"timeSt": "23:36",
// 						"timeEd": "23:38",
// 						"duration": 2
// 					}]
// 				}, {
// 					"date": "04-15",
// 					"timeDuration": [{
// 						"timeSt": "22:37",
// 						"timeEd": "22:38",
// 						"duration": 1
// 					}]
// 				}, {
// 					"date": "今日",
// 					"timeDuration": [{
// 						"timeSt": "23:03",
// 						"timeEd": "23:04",
// 						"duration": 1
// 					}, {
// 						"timeSt": "03:29",
// 						"timeEd": "03:31",
// 						"duration": 2
// 					}]
// 				}],
// 				"timeRange": ["20:34", "06:12"],
// 				"highFreTime": [{
// 					"timeSt": "18:53",
// 					"timeEd": "05:56",
// 					"duration": 663
// 				}],
// 				"desc": "通常会在18:53～05:56离床，没有明显异常",
// 				"descLabel": "·通常会在18:53～05:56离床，没有明显异常",
// 				"descAnimation": "由您每次离床发生的时间点和时长分布可见，您通常会在18:53～05:56离床，没有明显异常"
// 			},
// 			"secretsLeaveBedTimeDurationDeviate": {
// 				"desc": "最近30天里有2天的离床时间点和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的离床时间点和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "03月28日",
// 					"duration": "1分钟",
// 					"time": "06:12"
// 				}, {
// 					"date": "03月24日",
// 					"duration": "2分钟",
// 					"time": "06:09"
// 				}]
// 			},
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的离床整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"conclusionLabel": "基于以上，您的离床整体表现正常，暂无明显的异常特征。要继续保持哦～",
// 				"recommend": null,
// 				"recommendLabel": null
// 			},
// 			"hasOccurPrfList": null
// 		},
// 		"sleepInfo": {
// 			"clickFlag": 3,
// 			"changeNum": null,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": null,
// 			"secretsSleepDuration": {
// 				"xaxis": ["120", "130", "140", "150", "160", "170", "180", "190", "200", "210", "220", "230", "240", "250", "260", "270", "280", "290", "300", "310", "320", "330", "340", "350", "360", "370", "380", "390", "400", "410", "420", "430", "440", "450", "460", "470", "480", "490", "500", "510", "520", "530", "540", "550", "560", "570", "580", "590", "600", "610", "620", "630", "640", "650", "660", "670", "680", "690", "700", "710", "720"],
// 				"data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.03, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.07, 0.07, 0, 0, 0.07, 0.1, 0.07, 0.13, 0.07, 0.03, 0, 0, 0.07, 0.03, 0, 0, 0, 0.03, 0.07, 0.03, 0, 0.03, 0.03, 0, 0.03, 0, 0, 0, 0, 0, 0, 0.03, 0, 0, 0, 0, 0, 0],
// 				"range": ["420", "540"],
// 				"desc": "33%睡眠时长都集中在7～9h之间，没有明显异常",
// 				"descLabel": "·33%睡眠时长都集中在7～9h之间，没有明显异常",
// 				"descAnimation": "由您睡眠时长分布图可见，33%睡眠时长都集中在7～9h之间，没有明显异常"
// 			},
// 			"secretsSleepDurationDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["388", "404", "478", "411", "424", "221", "530", "413", "584", "418", "411", "526", "396", "521", "347", "651", "394", "514", "403", "382", "436", "468", "559", "349", "357", "350", "390", "565", "467", "425"],
// 				"range": [220, 676],
// 				"desc": "睡眠时长有点不稳定，但无需过度担心",
// 				"descLabel": "·睡眠时长有点不稳定，但无需过度担心",
// 				"descAnimation": null
// 			},
// 			"secretsSleepDurationDayDeviate": null,
// 			"secretsSleepEfficiency": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"],
// 				"data": [0, 0, 0, 0, 0, 0.3, 0.23, 0.23, 0.13, 0.1],
// 				"range": ["60", "100"],
// 				"desc": "53%睡眠效率都集中在90%以上，这很棒",
// 				"descLabel": "·53%睡眠效率都集中在90%以上，这很棒",
// 				"descAnimation": "由您睡眠效率分布图可见，53%睡眠效率都集中在90%以上，是高效睡眠的表现，这很棒"
// 			},
// 			"secretsSleepEfficiencyDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["54", "61", "72", "86", "64", "68", "73", "65", "82", "95", "59", "77", "58", "81", "52", "96", "68", "74", "58", "57", "68", "79", "80", "57", "54", "59", "64", "91", "74", "70"],
// 				"range": [29, 100],
// 				"desc": "睡眠效率整体表现比较稳定",
// 				"descLabel": "·睡眠效率整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsSleepEfficiencyDayDeviate": null,
// 			"secretsSleepCrush": {
// 				"xaxis": ["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"],
// 				"data": [0.2, 0.17, 0.07, 0.07, 0.03, 0.07, 0.07, 0.17, 0.03, 0.13],
// 				"range": ["0", "80"],
// 				"desc": "86%睡眠破碎指标都集中在20以下，这很棒",
// 				"descLabel": "·86%睡眠破碎指标都集中在20以下，这很棒",
// 				"descAnimation": "由您睡眠破碎指标分布图可见，86%睡眠破碎指标在20以下，这很棒"
// 			},
// 			"secretsSleepCrushDay": {
// 				"xaxis": ["03-18", "03-19", "03-20", "03-21", "03-22", "03-23", "03-24", "03-25", "03-26", "03-27", "03-28", "03-29", "03-30", "03-31", "04-01", "04-02", "04-03", "04-04", "04-05", "04-06", "04-07", "04-08", "04-09", "04-10", "04-11", "04-12", "04-13", "04-14", "04-15", "今日"],
// 				"data": ["60", "57", "54", "9", "74", "0", "67", "77", "33", "0", "100", "46", "100", "12", "100", "3", "70", "13", "70", "0", "71", "26", "2", "80", "15", "100", "23", "11", "30", "14"],
// 				"range": [0, 100],
// 				"desc": "睡眠破碎指标整体表现比较稳定",
// 				"descLabel": "·睡眠破碎指标整体表现比较稳定",
// 				"descAnimation": null
// 			},
// 			"secretsSleepCrushDayDeviate": null,
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的睡眠具有高效睡眠的表现，暂无明显的异常特征。要继续保持哦～",
// 				"conclusionLabel": "基于以上，您的睡眠具有<Tab_Text_P>高效睡眠</Tab_Text_P>的表现，暂无明显的异常特征。要继续保持哦～",
// 				"recommend": null,
// 				"recommendLabel": null
// 			},
// 			"hasOccurPrfList": [{
// 				"dimension": 6,
// 				"realValue": "高效睡眠",
// 				"conclusion": "高效**",
// 				"times": 1,
// 				"isWarn": false,
// 				"isNew": true,
// 				"isNewShow": true
// 			}]
// 		},
// 		"breathInfoV2": {
			
// 			"clickFlag": 3,
// 			"changeNum": 1,
// 			"changeNumShow": true,
// 			"unSecretsDays": null,
// 			"unSecretsData": null,
// 			"deviateTheDay": {
// 				"desc": "最近一天您的呼吸率中位数是21次/分，明显和您日常的表现有较大差异",
// 				"descLabel": "<Warning/> 最近一天您的呼吸率中位数是<Text_R>21次/分</Text_R>，明显和您日常的表现有较大差异",
// 				"remindAndSuggest": "我们发现您睡眠的呼吸率和日常差异较大，身体有没有哪里不舒服？或者昨天有没有大量饮酒或者咖啡茶之类的饮品？如果没有明显的不适，可以不用放在心上，建议持续观察您的呼吸情况",
// 				"remindAndSuggestLabel": "·我们发现您睡眠的呼吸率和日常差异较大，身体有没有哪里不舒服？或者昨天有没有大量饮酒或者咖啡茶之类的饮品？如果没有明显的不适，可以不用放在心上，建议持续观察您的呼吸情况"
// 			},
// 			"secretsBreath": {
// 				"brPdfFlag": 1,
// 				"xaxis": ["18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "今"],
// 				"xaxisCn": ["18日", "19日", "20日", "21日", "22日", "23日", "24日", "25日", "26日", "27日", "28日", "29日", "30日", "31日", "01日", "02日", "03日", "04日", "05日", "06日", "07日", "08日", "09日", "10日", "11日", "12日", "13日", "14日", "15日", "今"],
// 				"data": [{
// 					"date": "18",
// 					"dateCn": "18日",
// 					"min": "16",
// 					"median": "21",
// 					"max": "28",
// 					"extendData": {
// 						"date": "03月18日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "19",
// 					"dateCn": "19日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "27",
// 					"extendData": {
// 						"date": "03月19日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "20",
// 					"dateCn": "20日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月20日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "21",
// 					"dateCn": "21日",
// 					"min": "14",
// 					"median": "21",
// 					"max": "28",
// 					"extendData": {
// 						"date": "03月21日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "22",
// 					"dateCn": "22日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月22日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "23",
// 					"dateCn": "23日",
// 					"min": "12",
// 					"median": "20",
// 					"max": "28",
// 					"extendData": {
// 						"date": "03月23日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "24",
// 					"dateCn": "24日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "25",
// 					"extendData": {
// 						"date": "03月24日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "25",
// 					"dateCn": "25日",
// 					"min": "15",
// 					"median": "21",
// 					"max": "28",
// 					"extendData": {
// 						"date": "03月25日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "26",
// 					"dateCn": "26日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月26日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "27",
// 					"dateCn": "27日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月27日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "28",
// 					"dateCn": "28日",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27",
// 					"extendData": {
// 						"date": "03月28日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "29",
// 					"dateCn": "29日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "27",
// 					"extendData": {
// 						"date": "03月29日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "30",
// 					"dateCn": "30日",
// 					"min": "15",
// 					"median": "19",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月30日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "31",
// 					"dateCn": "31日",
// 					"min": "16",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "03月31日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "01",
// 					"dateCn": "01日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "04月01日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "02",
// 					"dateCn": "02日",
// 					"min": "15",
// 					"median": "19",
// 					"max": "25",
// 					"extendData": {
// 						"date": "04月02日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "03",
// 					"dateCn": "03日",
// 					"min": "16",
// 					"median": "20",
// 					"max": "25",
// 					"extendData": {
// 						"date": "04月03日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "04",
// 					"dateCn": "04日",
// 					"min": "14",
// 					"median": "20",
// 					"max": "26",
// 					"extendData": {
// 						"date": "04月04日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "05",
// 					"dateCn": "05日",
// 					"min": "15",
// 					"median": "20",
// 					"max": "28",
// 					"extendData": {
// 						"date": "04月05日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "06",
// 					"dateCn": "06日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "26",
// 					"extendData": {
// 						"date": "04月06日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "07",
// 					"dateCn": "07日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "27",
// 					"extendData": {
// 						"date": "04月07日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "08",
// 					"dateCn": "08日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "27",
// 					"extendData": {
// 						"date": "04月08日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "09",
// 					"dateCn": "09日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "28",
// 					"extendData": {
// 						"date": "04月09日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "10",
// 					"dateCn": "10日",
// 					"min": "13",
// 					"median": "19",
// 					"max": "25",
// 					"extendData": {
// 						"date": "04月10日",
// 						"deviateFlag": 1,
// 						"deviateDesc": "呼吸率表现和日常差异较大，可以关注一下",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": [0, 0, 0, 0, 0, 0, 0, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0002, 0.0002, 0.0002, 0.0003, 0.0004, 0.0004, 0.0005, 0.0007, 0.0008, 0.001, 0.0011, 0.0014, 0.0016, 0.0019, 0.0023, 0.0026, 0.0031, 0.0036, 0.0041, 0.0047, 0.0054, 0.0061, 0.0069, 0.0078, 0.0088, 0.0097, 0.0108, 0.0119, 0.0131, 0.0143, 0.0155, 0.0167, 0.018, 0.0192, 0.0204, 0.0216, 0.0227, 0.0238, 0.0248, 0.0257, 0.0265, 0.0271, 0.0277, 0.0281, 0.0284, 0.0285, 0.0285, 0.0283, 0.028, 0.0276, 0.027, 0.0263, 0.0255, 0.0246, 0.0235, 0.0225, 0.0213, 0.0201, 0.0189, 0.0177, 0.0164, 0.0152, 0.014, 0.0128, 0.0117, 0.0106, 0.0096, 0.0086, 0.0077, 0.0068, 0.006, 0.0053, 0.0047, 0.0041, 0.0035, 0.0031, 0.0026, 0.0023, 0.0019, 0.0016, 0.0014, 0.0012, 0.001, 0.0008, 0.0007, 0.0006, 0.0005, 0.0004, 0.0003, 0.0003, 0.0002, 0.0002, 0.0002, 0.0002, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": 21,
// 						"deviateBpmFocus": 21,
// 						"range": [13, 25],
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "11",
// 					"dateCn": "11日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "28",
// 					"extendData": {
// 						"date": "04月11日",
// 						"deviateFlag": 2,
// 						"deviateDesc": "",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": [0, 0, 0, 0, 0, 0, 0, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0002, 0.0002, 0.0002, 0.0003, 0.0003, 0.0004, 0.0005, 0.0006, 0.0007, 0.0008, 0.001, 0.0012, 0.0014, 0.0017, 0.002, 0.0023, 0.0027, 0.0031, 0.0036, 0.0041, 0.0047, 0.0053, 0.006, 0.0067, 0.0075, 0.0084, 0.0092, 0.0102, 0.0112, 0.0122, 0.0132, 0.0142, 0.0153, 0.0164, 0.0174, 0.0185, 0.0195, 0.0204, 0.0214, 0.0222, 0.023, 0.0237, 0.0244, 0.0249, 0.0254, 0.0257, 0.026, 0.0261, 0.0261, 0.026, 0.0258, 0.0255, 0.0251, 0.0246, 0.024, 0.0234, 0.0226, 0.0218, 0.0209, 0.02, 0.019, 0.018, 0.017, 0.0159, 0.0149, 0.0139, 0.0128, 0.0118, 0.0109, 0.0099, 0.009, 0.0082, 0.0074, 0.0066, 0.0059, 0.0053, 0.0047, 0.0041, 0.0036, 0.0032, 0.0028, 0.0024, 0.0021, 0.0018, 0.0015, 0.0013, 0.0011, 0.001, 0.0008, 0.0007, 0.0006, 0.0006, 0.0005, 0.0004, 0.0004, 0.0004, 0.0003, 0.0003, 0.0003, 0.0003, 0.0003, 0.0003, 0.0003, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0002, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": 22,
// 						"deviateBpmFocus": 22,
// 						"range": [14, 28],
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "12",
// 					"dateCn": "12日",
// 					"min": "14",
// 					"median": "20",
// 					"max": "27",
// 					"extendData": {
// 						"date": "04月12日",
// 						"deviateFlag": 1,
// 						"deviateDesc": "呼吸率表现和日常差异较大，可以关注一下",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0002, 0.0002, 0.0002, 0.0003, 0.0004, 0.0005, 0.0006, 0.0007, 0.0008, 0.001, 0.0012, 0.0014, 0.0017, 0.002, 0.0024, 0.0028, 0.0033, 0.0038, 0.0045, 0.0051, 0.0059, 0.0067, 0.0076, 0.0086, 0.0096, 0.0108, 0.0119, 0.0132, 0.0144, 0.0157, 0.0171, 0.0184, 0.0197, 0.021, 0.0223, 0.0235, 0.0246, 0.0256, 0.0266, 0.0274, 0.028, 0.0286, 0.029, 0.0292, 0.0292, 0.0291, 0.0289, 0.0285, 0.0279, 0.0273, 0.0265, 0.0255, 0.0245, 0.0234, 0.0223, 0.021, 0.0198, 0.0185, 0.0173, 0.016, 0.0147, 0.0135, 0.0124, 0.0112, 0.0102, 0.0091, 0.0082, 0.0073, 0.0065, 0.0057, 0.005, 0.0044, 0.0039, 0.0033, 0.0029, 0.0025, 0.0021, 0.0018, 0.0015, 0.0013, 0.0011, 0.0009, 0.0008, 0.0006, 0.0005, 0.0004, 0.0004, 0.0003, 0.0002, 0.0002, 0.0002, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": 21,
// 						"deviateBpmFocus": 21,
// 						"range": [14, 27],
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "13",
// 					"dateCn": "13日",
// 					"min": "15",
// 					"median": "21",
// 					"max": "26",
// 					"extendData": {
// 						"date": "04月13日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "14",
// 					"dateCn": "14日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "25",
// 					"extendData": {
// 						"date": "04月14日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "15",
// 					"dateCn": "15日",
// 					"min": "14",
// 					"median": "19",
// 					"max": "28",
// 					"extendData": {
// 						"date": "04月15日",
// 						"deviateFlag": 3,
// 						"deviateDesc": "有效数据不足，可能是因为睡眠时长短，或是床铺周边1米内有电器、窗帘、宠物等干扰因素，建议及时排查",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": null,
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": null,
// 						"deviateBpmFocus": null,
// 						"range": null,
// 						"normalBpm": 25
// 					}
// 				}, {
// 					"date": "今",
// 					"dateCn": "今",
// 					"min": "14",
// 					"median": "19",
// 					"max": "27",
// 					"extendData": {
// 						"date": "04月16日（今日）",
// 						"deviateFlag": 1,
// 						"deviateDesc": "呼吸率表现和日常差异较大，可以关注一下",
// 						"normalFlag": 2,
// 						"normalDesc": "呼吸急促",
// 						"naxis": [
// 							[5, 10],
// 							[10, 25],
// 							[25, 50]
// 						],
// 						"xaxis": [5, 5.25, 5.5, 5.75, 6, 6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5, 8.75, 9, 9.25, 9.5, 9.75, 10, 10.25, 10.5, 10.75, 11, 11.25, 11.5, 11.75, 12, 12.25, 12.5, 12.75, 13, 13.25, 13.5, 13.75, 14, 14.25, 14.5, 14.75, 15, 15.25, 15.5, 15.75, 16, 16.25, 16.5, 16.75, 17, 17.25, 17.5, 17.75, 18, 18.25, 18.5, 18.75, 19, 19.25, 19.5, 19.75, 20, 20.25, 20.5, 20.75, 21, 21.25, 21.5, 21.75, 22, 22.25, 22.5, 22.75, 23, 23.25, 23.5, 23.75, 24, 24.25, 24.5, 24.75, 25, 25.25, 25.5, 25.75, 26, 26.25, 26.5, 26.75, 27, 27.25, 27.5, 27.75, 28, 28.25, 28.5, 28.75, 29, 29.25, 29.5, 29.75, 30, 30.25, 30.5, 30.75, 31, 31.25, 31.5, 31.75, 32, 32.25, 32.5, 32.75, 33, 33.25, 33.5, 33.75, 34, 34.25, 34.5, 34.75, 35, 35.25, 35.5, 35.75, 36, 36.25, 36.5, 36.75, 37, 37.25, 37.5, 37.75, 38, 38.25, 38.5, 38.75, 39, 39.25, 39.5, 39.75, 40, 40.25, 40.5, 40.75, 41, 41.25, 41.5, 41.75, 42, 42.25, 42.5, 42.75, 43, 43.25, 43.5, 43.75, 44, 44.25, 44.5, 44.75, 45, 45.25, 45.5, 45.75, 46, 46.25, 46.5, 46.75, 47, 47.25, 47.5, 47.75, 48, 48.25, 48.5, 48.75, 49, 49.25, 49.5, 49.75, 50],
// 						"deviateData": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0.0002, 0.0002, 0.0003, 0.0003, 0.0004, 0.0005, 0.0006, 0.0007, 0.0009, 0.0011, 0.0013, 0.0015, 0.0018, 0.0022, 0.0026, 0.0031, 0.0036, 0.0042, 0.0049, 0.0056, 0.0064, 0.0073, 0.0083, 0.0094, 0.0105, 0.0117, 0.013, 0.0143, 0.0157, 0.0171, 0.0185, 0.0199, 0.0212, 0.0226, 0.0239, 0.0251, 0.0262, 0.0272, 0.028, 0.0288, 0.0293, 0.0298, 0.03, 0.0301, 0.03, 0.0297, 0.0293, 0.0287, 0.0279, 0.0271, 0.0261, 0.025, 0.0238, 0.0225, 0.0212, 0.0199, 0.0186, 0.0172, 0.0159, 0.0146, 0.0133, 0.0121, 0.0109, 0.0098, 0.0088, 0.0078, 0.0069, 0.0061, 0.0053, 0.0046, 0.004, 0.0035, 0.003, 0.0026, 0.0022, 0.0019, 0.0016, 0.0013, 0.0011, 0.0009, 0.0008, 0.0006, 0.0005, 0.0004, 0.0003, 0.0003, 0.0002, 0.0002, 0.0001, 0.0001, 0.0001, 0.0001, 0.0001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"normalData": [0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00003, 0.00003, 0.00004, 0.00005, 0.00005, 0.00007, 0.00008, 0.00009, 0.00011, 0.00012, 0.00016, 0.00018, 0.00023, 0.00027, 0.00034, 0.0004, 0.00048, 0.0006, 0.00072, 0.00088, 0.00105, 0.00125, 0.00151, 0.00178, 0.0021, 0.00248, 0.0029, 0.00338, 0.00392, 0.00452, 0.00518, 0.0059, 0.00673, 0.00759, 0.00853, 0.00953, 0.0106, 0.01172, 0.01289, 0.01409, 0.01533, 0.01659, 0.01786, 0.01912, 0.02035, 0.02155, 0.02271, 0.02377, 0.02477, 0.02569, 0.02648, 0.02715, 0.0277, 0.02809, 0.02835, 0.02846, 0.02842, 0.02823, 0.02791, 0.02744, 0.02683, 0.02611, 0.02527, 0.02433, 0.02331, 0.02222, 0.02107, 0.01987, 0.01866, 0.01744, 0.01622, 0.01499, 0.0138, 0.01265, 0.01154, 0.01046, 0.00945, 0.0085, 0.0076, 0.00677, 0.006, 0.00531, 0.00466, 0.00409, 0.00354, 0.00309, 0.00266, 0.0023, 0.00197, 0.00169, 0.00144, 0.00122, 0.00103, 0.00088, 0.00074, 0.00063, 0.00053, 0.00045, 0.00039, 0.00032, 0.00029, 0.00026, 0.00022, 0.0002, 0.00018, 0.00017, 0.00017, 0.00017, 0.00016, 0.00017, 0.00016, 0.00017, 0.00017, 0.00018, 0.0002, 0.0002, 0.0002, 0.00022, 0.00022, 0.00023, 0.00024, 0.00025, 0.00026, 0.00027, 0.00028, 0.00027, 0.00027, 0.00027, 0.00026, 0.00026, 0.00026, 0.00026, 0.00025, 0.00025, 0.00024, 0.00024, 0.00022, 0.00022, 0.0002, 0.0002, 0.00019, 0.00017, 0.00017, 0.00016, 0.00014, 0.00013, 0.00011, 0.00011, 0.00009, 0.00009, 0.00007, 0.00007, 0.00006, 0.00005, 0.00005, 0.00004, 0.00004, 0.00004, 0.00003, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0],
// 						"deviateBpm": 21,
// 						"deviateBpmFocus": 21,
// 						"range": [14, 27],
// 						"normalBpm": 25
// 					}
// 				}],
// 				"desc": "呼吸率日常表现多集中在25次/分左右，有点偏快",
// 				"descLabel": "·呼吸率日常表现多集中在25次/分左右，有点偏快"
// 			},
// 			"secretsBreathDeviate": {
// 				"desc": "最近30天里有3天的呼吸率中位数和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>3</Text_R>天的呼吸率中位数和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "04月10日",
// 					"value": "21次/分"
// 				}, {
// 					"date": "04月12日",
// 					"value": "21次/分"
// 				}, {
// 					"date": "04月16日",
// 					"value": "21次/分"
// 				}]
// 			},
// 			"secretsInExRatio": {
// 				"xaxis": ["0.1", "0.2", "0.3", "0.4", "0.5", "0.6", "0.7", "0.8", "0.9", "1.0", "1.1", "1.2", "1.3", "1.4", "1.5", "1.6", "1.7", "1.8", "1.9", "2.0", "2.1", "2.2", "2.3", "2.4"],
// 				"data": [0.03, 0.05, 0.05, 0.05, 0.07, 0.1, 0.13, 0.16, 0.07, 0.09, 0.04, 0.03, 0.02, 0.02, 0.02, 0.01, 0.01, 0.01, 0, 0.01, 0.01, 0.01, 0.01, 0.01],
// 				"range": ["0.8", "1.2"],
// 				"desc": "38%吸呼比都集中在0.8～1.2之间，没有异常",
// 				"descLabel": "·38%吸呼比都集中在0.8～1.2之间，没有异常",
// 				"descAnimation": "由您吸呼比分布如图可见，38%吸呼比都集中在0.8～1.2之间，没有异常"
// 			},
// 			"secretsInExRatioDeviate": {
// 				"desc": "最近30天里有2天的吸呼比和平时差异较大，可以关注一下：",
// 				"descLabel": "<Warning/> 最近30天里有<Text_R>2</Text_R>天的吸呼比和平时差异较大，可以关注一下：",
// 				"data": [{
// 					"date": "03月23日",
// 					"value": "1.0"
// 				}, {
// 					"date": "03月19日",
// 					"value": "0.6"
// 				}]
// 			},
// 			"conclusionRecommend": {
// 				"conclusion": "基于以上，您的呼吸具有呼吸急促的表现，这可能跟一些潜在的身体不适相关，有出现嗜睡、疲劳、头痛的几率。",
// 				"conclusionLabel": "基于以上，您的呼吸具有<Tab_Warning_Text_R>呼吸急促</Tab_Warning_Text_R>的表现，这可能跟一些潜在的身体不适相关，有出现嗜睡、疲劳、头痛的几率。",
// 				"recommend": "合理饮食，控制体重，远离烟酒\n每周坚持3～5次30分钟有氧运动，放松心情，释放压力\n如果存在呼吸道感染或哮喘等疾病，需要按照医生建议进行治疗和管理\n可以观察数据的变化，如果持续加重并伴随其他症状，如胸痛、发热等，请尽快就医。",
// 				"recommendLabel": {
// 					"recommendList": [{
// 						"imageType": "1",
// 						"recommend": "合理饮食，控制体重，远离烟酒"
// 					}, {
// 						"imageType": "2",
// 						"recommend": "每周坚持3～5次30分钟有氧运动，放松心情，释放压力"
// 					}, {
// 						"imageType": "3",
// 						"recommend": "如果存在呼吸道感染或哮喘等疾病，需要按照医生建议进行治疗和管理"
// 					}],
// 					"recommend": "可以观察数据的变化，如果持续加重并伴随其他症状，如胸痛、发热等，请尽快就医。"
// 				}
// 			},
// 			"hasOccurPrfList": [{
// 				"dimension": 1,
// 				"realValue": "呼吸急促",
// 				"conclusion": "呼吸**",
// 				"times": 1,
// 				"isWarn": true,
// 				"isNew": true,
// 				"isNewShow": true
// 			}]
// 		}
// 	}
// }
          if (res.code == 0) {
            if (res.data) {
              console.log(res.data)
              this.allData = res.data;

              

              this.$nextTick((resNext) => {

				let tempIsHaveHxl = true;
				if (!this.allData || !this.allData.breathInfoV2 || !this.allData.breathInfoV2.secretsBreath || !this.allData.breathInfoV2.secretsBreath.data) {
					tempIsHaveHxl = false;
				} else {
					let tempZ = false;
					for (let i = 0; i < this.allData.breathInfoV2.secretsBreath.data.length; i++) {
						let item = this.allData.breathInfoV2.secretsBreath.data[i];
						if (item.min != '-') {
							tempZ = true;
						}
					}
					if (!tempZ) {
						tempIsHaveHxl = false;
					}
				}
				this.isHaveHxl = tempIsHaveHxl;


                // 呼吸情况
                if(!res.data.breathInfoV2.unSecretsDays){
                  // 呼吸率分布图
                  let hxl_dis = {
                    name: '呼吸率',
                    xAxis: {
                      data: this.allData.breathInfoV2.secretsBreath.xaxis
                    },
                    series: {
                      data: this.allData.breathInfoV2.secretsBreath.data,
                      range: this.allData.breathInfoV2.secretsBreath.range
                    },
                  }
                  // 吸呼比分布图
                  let xhb_dis = {
                    name: '吸呼比',
                    xAxis: {
                      data: this.allData.breathInfoV2.secretsInExRatio.xaxis
                    },
                    series: {
                      data: this.allData.breathInfoV2.secretsInExRatio.data,
                      range: this.allData.breathInfoV2.secretsInExRatio.range
                    },
                  }

                //   this.getMyChart_optionBar('ech_breathOne','hxl_dis',hxl_dis)          //呼吸率分布
				if (this.allData.breathInfoV2.secretsBreath.brPdfFlag == 1 && tempIsHaveHxl) {
					this.getMyChart_optionMyFloat('ech_breathOne','hxl_dis',hxl_dis);
				}
                  this.getMyChart_optionBar('ech_breathTwo','xhb_dis',xhb_dis)         //吸呼比分布
                }
                // 体动情况
                if(!res.data.bodyMoveInfo.unSecretsDays){
                  // 体动分布图
                  let td_dis = {
                    name: '体动指数',
                    xAxis: {
                      data: this.allData.bodyMoveInfo.secretsBodyMoveIndex.xaxis
                    },
                    series: {
                      data: this.allData.bodyMoveInfo.secretsBodyMoveIndex.data,
                      range: this.allData.bodyMoveInfo.secretsBodyMoveIndex.range
                    },
                  }
                  // 体动破碎图
                  let td_crush_line = {
                    xAxis: {
                      data: this.allData.bodyMoveInfo.secretsBodyMoveIndexDay.xaxis
                    },
                    series: {
                      data: this.allData.bodyMoveInfo.secretsBodyMoveIndexDay.data,
                      range: this.allData.bodyMoveInfo.secretsBodyMoveIndexDay.range
                    },
                    avg: 10
                  }
                  this.getMyChart_optionBar('ech_tdOne','td_dis',td_dis)                //体动指数分布
                  this.getMyChart_optionLine('ech_td_line','td_crush_line',td_crush_line, true)    //体动指数统计_折线
                }
                // 心跳情况
                if(!res.data.heartInfo.unSecretsDays){
                  // 心率分布图
                  let heart_dis = {
                    name: '心率',
                    xAxis: {
                      data: this.allData.heartInfo.secretsHeart.xaxis
                    },
                    series: {
                      data: this.allData.heartInfo.secretsHeart.data,
                      range: this.allData.heartInfo.secretsHeart.range
                    },
                  }
                  this.getMyChart_optionBar('ech_heartOne','heart_dis',heart_dis)             //心跳分布
                }
                // 作息规律
                if(!res.data.dailyRoutineInfo.unSecretsDays){

                  // 作息规律_上床入睡醒来起床散点图secretsDailyRoutine  未写
                  let zxglArr = this.allData.dailyRoutineInfo.secretsDailyRoutine.data;
                  let zxgl_highFreTime = this.allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime;
                  let zxgl_scRsXlQc_sandian = {
                    xAxis_data: this.function_get_all_mintues(),
                    yAxis_data: [],
                    series_data0: [],
                    series_data1: [],
                    series_data2: [],
                    series_data3: [],
                    scatter_interval1: [],
                    scatter_interval2: [],
                    scatter_interval3: [],
                    scatter_interval4: [],
                  }
                  for(let i = 0;i < zxglArr.length;i++){
                    // console.log(zxglArr[i])
                    zxgl_scRsXlQc_sandian.yAxis_data.push(zxglArr[i].date)
                    // zxgl_scRsXlQc_sandian.series_data0.push(zxglArr[i].getBed)
                    zxgl_scRsXlQc_sandian.series_data0.push([zxglArr[i].getBed,zxglArr[i].date])
                    zxgl_scRsXlQc_sandian.series_data1.push([zxglArr[i].sleepSt,zxglArr[i].date])
                    zxgl_scRsXlQc_sandian.series_data2.push([zxglArr[i].sleepEd,zxglArr[i].date])
                    zxgl_scRsXlQc_sandian.series_data3.push([zxglArr[i].leaveBed,zxglArr[i].date])
                  }
                  // 上床
                  if(zxgl_highFreTime.getBedSt){
                    zxgl_scRsXlQc_sandian.scatter_interval1 = [[{'xAxis': zxgl_highFreTime.getBedSt},{'xAxis': zxgl_highFreTime.getBedEd}]]
                  }
                  // 入睡
                  if(zxgl_highFreTime.sleepStSt){
                    zxgl_scRsXlQc_sandian.scatter_interval2 = [[{'xAxis': zxgl_highFreTime.sleepStSt},{'xAxis': zxgl_highFreTime.sleepStEd}]]
                  }
                  // 醒来
                  if(zxgl_highFreTime.sleepEdSt){
                    zxgl_scRsXlQc_sandian.scatter_interval3 = [[{'xAxis': zxgl_highFreTime.sleepEdSt},{'xAxis': zxgl_highFreTime.sleepEdEd}]]
                  }
                  // 起床
                  if(zxgl_highFreTime.leaveBedSt){
                    zxgl_scRsXlQc_sandian.scatter_interval4 = [[{'xAxis': zxgl_highFreTime.leaveBedSt},{'xAxis': zxgl_highFreTime.leaveBedEd}]]
                  }
                  // 前端自己增加是否显示作息规律中四个高频内容
                  if(zxgl_highFreTime.getBedSt || zxgl_highFreTime.sleepStSt || zxgl_highFreTime.sleepEdSt || zxgl_highFreTime.leaveBedSt){
                    this.allData.dailyRoutineInfo.secretsDailyRoutine.isShow_highFreTime2 = true
                  }else{
                    this.allData.dailyRoutineInfo.secretsDailyRoutine.isShow_highFreTime2 = false
                  }
                  // 作息规律_入睡时长分布图
                  let zxgl_rssc_dis = {
                    name: '入睡时长',
                    xAxis: {
                      data: this.allData.dailyRoutineInfo.secretsSleep.xaxis
                    },
                    series: {
                      data: this.allData.dailyRoutineInfo.secretsSleep.data,
                      range: this.allData.dailyRoutineInfo.secretsSleep.range
                    },
                  }
                  // 作息规律_入睡时长统计图
                  let zxgl_rssc_dis2 = {
                    xAxis: {
                      // data: [0,1,2,3]
                      data: this.allData.dailyRoutineInfo.secretsSleepDay.xaxis
                    },
                    series: {
                      data: this.allData.dailyRoutineInfo.secretsSleepDay.data,
                      range: this.allData.dailyRoutineInfo.secretsSleepDay.range
                      // data: [10,14,'3','32'],
                      // range: [1,2]
                    },
                  }
                  // 作息规律_起床时长分布图
                  let zxgl_qcsc_dis = {
                    name: '起床时长',
                    xAxis: {
                      data: this.allData.dailyRoutineInfo.secretsBed.xaxis
                    },
                    series: {
                      data: this.allData.dailyRoutineInfo.secretsBed.data,
                      range: this.allData.dailyRoutineInfo.secretsBed.range
                    },
                  }
                  // 作息规律_起床时长统计图
                  let zxgl_qcsc_dis2 = {
                    xAxis: {
                      data: this.allData.dailyRoutineInfo.secretsBedDay.xaxis
                    },
                    series: {
                      data: this.allData.dailyRoutineInfo.secretsBedDay.data,
                      range: this.allData.dailyRoutineInfo.secretsBedDay.range
                    },
                  }
                  // id为echSanDian的dom滚动到底部
                  let message = document.getElementById('id_echSanDian_wrap');
                  message.scrollTop = message.scrollHeight;

                  this.getMyChart_optionSca('echSanDian','zxgl_scRsXlQc_sandian',zxgl_scRsXlQc_sandian)         // 作息规律_上床入睡醒来起床散点图secretsDailyRoutine
                  this.getMyChart_optionBar('ech_sleepOne','zxgl_rssc_dis',zxgl_rssc_dis)             //入睡时长分布
                  this.getMyChart_optionBar('ech_sleepTwo','zxgl_rssc_dis2',zxgl_rssc_dis2)            //入睡时长统计
                  this.getMyChart_optionBar('ech_getUpOne','zxgl_qcsc_dis',zxgl_qcsc_dis)             //起床时长分布
                  this.getMyChart_optionBar('ech_getUpTwo','zxgl_qcsc_dis2',zxgl_qcsc_dis2)            //起床时长统计
                }
                
                

                // 夜间离床
                if(!res.data.leaveBedInfoV2.unSecretsDays){
                //   // 夜间离床_离床次数分布图
                //   let yjlc_lccs_dis = {
                //     name: '离床次数',
                //     xAxis: {
                //       data: this.allData.leaveBedInfo.secretsLeaveBedTimes.xaxis
                //     },
                //     series: {
                //       data: this.allData.leaveBedInfo.secretsLeaveBedTimes.data,
                //       range: this.allData.leaveBedInfo.secretsLeaveBedTimes.range
                //     },
                //   }
                //   // 夜间离床_离床次数统计图
                //   let yjlc_lccs_dis2 = {
                //     xAxis: {
                //       data: this.allData.leaveBedInfo.secretsLeaveBedTimesDay.xaxis
                //     },
                //     series: {
                //       data: this.allData.leaveBedInfo.secretsLeaveBedTimesDay.data,
                //       range: this.allData.leaveBedInfo.secretsLeaveBedTimesDay.range
                //     },
                //   }
                //   // 夜间离床_离床时长分布图
                //   if(this.allData.leaveBedInfo.secretsLeaveBedDuration){
                //     let yjlc_lcsc_dis = {
                //       name: '离床时长',
                //       xAxis: {
                //         data: this.allData.leaveBedInfo.secretsLeaveBedDuration.xaxis
                //       },
                //       series: {
                //         data: this.allData.leaveBedInfo.secretsLeaveBedDuration.data,
                //         range: this.allData.leaveBedInfo.secretsLeaveBedDuration.range
                //       },
                //     }
                //     this.getMyChart_optionBar('ech_outBedTimeOne','yjlc_lcsc_dis',yjlc_lcsc_dis)        //离床时长分布
                //   }
                  // 夜间离床_上床入睡醒来起床散点图secretsDailyRoutine 
                  if(this.allData.leaveBedInfoV2.secretsLeaveBedTimeDuration){

                    // let yjlcArr = this.allData.leaveBedInfo.secretsLeaveBedTimeDuration.data
                    // let sc_rs_xl_qcData = {
                    //   xAxis_data: this.function_get_all_mintues(),
                    //   yAxis_data: [],
                    //   series_data: [],
                    //   scatter_interval: [],
                    //   referenceList: this.allData.leaveBedInfo.secretsLeaveBedTimeDuration.referenceList || []
                    // }
                    // for(let i = 0;i < yjlcArr.length;i++){
                    //   sc_rs_xl_qcData.yAxis_data.push(yjlcArr[i].date)
                    //   if(yjlcArr[i].timeDuration){
                    //     for(let j = 0;j < yjlcArr[i].timeDuration.length;j++){
                    //       let aaa = [
                    //         yjlcArr[i].timeDuration[j].timeSt,
                    //         yjlcArr[i].date,
                    //         yjlcArr[i].timeDuration[j].duration
                    //       ]
                    //       sc_rs_xl_qcData.series_data.push(aaa)
                    //     }
                        
                    //   }
                    // }
                    // let yjlc_highFreTime = this.allData.leaveBedInfo.secretsLeaveBedTimeDuration.highFreTime;
                    // if(yjlc_highFreTime){
                    //   for(let i = 0;i < yjlc_highFreTime.length;i++){
                    //     let aaa = [
                    //       {'xAxis': yjlc_highFreTime[i].timeSt},
                    //       {'xAxis': yjlc_highFreTime[i].timeEd}
                    //     ]
                    //     sc_rs_xl_qcData.scatter_interval.push(aaa)
                    //   }
                    // }

                    // id为id_echSanDian_nightOutBed的dom滚动到底部
                    // let message_OutBed = document.getElementById('id_echSanDian_nightOutBed');
                    // message_OutBed.scrollTop = message_OutBed.scrollHeight;
                    // this.getMyChart_optionSca2('echSanDian_nightOutBed','sc_rs_xl_qcData',sc_rs_xl_qcData)   //夜间离床散点


                  }

                //   this.getMyChart_optionBar('ech_outBedNumOne','yjlc_lccs_dis',yjlc_lccs_dis)         //离床次数分布
                //   this.getMyChart_optionBar('ech_outBedNumTwo','yjlc_lccs_dis2',yjlc_lccs_dis2)        //离床次数统计

				  if (this.allData && this.allData.leaveBedInfoV2 && this.allData.leaveBedInfoV2.secretsLeaveBedInfo && this.allData.leaveBedInfoV2.secretsLeaveBedInfo.secretsLeaveBedAbnormal) {
					this.leaveLeftData = JSON.parse(JSON.stringify(this.allData.leaveBedInfoV2.secretsLeaveBedInfo.secretsLeaveBedAbnormal))
				  } else {
					this.leaveLeftData = null
				  }
				  if (this.allData && this.allData.leaveBedInfoV2 && this.allData.leaveBedInfoV2.secretsLeaveBedInfo && this.allData.leaveBedInfoV2.secretsLeaveBedInfo.secretsLeaveBedBaseline) {
					this.leaveWidth = 540;
					this.leaveSingleWidth = 18;
					this.leaveRightData = JSON.parse(JSON.stringify(this.allData.leaveBedInfoV2.secretsLeaveBedInfo.secretsLeaveBedBaseline))
				  } else {
					this.leaveWidth = 780;
					this.leaveSingleWidth = 26;
					this.leaveRightData = null
				  }

				// 初始化离床相关的图表
				this.initLeaveCharts();

				if (this.allData && this.allData.leaveBedInfoV2 && this.allData.leaveBedInfoV2.secretsLeaveBedInfo && this.allData.leaveBedInfoV2.secretsLeaveBedInfo.secretsLeaveBedBaseline) {
					this.leaveIsShowRightCharts = true;
				} else {
					this.leaveIsShowRightCharts = false;
				}


				// 最近30天每小时离床情况 - 图表
				if (this.leaveIsShowRightCharts == true) {
					this.setEchartLastThirtyDayLeaveBed();
				}

				// 每晚睡眠间离床情况 - 图表
				this.setEchartLeaveBed();

                }

                // 睡眠情况
                if(!res.data.sleepInfo.unSecretsDays){
                  // 睡眠情况_睡眠时长分布图
                  let smqk_smsc_dis = {
                    name: '睡眠时长',
                    xAxis: {
                      data: this.allData.sleepInfo.secretsSleepDuration.xaxis
                    },
                    series: {
                      data: this.allData.sleepInfo.secretsSleepDuration.data,
                      range: this.allData.sleepInfo.secretsSleepDuration.range
                    },
                  }
                  // 睡眠情况_睡眠时长统计图
                  let smqk_smsc_dis2 = {
                    xAxis: {
                      data: this.allData.sleepInfo.secretsSleepDurationDay.xaxis
                    },
                    series: {
                      data: this.allData.sleepInfo.secretsSleepDurationDay.data,
                      range: this.allData.sleepInfo.secretsSleepDurationDay.range
                    },
                  }
                  // 睡眠情况_睡眠效率分布图
                  let smqk_smxl_dis = {
                    name: '睡眠效率',
                    xAxis: {
                      data: this.allData.sleepInfo.secretsSleepEfficiency.xaxis
                    },
                    series: {
                      data: this.allData.sleepInfo.secretsSleepEfficiency.data,
                      range: this.allData.sleepInfo.secretsSleepEfficiency.range
                    },
                  }
                  // 睡眠情况_睡眠效率统计图
                  let smqk_smxl_dis2 = {
                    xAxis: {
                      data: this.allData.sleepInfo.secretsSleepEfficiencyDay.xaxis
                    },
                    series: {
                      data: this.allData.sleepInfo.secretsSleepEfficiencyDay.data,
                      range: this.allData.sleepInfo.secretsSleepEfficiencyDay.range
                    },
                  }
                  // 睡眠情况_睡眠破碎分布图
                  let smqk_smps_dis = {
                    name: '睡眠破碎',
                    xAxis: {
                      data: this.allData.sleepInfo.secretsSleepCrush.xaxis
                    },
                    series: {
                      data: this.allData.sleepInfo.secretsSleepCrush.data,
                      range: this.allData.sleepInfo.secretsSleepCrush.range
                    },
                  }
                  // 睡眠情况_睡眠破碎统计图
                  let smqk_smps_dis2 = {
                    xAxis: {
                      data: this.allData.sleepInfo.secretsSleepCrushDay.xaxis,
                    },
                    series: {
                      data: this.allData.sleepInfo.secretsSleepCrushDay.data,
                      range: this.allData.sleepInfo.secretsSleepCrushDay.range
                    },
                    // avg: res.data.median
                    avg: 10
                  };
                  this.getMyChart_optionBar('ech_sleepTimeOne','smqk_smsc_dis',smqk_smsc_dis)         //睡眠时长分布
                  this.getMyChart_optionBar('ech_sleepTimeTwo','smqk_smsc_dis2',smqk_smsc_dis2)        //睡眠时长统计
                  this.getMyChart_optionBar('ech_sleepEffOne','smqk_smxl_dis',smqk_smxl_dis)          //睡眠效率分布
                  this.getMyChart_optionBar('ech_sleepEffTwo','smqk_smxl_dis2',smqk_smxl_dis2)         //睡眠效率统计
                  this.getMyChart_optionBar('ech_sleepRrush','smqk_smps_dis',smqk_smps_dis)    //睡眠破碎分布
                  this.getMyChart_optionLine('ech_sleepRrush_line','smqk_smps_dis2',smqk_smps_dis2)    //睡眠破碎统计
                }
              })

              this.$forceUpdate()
              this.$nextTick((res2) => {
                this.hxqk_isExpand = false
                this.tdqk_isExpand = false
                this.xtqk_isExpand = false
                this.zxgl_isExpand = false
                this.yjlc_isExpand = false
                this.smqk_isExpand = false
                // setTimeout(() => {
                  this.isDomOver = true
                // }, 100);
                
              })
            } 
          } else {
            this.$message.error(res.msg);
          }
          if (loading && loading.close) {
            loading.close();
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
          if (loading && loading.close) {
            loading.close();
          }
        }
      );
    },




    // 公共柱状图
    getMyChart_optionBar(idName, type, olddata) {
      let data = olddata
      // type  
      // 呼吸率分布hxl_dis  吸呼比分布xhb_dis  
      // 体动指数分布td_dis  
      // 心跳分布heart_dis  
      // 入睡时长分布zxgl_rssc_dis  入睡时长统计zxgl_rssc_dis2
      // 起床时长分布zxgl_qcsc_dis  起床时长统计zxgl_qcsc_dis2
      // 离床次数分布yjlc_lccs_dis  离床次数统计yjlc_lccs_dis2
      // 离床时长分布yjlc_lcsc_dis
      // 睡眠时长分布smqk_smsc_dis  睡眠时长统计smqk_smsc_dis2
      // 睡眠效率分布smqk_smxl_dis  睡眠效率统计smqk_smxl_dis2
      // 睡眠破碎分布smqk_smps_dis

	  		// 判断Y轴单位是否为小时
		let isYJudgeHours = false;
		let maxValue = 0;
		if (type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2') {
			if (data && data.series && data.series.data) {
				for (let i = 0; i < data.series.data.length; i++) {
					let item = data.series.data[i];
					if (item != '-') {
						if (parseInt(item) >= 60) {
							isYJudgeHours = true;
						}
						maxValue = item;
					}
				}
			}
		}

      // type  离床次数lccs  lccs2
      this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
      console.log(idName, type, data)


      // 判断是哪些类型的
      let allType;        //蓝色紫色区域范围都有的1   纯蓝色的2
      if(type == 'hxl_dis' || type == 'xhb_dis' || type == 'td_dis' || type == 'heart_dis' || type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lccs_dis' || type == 'yjlc_lcsc_dis' || type == 'smqk_smsc_dis' || type == 'smqk_smxl_dis' || type == 'smqk_smps_dis'){
        allType = 1
      }else {
        allType = 2
      }
      let x1,x2;

      let xAxis_axisLabel_interval = 0;     //x轴最小间隔
      // 蓝色紫色区域范围都有的1
      if(allType == 1){
        // 百分比处理
        for(let i = 0;i < data.series.data.length;i++){
          data.series.data[i] = Math.round(data.series.data[i] * 100)
        }
        
        // 柱状图bar颜色处理
        if(data.series.range){
          for(let i = 0;i < data.xAxis.data.length;i++){
            // 在范围内
            if(Number(data.xAxis.data[i]) >= Number(data.series.range[0]) && Number(data.xAxis.data[i]) <= Number(data.series.range[1])){
              data.series.data[i] = {
                value: data.series.data[i],
                itemStyle: {color: '#1890FF'}
              }
            }else {
              data.series.data[i] = {
                value: data.series.data[i],
                itemStyle: {color: '#B17DFF'}
              }
            }
          }
        }
        
        // 区间范围计算
        let singleBarAreaWidth = 750 / data.xAxis.data.length;
        let xAxis_data = data.xAxis.data;
        let markArea_range = data.series.range
        if (xAxis_data.indexOf(markArea_range[0]) != -1) {
          x1 = xAxis_data.indexOf(markArea_range[0]) * singleBarAreaWidth + 30;
        }
        if (xAxis_data.indexOf(markArea_range[1]) != -1) {
          x2 = xAxis_data.indexOf(markArea_range[1]) * singleBarAreaWidth + singleBarAreaWidth + 30;
        }
      }else if(allType == 2){
        x1 = 300
        x1 = 500
      }

      if(type == 'smqk_smsc_dis' || type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2' || type == 'yjlc_lccs_dis2' || type == 'smqk_smsc_dis2' || type == 'smqk_smxl_dis2'){
        xAxis_axisLabel_interval = 2
      }


      // 需要分钟转换小时分钟的
      let timeFonts = []
      if(type == 'zxgl_rssc_dis'){      //入睡时长分布
        for(let i = 0;i < data.series.data.length;i++){
          if(data.series.data[i].value){
            timeFonts.push(this.formaTime(data.series.data[i].value))
          }else{
            timeFonts.push('-')
          }
          
        }
      }




      let maxNum = Math.max(...data.series.data)
      // let yAxis_max = Math.round(maxNum / 10) * 10 + 10
      let yAxis_minInterval = 10
      let yAxis_max = null;
      if(type == 'smqk_smsc_dis2'){
        yAxis_max = 720
        yAxis_minInterval = 240
      }
      var optionBar = {
        tooltip: {
          // show: false,
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderColor: '#ABD7FF',
          borderWidth: 1,
          spanStyle: {
            color: '#fff',
          },
          confine: true,
          borderRadius: 5,
          formatter: function(params) {
            console.log(type);
            console.log(params);

            // 判断除了下面这些类型，剩余类型中params[0].data.value是否为undefined，如果是undefined，不显示浮窗（算法数据多给了一条导致）
            if(!(type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2' || type == 'smqk_smsc_dis2' || type == 'yjlc_lccs_dis2' || type == 'smqk_smxl_dis2')){
              if(typeof params[0].data.value == 'undefined'){
                return;
              }
            }
            if(type == 'xhb_dis' || type == 'td_dis' || type == 'smqk_smps_dis'){      //吸呼比分布  体动指数分布  破碎指标分布
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '</span>'
              );
            } else if(type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lcsc_dis'){   //入睡时长分布  起床时长分布  离床时长分布
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '分钟</span>'
              );
            } else if(type == 'yjlc_lccs_dis'){      //离床次数分布 
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '次</span>'
              );
            } else if(type == 'hxl_dis' || type == 'heart_dis') {            //呼吸率分布  心率分布
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '次/分</span>'
              );
            } else if(type == 'smqk_smxl_dis') {            //睡眠效率分布
              return (
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data.value + 
                `%${data.name}集中`+
                '<br/>' +
                '<span style="margin-left:10px;"> 在' + params[0].axisValue + '%</span>'
              );
            } else if(type == 'smqk_smsc_dis') {            //睡眠时长分布
              let hourMin = params[0].axisValue;
              if(hourMin < 60){
                return (
                  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                  params[0].data.value + 
                  `%${data.name}集中`+
                  '<br/>' +
                  '<span style="margin-left:10px;"> 在' + hourMin + '分钟</span>'
                );
              }else {
                let nowTips = ''
                if(hourMin % 60 == 0){
                  nowTips += Math.floor(Number(hourMin) / 60) + '小时'
                }else {
                  nowTips += Math.floor(Number(hourMin) / 60) + '小时' + (hourMin % 60) + '分钟'
                }
                return (
                  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                  params[0].data.value + 
                  `%${data.name}集中`+
                  '<br/>' +
                  '<span style="margin-left:10px;"> 在' + nowTips +'</span>'
                );
              }
            } else if(type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2' || type == 'smqk_smsc_dis2'){          //入睡时长统计  起床时长统计  睡眠时长统计
              let hourMin = params[0].data;
              if (hourMin == '-') {
                console.log('不存在params[0].data.value');
                // return params[0].name + '<br/>' + '入睡时长' + '-' + '分钟';
                return params[0].name + '<br/>' + '' + '-' + '分钟';
              } else {
                console.log('存在params[0].data.value');
                if (hourMin < 60) {
                  return (
                    params[0].name +
                    '<br/>' +
                    `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                    (params[0].data.isEmpty ? '-' : hourMin) +
                    '分钟'
                  );
                } else {
                  let nowTips = ''
                  if(hourMin % 60 == 0){
                    nowTips += Math.floor(Number(hourMin) / 60) + '小时'
                  }else {
                    nowTips += Math.floor(Number(hourMin) / 60) + '小时' + (hourMin % 60) + '分钟'
                  }
                  return (
                    params[0].name +
                    '<br/>' +
                    `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                    nowTips
                  );
                }
              }
            } else if(type == 'yjlc_lccs_dis2'){      //离床次数统计
              return (
                params[0].name +
                '<br/>' +
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data +
                '次'
              );
            } else if(type == 'smqk_smxl_dis2'){      //睡眠效率统计
              return (
                params[0].name +
                '<br/>' +
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data +
                '%'
              );
            } else {
              return (
                params[0].name + 
                '<br/>' +
                `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
                params[0].data + '分钟'
              );
            }
          },
        },
        grid: {
          left: '0%',
          right: '0.5%',
          top: '10%',
          bottom: '1%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis.data,
            axisLabel: {
              // interval: xAxis_axisLabel_interval,
              // spanStyle: {
              //   color: '', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:'',
              },
              formatter(value,index) {
                if(type == 'smqk_smsc_dis'){     //睡眠时长分布
                  let surplus = value % 60;
                  if (surplus == 0) {
                    return value / 60;
                  }
                  return '';
                } else {
                  return value
                }
              }

            },
            axisLine: {
              lineStyle: {
                color: '#9094A6',
              },
            },
            
            axisTick: {
              show: false,
              // alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            max: yAxis_max,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'solid',
                color: '#E4E6EC'
              }
            },
            minInterval: yAxis_minInterval, //设置最小间隔为1，防止出现小数
			min: maxValue == 0 ? 5 : undefined,
            axisLabel: {
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:''
              },
              formatter: function (value, index) {
                if(type == 'hxl_dis' || type == 'xhb_dis' || type == 'td_dis' || type == 'heart_dis' || type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lccs_dis' || type == 'yjlc_lcsc_dis' || type == 'smqk_smsc_dis' || type == 'smqk_smxl_dis' || type == 'smqk_smps_dis' || type == 'smqk_smxl_dis2'){
                  return value + '%';
                }else if(type == 'yjlc_lccs_dis2'){     //离床次数统计
                  return value + '次';
                }else {
					if (type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2') {
						if (isYJudgeHours) {
							if (value % 60 == 0) {
								return (value / 60) + 'h'
							}
						} else {
							if (value % 1 == 0) {
								return value + '分';
							}
						}
					} else {
						let val = Math.floor(Number(value) / 60) + 'h'
						return val
					}
                }
               
              }
            },
            axisLine: {
              lineStyle: {
                color: '#c7c6c9',
              },
              show: false,
            },
            splitNumber: 3,
			minInterval: (type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2') ? (isYJudgeHours ? 60 : undefined) : undefined
          },
        ],
        series: [
          {
            data: data.series.data,
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              normal: {
                //柱形图圆角，初始化效果
                barBorderRadius: [4, 4, 0, 0],
                color: '#1890FF'
              },
            },
            markArea: type == 'hxl_dis' || type == 'xhb_dis' || type == 'td_dis' || type == 'heart_dis' || type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lccs_dis' || type == 'yjlc_lcsc_dis' || type == 'smqk_smsc_dis' || type == 'smqk_smxl_dis' || type == 'smqk_smps_dis' ?{
              silent:true,
              data: [
                [
                  { x: x1, },
                  { x: x2, },
                ],
              ],
              itemStyle: {
                borderType: 'dashed',
                borderColor: '#1890FF',
                borderWidth: 1,
                color: 'rgba(24,144,255,0.05)',
              }
            } : {
              silent:true,
              data: [
                [
                  { yAxis: data.series.range[0], },
                  { yAxis: data.series.range[1], },
                ],
              ],
              itemStyle: {
                borderType: 'dashed',
                borderColor: '#1890FF',
                borderWidth: 1,
                color: 'rgba(24,144,255,0.05)',
              }
            },
          }
          
        ]
      }
      this.myChart_Bar.setOption(optionBar,true);
      window.addEventListener('resize', () => {
        this.myChart_Bar.resize();
      });
      this.$forceUpdate()
    },
	// 公共柱状图
    getMyChart_optionMyFloat(idName, type, olddata) {
      let item = JSON.parse(JSON.stringify(this.allData.breathInfoV2.secretsBreath));
	  if (!this.myChart_Bar) {
		this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
	  }
      
	let needDataMin = [];
	let needDataMedian = [];
	let needDataMax = [];
	let tempArr = JSON.parse(JSON.stringify(item.data || []));
	for (let i = 0; i < tempArr.length; i++) {
		let item = tempArr[i];
		needDataMin.push(item.min);
		needDataMedian.push(parseInt(item.median));
		needDataMax.push(item.max - item.min);
	}
	let xAxis_data = item.xaxis || [];
	let series_data = [
		{ data: needDataMin },
		{ data: needDataMax },
		{ data: needDataMedian },
	];
	let expansion_data = item.xaxisCn || [];
	let markArea_range = item.range || [];
	if (markArea_range.length != 2) {
		markArea_range = [];
	}
	let colorArr = null;
	let option = getEchartsOptionFloatA2(xAxis_data, series_data, expansion_data, markArea_range, 0, colorArr)

	  this.myChart_Bar.setOption(option,true);
      window.addEventListener('resize', () => {
        this.myChart_Bar.resize();
      });
      this.$forceUpdate()
    },
    // 公共折线图
    getMyChart_optionLine(idName, type, olddata, isMax) {
      let data = olddata
      // 体动指数统计_折线td_crush_line  睡眠破碎统计smqk_smps_dis2
      this.myChart_Line = this.$echarts.init(document.getElementById(idName));
      console.log(idName, type, data)

      let maxNum = Math.max(...data.series.data)
      let yAxis_max = Math.round(maxNum / 10) * 10 + 10
      

      let grid_left = '0.5%'
      let grid_bottom = '1%'

      if(type == 'td_crush_line'){             //体动指数统计_折线
        yAxis_max = null
        grid_left = '1%'
      } else if(type == 'smqk_smps_dis2'){    //睡眠破碎统计
        yAxis_max = null
      } 
      var optionLine = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderColor: '#ABD7FF',
          borderWidth: 1,
          spanStyle: {
            color: '#fff',
          },
          confine: true,
          borderRadius: 5,
          formatter: function(params) {
            console.log(type);
            console.log(params);
            // if (type == 'bjbl') {      //报警比例
              return (
                // params[0].name +
                // '<br/>' +
                // '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                // params[0].data + '%'


                params[0].name +
                '<br/>' +
                '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                params[0].data 
              );
            // } 
          },
        },
        grid: {
          left: grid_left,
          // left: '0%',
          right: '0.5%',
          top: '15%',
          bottom: grid_bottom,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis.data,
            axisLabel: {
              // interval: 10,
              // spanStyle: {
              //   color: '', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:'',
              },
              show: type == 'bjbl' ? false : true
            },
            axisLine: {
              lineStyle: {
                color: '#9094A6',
              },
            },
            
            axisTick: {
              show: false,
              // alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            max: yAxis_max,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#CACDD9'
              }
            },
            // minInterval: 1100, //设置最小间隔为1，防止出现小数
            minInterval: 1, //设置最小间隔为1，防止出现小数
            axisLabel: {
              // spanStyle: {
              //   color: '#5E6779', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:''
              }
            },
            axisLine: {
              lineStyle: {
                color: '#c7c6c9',
              },
              show: false,
            },
            splitNumber: 1,
			max: isMax ? 100 : undefined,
			min: isMax ? 0 : undefined
          },
        ],
        series: [
          {
            data: data.series.data,
            type: 'line',
            barWidth: 20,
            // symbol: 'none',
            lineStyle:{           //线条颜色
              color:'#1890FF'
            },
            // smooth: true,         //平滑处理
            symbol: 'circle',
            showSymbol: type == 'bjbl' ? false : true,
            symbolSize: 8,
            color: '#1890FF',
            areaStyle: type == 'seven_bjbl' || type == 'bbbb' ? {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(24, 144, 255, 0.4)', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(24, 144, 255, 0.05)', // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            } : null,
            markLine: type == 'bbbb' ? {
              symbol: 'none',
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
              data: [
                {
                  silent: false, //鼠标悬停事件  true没有，false有
                  lineStyle: {
                    //警戒线的样式  ，虚实  颜色
                    type: 'dashed',
                    color: '#63B2FB',
                  },
                  label: {
                    position: 'end',
                    formatter: '',
                  },
                  yAxis: data.avg, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
              ],
            } : null,
            markArea: {
              silent:true,
              data: [
                [
                  {
                    name: '',
                    yAxis: data.series.range[0],
                    // yAxis: 10,
                    itemStyle: {
                      color: 'rgba(24,144,255,0.05)',
                    },
                  },
                  {
                    yAxis: data.series.range[1],
                    // yAxis: 40,
                  },
                ],
              ],
			  itemStyle: {
                borderType: 'dashed',
                borderColor: '#1890FF',
                borderWidth: 1,
                color: 'rgba(24,144,255,0.05)',
              }
            } 
          }
          
        ]
      }
      this.myChart_Line.setOption(optionLine,true);
      window.addEventListener('resize', () => {
        this.myChart_Line.resize();
      });
      this.$forceUpdate()
    },

    // 公共散点图_作息规律上床入睡醒来起床
    getMyChart_optionSca(idName, type, olddata){
      let data = olddata
      console.log(idName, type, olddata)
      this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
      let xAxis_data = data.xAxis_data
      let yAxis_data = data.yAxis_data
      let series_data0 = data.series_data0
      let series_data1 = data.series_data1
      let series_data2 = data.series_data2
      let series_data3 = data.series_data3
      let scatter_interval1 = data.scatter_interval1
      let scatter_interval2 = data.scatter_interval2
      let scatter_interval3 = data.scatter_interval3
      let scatter_interval4 = data.scatter_interval4


      let optionBar = {
        tooltip: {
          type: 'none',
          axisPointer: { // 十字
            type: 'cross',
            snap: false,
            animation: true,
            label: {
              color: '#FFFFFF',
              backgroundColor: '#5F64E7',
              opacity: 1
            },
            crossStyle: {
              color: '#BCB6E8',
              width: 1
            }
          },
          backgroundColor: "#FFFFFF",
          borderColor: "#ABD7FF",
          borderWidth: 1,
          borderRadius: 5,
          textStyle: {
            color: "#262626",
          },
          confine: true,
          formatter: function (val) {
            return val.seriesName + '<br/>' + val.marker + val.value[1] + '为' + val.value[0].toString();
          }
        },
        xAxis: [
          {
            position: 'top',
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            data: xAxis_data,
          }
        ],
        yAxis: [
          {
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#A5A9BC',
            },
            axisTick: {
              show: false
            },
            inverse: true, // 反转
            data: yAxis_data,
            splitArea: {
              show: true,
              interval: 'auto',
              areaStyle: {
              }
            }
          }
        ],
        grid: {
          x: 12,
          y: -1,
          x2: 12,
          y2: 1,
          containLabel: true
        },
        series: [
          {
            name: '上床时间',
            data: series_data0,
            type: 'scatter',
            symbol: 'circle',
            symbolSize: [6 , 6],
            itemStyle: {
              normal: {
                color: '#FF7186'
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: 'red'
            },
            markArea: {
              itemStyle: {
                color: '#FF718630'
              },
              data: scatter_interval1
            }
          },
          {
            name: '入睡时间',
            data: series_data1,
            type: 'scatter',
            symbol: 'circle',
            symbolSize: [6 , 6],
            itemStyle: {
              normal: {
                color: '#FFB971'
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: 'red'
            },
            markArea: {
              itemStyle: {
                color: '#FAAB6230'
              },
              data: scatter_interval2
            }
          },
          {
            name: '醒来时间',
            data: series_data2,
            type: 'scatter',
            symbol: 'circle',
            symbolSize: [6 , 6],
            itemStyle: {
              normal: {
                color: '#44D7B6'
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: '#FF7186'
            },
            markArea: {
              itemStyle: {
                color: '#44D7B630'
              },
              data: scatter_interval3
            }
          },
          {
            name: '起床时间',
            data: series_data3,
            type: 'scatter',
            symbol: 'circle',
            symbolSize: [6 , 6],
            itemStyle: {
              normal: {
                color: '#1890FF'
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: 'red'
            },
            markArea: {
              itemStyle: {
                color: '#1890FF30'
              },
              data: scatter_interval4
            }
          }
        ],
        // dataZoom: [
        //   {
        //     type: 'inside',
        //     orient: 'vertical',
        //     start: 100,
        //     maxValueSpan: 6,
        //     minValueSpan: 6,
        //     zoomLock: true,
        //   }
        // ]
      };
      this.myChart_Bar.setOption(optionBar,true);
      window.addEventListener('resize', () => {
        this.myChart_Bar.resize();
      });
      this.$forceUpdate()
    },
    // 公共散点图_夜间离床
    getMyChart_optionSca2(idName, type, olddata){
      let data = olddata
      console.log('散点夜间离床')
      console.log(idName, type, olddata)
      this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
      let xAxis_data = data.xAxis_data
      let yAxis_data = data.yAxis_data
      let series_data = data.series_data
      let scatter_interval = data.scatter_interval
      let referenceList = data.referenceList


      let optionBar = {
        tooltip: {
          type: 'none',
          axisPointer: { // 十字
            type: 'cross',
            snap: false,
            animation: true,
            label: {
              color: '#FFFFFF',
              backgroundColor: '#5F64E7',
              opacity: 1
            },
            crossStyle: {
              color: '#BCB6E8',
              width: 1
            }
          },
          backgroundColor: "#FFFFFF",
          borderColor: "#ABD7FF",
          borderWidth: 1,
          borderRadius: 5,
          textStyle: {
            color: "#262626",
          },
          confine: true,
          formatter: function (val) {
            console.log(val)
            let value = val.value;
				    return value[1] + ' ' + value[0] + '<br/>' + val.marker + '离床' + value[2] + '分钟';
          }
        },
        xAxis: [
          {
            position: 'top',
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            data: xAxis_data,
          }
        ],
        yAxis: [
          {
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#A5A9BC',
            },
            axisTick: {
              show: false
            },
            inverse: true, // 反转
            data: yAxis_data,
            splitArea: {
              show: true,
              interval: 'auto',
              areaStyle: {
              }
            }
          }
        ],
        grid: {
          x: 12,
          y: -1,
          x2: 12,
          y2: 1,
          containLabel: true
        },
        series: [
          {
            name: '离床时长',
            data: series_data,
            type: 'scatter',
            symbol: function (val) {
              if (val[2] <= 5) {
                return 'rect';
              }
              return 'rect';
            },
            symbolSize: function (val) {
              // let allMinutes = 13 * 60.0;
              // let screenWidth = formatterVariable.screenWidth;
              // let singleWidth = screenWidth / allMinutes;
              let singleWidth = 711/720
              if (val[2] <= 5) {
                return [5, 5];
              }
              return [6 + (val[2] * singleWidth) , 6];
            },
            symbolOffset: ['50%', 0],
            itemStyle: {
              normal: {
                color: function (val) {
                  // let referenceList = formatterVariable.referenceList || [];
                  let colors = [
                    'rgba(78, 66, 199, 1)',
                    'rgba(76, 96, 196, 1)',
                    'rgba(74, 125, 193, 1)',
                    'rgba(72, 155, 189, 1)',
                    'rgba(70, 184, 185, 1)',
                    'rgba(68, 214, 182, 1)',
                    'rgba(103, 209, 169, 1)',
                    'rgba(140, 204, 156, 1)',
                    'rgba(177, 198, 142, 1)',
                    'rgba(213, 192, 128, 1)',
                    'rgba(250, 186, 115, 1)'
                  ];
                  for (let i = 0; i < referenceList.length; i++) {
                    let item = referenceList[i];
                    if (i == referenceList.length - 1) {
                      return colors[10];
                    } else {
                      if (val.value[2] >= Number(item) && val.value[2] < referenceList[i + 1]) {
                        return colors[i];
                      }
                    }
                  }
                  return colors[16];
                }
              },
            },
            showBackground: true,
            markArea: {
              itemStyle: {
                color: '#4E3EC810'
              },
              data: scatter_interval
            }
          }
        ],
        // dataZoom: [
        //   {
        //     type: 'inside',
        //     orient: 'vertical',
        //     start: 100,
        //     maxValueSpan: 6,
        //     minValueSpan: 6,
        //     zoomLock: true,
        //   }
        // ]
      };
      this.myChart_Bar.setOption(optionBar,true);
      window.addEventListener('resize', () => {
        this.myChart_Bar.resize();
      });
      this.$forceUpdate()
    },
    // 时间方法 720个点
    function_get_all_mintues() {
      let hours_data = [19, 20, 21, 22, 23, 0, 1, 2, 3, 4, 5, 6, 7, 8];
      let times = [];
      let minutes = [];
      for (let i = 0; i < hours_data.length; i++) {
        let needTime;
        let item = hours_data[i];
        for (let j = 0; j <= 59; j++) {
          if (item == 19) {
            if (j >= 30) {
              let tempHours = item > 9 ? item : '0' + item;
              let tempMinutes = j > 9 ? j : '0' + j;
              needTime = tempHours + ':' + tempMinutes;
              times.push(needTime);
              minutes.push(item * 60 + j);
            }
          } else if (item == 8) {
            if (j <= 30) {
              let tempHours = item > 9 ? item : '0' + item;
              let tempMinutes = j > 9 ? j : '0' + j;
              needTime = tempHours + ':' + tempMinutes;
              times.push(needTime);
              minutes.push(item * 60 + j);
            }
          } else {
            let tempHours = item > 9 ? item : '0' + item;
            let tempMinutes = j > 9 ? j : '0' + j;
            needTime = tempHours + ':' + tempMinutes;
            times.push(needTime);
            minutes.push(item * 60 + j);
          }
        }
      }
      return times;
    },
    formaTime(minutes) {
      return Math.floor(minutes / 60) + '小时' + (minutes % 60) + '分钟';
    },


    
  },
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';

.needChangeWrap{
  width: 852px;
  height: 54px;
  background: #FFFFFF;
  border-radius: 2px;
  backdrop-filter: blur(8px);
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 10px;
  position: relative;
  display: flex;
  align-items: center;
  .needChangeTip{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1F2635;
  }
}
.needChangeWrap::after{
  width: 4px;
  height: 20px;
  background: #FF7186;
  border-radius: 0px 2px 2px 0px;

  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
// 发现几项值得关注的变化
.gzVaryWrap{
  width: 850px;
  height: 54px;
  background: #FCEBEE;
  border-radius: 4px;
  border: 1px solid #FFB8C3;
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto 0;
  .gBellImg{
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
  .name{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5E6779;
  }
}
// .tan_needGz_portraitWrap{
//   width:auto;
//   height: auto;
//   position:relative;
//   left: -24px;
//   // top: -24px;
//   top: -79px;
//   background: none;
//   z-index: 999;
//   .needGZ_One_Tan{
//     position: static;
//     max-height: none;
//     left: 0;
//     top: 0;
//     transform: none;
//   }
// }

.needGZ_TanWrap{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0,0,0,0.5);
  z-index: 999;
  .needGZ_Tan{
    width: 900px;
    height: auto;
    background: #FFFFFF;
    border-radius: 4px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    padding-bottom: 30px;

    min-height: 600px;
    max-height: 800px;
    overflow: auto;
  }
}

.tan_needGz_portraitWrap ::v-deep {
  .hx_overview1{
   	  width: 850px;
	  min-height: 80px;
	  height: auto;
	  z-index: 999;
	  padding-left: 225px;
	  padding-right: 15px;
	  padding-top: 10px;
	  box-sizing: border-box;
	  margin-top: 100px;
	  background: url("../../../assets/icon_work_proposal_icon_15.png") no-repeat !important;
  	  background-size: 850px 100% !important;
    .bot_adv_tag{
      padding: 1px 10px 1px 5px;
      background: #FFE0E4;
      border-radius: 19px;
      border: 1px solid #FFB8C3;
      backdrop-filter: blur(8px);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5E6779;

      display: inline-block;

      .tanhaoIcon{
        width: 14px;
        height: 14px;
        // margin-right: 3px;
        margin-top: -3px;
      }
    }
  }
  .bot_adv_tag2{
    font-size: 14px;
    padding: 2px 10px;
    background: #E0F0FF;
    border-radius: 19px;
    border: 1px solid #B7DCFE;
    backdrop-filter: blur(8px);
    display: inline-block;
  }
  .refer_comTit2{
    width: 780px;
    height: 52px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1F2635;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid rgba(255,113,134,0.5);
    padding: 0 15px;
    box-sizing: border-box;
    // display: flex;
    align-items: center;
    .reIcon{
      width: 15px;
      height: 15px;
      margin-top: -2px;
      // margin-right: 5px;
    }
  }
  .zxWrap{
    height: 30px;
    position: relative;
    .zxLine{
      width: 750px;
      height: 2px;
      background: #FFD4DA;
      border-radius: 3px;
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      .zxCirWrap{
        flex:1;
        display: flex;
        justify-content: center;
        .zxCir{
          width: 12px;
          height: 12px;
          border-radius: 50%;
          cursor: pointer;
          position: relative;
          .red_cir_noSel{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
          .red_cir_Sel{
            display: none;
          }
          .zxCirFloWin{
            // width: 93px;
            height: auto;
            background: rgba(255,255,255,0.8);
            border: 1px solid #FFDDE2;
            backdrop-filter: blur(2px);
            padding: 15px;
            position: absolute;
            top: -80px;
            left: 50%;
            transform: translateX(-50%);
            display: none;
            .ai_image_change_triangle_d{
              width: 10px;
              height: 8px;
              position: absolute;
              bottom: -6px;
              left: 50%;
              transform: translateX(-50%);
            }
            .time{
              // width: auto;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #262626;
              white-space: nowrap;
            }
            .tCir{
              width: 8px;
              height: 8px;
              background: #FF7186;
              border-radius: 50%;
              margin-right: 3px;
            }
          }
        }
        .zxCir:hover .red_cir_Sel{
          display: block;
        }
        .zxCir:hover .zxCirFloWin{
          display: block;
        }
      }
    }
  }
}

.richTextDiv ::v-deep {
	.richContentStyle {
		display: block;
		white-space: nowrap;
		height: 20px;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.richTextStyleNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
		white-space: nowrap;
		display: inline;
	}
	.richTextStyleRed {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 20px;
		white-space: nowrap;
		display: inline;
	}

	.richContentStyleTip {
		display: block;
		white-space: wrap;
		// max-width: 100px;
		overflow-wrap: break-word;
	}
	.richTextStyleTipNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
		// white-space: nowrap;
		display: inline;
	}
	.richTextStyleTipRed {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 20px;
		// white-space: nowrap;
		display: inline;
	}
}


</style>
